(window.wwhatsappJs = window.wwhatsappJs || {}),
  (wwhatsappJs.WhatsApp = (function () {
    var lpoha =
      ".pwapp-animated{-webkit-animation-duration:4s;animation-duration:4s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-delay:1s;animation-delay:1s}.pwapp-animated.pwapp-infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.pwapp-animated.pwapp-onlyonce {-webkit-animation-iteration-count: 1;animation-iteration-count: 1;}.pwapp-animated.pwapp-onlytwo {-webkit-animation-iteration-count: 2;animation-iteration-count: 2;}.pwapp-animated.pwapp-onlythree {-webkit-animation-iteration-count: 3;animation-iteration-count: 3;}.pwapp-animated.pwapp-onlyfour {-webkit-animation-iteration-count: 4;animation-iteration-count: 4;}.pwapp-animated.pwapp-onlyfive {-webkit-animation-iteration-count: 5;animation-iteration-count: 5;}.pwapp-animated.pwapp-onlysix {  -webkit-animation-iteration-count: 6; animation-iteration-count: 6;}	  .pwapp-animated2{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-delay:1s;animation-delay:1s}.pwapp-animated2.pwapp-infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.pwapp-animated2.pwapp-onlyonce {-webkit-animation-iteration-count: 1;animation-iteration-count: 1;}.pwapp-animated2.pwapp-onlytwo {-webkit-animation-iteration-count: 2;animation-iteration-count: 2;}.pwapp-animated2.pwapp-onlythree {-webkit-animation-iteration-count: 3;animation-iteration-count: 3;}.pwapp-animated2.pwapp-onlyfour {-webkit-animation-iteration-count: 4;animation-iteration-count: 4;}.pwapp-animated2.pwapp-onlyfive {-webkit-animation-iteration-count: 5;animation-iteration-count: 5;}.pwapp-animated2.pwapp-onlysix {  -webkit-animation-iteration-count: 6; animation-iteration-count: 6;} @-webkit-keyframes pwapp-emitting{13%{box-shadow:0 0 5px 5px rgba(0,0,0,.8)}100%,25%{box-shadow:0 0 0 0 rgba(0,0,0,.8)}}@keyframes pwapp-emitting{13%{box-shadow:0 0 5px 5px rgba(0,0,0,.8)}100%,25%{box-shadow:0 0 0 0 rgba(0,0,0,.8)}}.pwapp-emitting{-webkit-animation-name:pwapp-emitting;animation-name:pwapp-emitting;-webkit-transform-origin:center bottom;transform-origin:center bottom}@-webkit-keyframes pwapp-glow { 20%,  24%,  55% {color: #111;text-shadow: none;}0%,19%,21%,23%,25%, 54%,56%,100% {text-shadow: 0 0 5px #ffa500, 0 0 15px #ffa500, 0 0 20px #ffa500, 0 0 40px #ffa500, 0 0 60px #ff0000, 0 0 10px #ff8d00, 0 0 98px #ff0000;color: #fff6a9;}}@keyframes pwapp-glow { 20%,24%,55% {color: #111;text-shadow: none;}0%,19%,21%,23%,25%,54%,56%,100%{text-shadow: 0 0 5px #ffa500, 0 0 15px #ffa500, 0 0 20px #ffa500, 0 0 40px #ffa500, 0 0 60px #ff0000, 0 0 10px #ff8d00, 0 0 98px #ff0000;color: #fff6a9;}}.pwapp-glow{-webkit-animation-name:pwapp-glow;animation-name:pwapp-glow;animation: pwapp-glow 12s infinite; -webkit-animation: pwapp-glow 12s infinite;}@-webkit-keyframes pwapp-zooml{0% {transform: scale(0);}14% {transform: scale(1.15);}28% {transform: scale(.8);}42% {transform: scale(1.15);}70% {transform: scale(1);}100% {transform: scale(1);}}@keyframes pwapp-zooml{0% {transform: scale(0);}14% {transform: scale(1.15);}28% {transform: scale(.8);}42% {transform: scale(1.15);}70% {transform: scale(1);}100% {transform: scale(1);}}.pwapp-zooml{-webkit-animation-name:pwapp-zooml;animation-name:pwapp-zooml;-webkit-transform-origin:center bottom;transform-origin:center bottom}	@-webkit-keyframes pwapp-bounce{13%,20%,25%,5%,from,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355repla,1);-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}10%,12%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}17%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}23%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}@keyframes pwapp-bounce{13%,20%,25%,5%,from,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}10%,12%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}17%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}23%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}.pwapp-bounce{-webkit-animation-name:pwapp-bounce;animation-name:pwapp-bounce;-webkit-transform-origin:center bottom;transform-origin:center bottom}@-webkit-keyframes pwapp-flash{12%,6%,from,to{opacity:1}3%,9%{opacity:0}}@keyframes pwapp-flash{12%,6%,from,to{opacity:1}3%,9%{opacity:0}}.pwapp-flash{-webkit-animation-name:pwapp-flash;animation-name:pwapp-flash}@-webkit-keyframes pwapp-rubberBand{25%,from,to{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1)}7%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}10%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}12%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}16%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}18%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}}@keyframes pwapp-rubberBand{25%,from,to{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1)}7%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}10%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}12%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}16%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}18%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}}.pwapp-rubberBand{-webkit-animation-name:pwapp-rubberBand;animation-name:pwapp-rubberBand}@-webkit-keyframes pwapp-swing{5%{-webkit-transform:rotate3d(0,0,1,15deg);transform:rotate3d(0,0,1,15deg)}10%{-webkit-transform:rotate3d(0,0,1,-10deg);transform:rotate3d(0,0,1,-10deg)}15%{-webkit-transform:rotate3d(0,0,1,5deg);transform:rotate3d(0,0,1,5deg)}20%{-webkit-transform:rotate3d(0,0,1,-5deg);transform:rotate3d(0,0,1,-5deg)}25%,to{-webkit-transform:rotate3d(0,0,1,0deg);transform:rotate3d(0,0,1,0deg)}}@keyframes pwapp-swing{5%{-webkit-transform:rotate3d(0,0,1,15deg);transform:rotate3d(0,0,1,15deg)}10%{-webkit-transform:rotate3d(0,0,1,-10deg);transform:rotate3d(0,0,1,-10deg)}15%{-webkit-transform:rotate3d(0,0,1,5deg);transform:rotate3d(0,0,1,5deg)}20%{-webkit-transform:rotate3d(0,0,1,-5deg);transform:rotate3d(0,0,1,-5deg)}25%,to{-webkit-transform:rotate3d(0,0,1,0deg);transform:rotate3d(0,0,1,0deg)}}.pwapp-swing{-webkit-transform-origin:top center;transform-origin:top center;-webkit-animation-name:pwapp-swing;animation-name:pwapp-swing}@-webkit-keyframes pwapp-tada{25%,from,to{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1)}2%,5%{-webkit-transform:scale3d(.9,.9,.9) rotate3d(0,0,1,-3deg);transform:scale3d(.9,.9,.9) rotate3d(0,0,1,-3deg)}12%,17%,22%,7%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,3deg);transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,3deg)}10%,15%,20%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,-3deg);transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,-3deg)}}@keyframes pwapp-tada{25%,from,to{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1)}2%,5%{-webkit-transform:scale3d(.9,.9,.9) rotate3d(0,0,1,-3deg);transform:scale3d(.9,.9,.9) rotate3d(0,0,1,-3deg)}12%,17%,22%,7%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,3deg);transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,3deg)}10%,15%,20%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,-3deg);transform:scale3d(1.1,1.1,1.1) rotate3d(0,0,1,-3deg)}}.pwapp-tada{-webkit-animation-name:pwapp-tada;animation-name:pwapp-tada}@-webkit-keyframes pwapp-wobble{25%,from,to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}3%{-webkit-transform:translate3d(-25%,0,0) rotate3d(0,0,1,-5deg);transform:translate3d(-25%,0,0) rotate3d(0,0,1,-5deg)}7%{-webkit-transform:translate3d(20%,0,0) rotate3d(0,0,1,3deg);transform:translate3d(20%,0,0) rotate3d(0,0,1,3deg)}11%{-webkit-transform:translate3d(-15%,0,0) rotate3d(0,0,1,-3deg);transform:translate3d(-15%,0,0) rotate3d(0,0,1,-3deg)}15%{-webkit-transform:translate3d(10%,0,0) rotate3d(0,0,1,2deg);transform:translate3d(10%,0,0) rotate3d(0,0,1,2deg)}18%{-webkit-transform:translate3d(-5%,0,0) rotate3d(0,0,1,-1deg);transform:translate3d(-5%,0,0) rotate3d(0,0,1,-1deg)}}@keyframes pwapp-wobble{25%,from,to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}3%{-webkit-transform:translate3d(-25%,0,0) rotate3d(0,0,1,-5deg);transform:translate3d(-25%,0,0) rotate3d(0,0,1,-5deg)}7%{-webkit-transform:translate3d(20%,0,0) rotate3d(0,0,1,3deg);transform:translate3d(20%,0,0) rotate3d(0,0,1,3deg)}11%{-webkit-transform:translate3d(-15%,0,0) rotate3d(0,0,1,-3deg);transform:translate3d(-15%,0,0) rotate3d(0,0,1,-3deg)}15%{-webkit-transform:translate3d(10%,0,0) rotate3d(0,0,1,2deg);transform:translate3d(10%,0,0) rotate3d(0,0,1,2deg)}18%{-webkit-transform:translate3d(-5%,0,0) rotate3d(0,0,1,-1deg);transform:translate3d(-5%,0,0) rotate3d(0,0,1,-1deg)}}.pwapp-wobble{-webkit-animation-name:pwapp-wobble;animation-name:pwapp-wobble}@-webkit-keyframe pwapp-jello{5.6%,50%,from,to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}11.1%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}16.6%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}22.2%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}27.7%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}33.3%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}38.8%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}44.4%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}@keyframes pwapp-jello{5.6%,50%,from,to{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}11.1%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}16.6%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}22.2%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}27.7%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}33.3%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}38.8%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}44.4%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}.pwapp-jello{-webkit-animation-name:pwapp-jello;animation-name:pwapp-jello;-webkit-transform-origin:center;transform-origin:center}@-webkit-keyframes pwapp-flip{from{-webkit-transform:perspective(400px) rotate3d(0,1,0,-360deg);transform:perspective(400px) rotate3d(0,1,0,-360deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}5%{-webkit-transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-190deg);transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-190deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}6%{-webkit-transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-170deg);transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-170deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}10%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95);transform:perspective(400px) scale3d(.95,.95,.95);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}12%,to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}@keyframes pwapp-flip{from{-webkit-transform:perspective(400px) rotate3d(0,1,0,-360deg);transform:perspective(400px) rotate3d(0,1,0,-360deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}5%{-webkit-transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-190deg);transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-190deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}6%{-webkit-transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-170deg);transform:perspective(400px) translate3d(0,0,150px) rotate3d(0,1,0,-170deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}10%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95);transform:perspective(400px) scale3d(.95,.95,.95);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}12%,to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}.pwapp-flip{-webkit-backface-visibility:visible;backface-visibility:visible;-webkit-animation-name:pwapp-flip;animation-name:pwapp-flip}@keyframes pwapp-heartBeat{0%{-webkit-transform: scale(1);transform: scale(1);}14% {-webkit-transform: scale(1.3);transform: scale(1.3);}28% {-webkit-transform: scale(1);transform: scale(1);}42% {-webkit-transform: scale(1.3);transform: scale(1.3);}70% {-webkit-transform: scale(1);transform:scale(1);}}.pwapp-heartBeat {-webkit-animation-name: pwapp-heartBeat;animation-name: pwapp-heartBeat;-webkit-animation-duration: 1.3s;animation-duration: 1.3s;-webkit-animation-timing-function: ease-in-out;animation-timing-function: ease-in-out;}@-webkit-keyframes pwapp-bounceInDown {from,60%,75%,90%,to {-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);}0% {opacity: 0;-webkit-transform: translate3d(0, -3000px, 0);transform: translate3d(0, -3000px, 0);}60% {opacity: 1;-webkit-transform: translate3d(0, 25px, 0);transform: translate3d(0, 25px, 0);}75% {-webkit-transform: translate3d(0, -10px, 0);transform: translate3d(0, -10px, 0);}90% {-webkit-transform: translate3d(0, 5px, 0);transform: translate3d(0, 5px, 0);}to {-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}@keyframes pwapp-bounceInDown { from,  60%,  75%,  90%,to {-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);}  0% {opacity: 0;-webkit-transform: translate3d(0, -3000px, 0);transform: translate3d(0, -3000px, 0);  }  60% {    opacity: 1;-webkit-transform: translate3d(0, 25px, 0);transform: translate3d(0, 25px, 0);  }75% {-webkit-transform: translate3d(0, -10px, 0);transform: translate3d(0, -10px, 0);  }  90% {-webkit-transform: translate3d(0, 5px, 0);transform: translate3d(0, 5px, 0);  }  to {-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);}}.pwapp-bounceInDown {-webkit-animation-name: pwapp-bounceInDown;animation-name: pwapp-bounceInDown;}@-webkit-keyframes pwapp-bounceInLeft {  from,  60%,  75%,  90%,to {-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);}0% {opacity: 0;-webkit-transform: translate3d(-3000px, 0, 0);    transform: translate3d(-3000px, 0, 0);  }  60% {    opacity: 1;    -webkit-transform: translate3d(25px, 0, 0);transform: translate3d(25px, 0, 0);  }  75% {    -webkit-transform: translate3d(-10px, 0, 0);   transform: translate3d(-10px, 0, 0);  }  90% {-webkit-transform: translate3d(5px, 0, 0);    transform: translate3d(5px, 0, 0);  }  to {    -webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);}}@keyframes pwapp-bounceInLeft {  from,  60%,  75%,  90%,  to {    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);}  0% {    opacity: 0;    -webkit-transform: translate3d(-3000px, 0, 0);transform: translate3d(-3000px, 0, 0);  }  60% {    opacity: 1;-webkit-transform: translate3d(25px, 0, 0);transform: translate3d(25px, 0, 0);  }  75% {-webkit-transform: translate3d(-10px, 0, 0);transform: translate3d(-10px, 0, 0);  }  90% {-webkit-transform: translate3d(5px, 0, 0);transform: translate3d(5px, 0, 0);  }  to {    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}.pwapp-bounceInLeft {-webkit-animation-name: pwapp-bounceInLeft;  animation-name: pwapp-bounceInLeft;}@-webkit-keyframes pwapp-bounceInRight {  from,  60%,  75%,  90%,  to {-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);  }  from {    opacity: 0;-webkit-transform: translate3d(3000px, 0, 0);transform: translate3d(3000px, 0, 0);  }  60% {    opacity: 1;-webkit-transform: translate3d(-25px, 0, 0);    transform: translate3d(-25px, 0, 0);  }  75% {-webkit-transform: translate3d(10px, 0, 0);transform: translate3d(10px, 0, 0);  }  90% {    -webkit-transform: translate3d(-5px, 0, 0);    transform: translate3d(-5px, 0, 0);  }  to {-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}@keyframes pwapp-bounceInRight {  from,  60%,  75%,  90%,  to {-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);  }  from {opacity: 0;-webkit-transform: translate3d(3000px, 0, 0);transform: translate3d(3000px, 0, 0);  }  60% {    opacity: 1;-webkit-transform: translate3d(-25px, 0, 0);transform: translate3d(-25px, 0, 0);  }  75% {-webkit-transform: translate3d(10px, 0, 0);transform: translate3d(10px, 0, 0);  }  90% {-webkit-transform: translate3d(-5px, 0, 0);    transform: translate3d(-5px, 0, 0);  }  to {-webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}.pwapp-bounceInRight {-webkit-animation-name: pwapp-bounceInRight;animation-name: pwapp-bounceInRight;}@-webkit-keyframes pwapp-bounceInUp {  from,  60%,  75%,  90%,  to {    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);  }  from {    opacity: 0;-webkit-transform: translate3d(0, 3000px, 0);    transform: translate3d(0, 3000px, 0);  }  60% {    opacity: 1;    -webkit-transform: translate3d(0, -20px, 0);transform: translate3d(0, -20px, 0);  }  75% {    -webkit-transform: translate3d(0, 10px, 0);   transform: translate3d(0, 10px, 0); }90% {-webkit-transform: translate3d(0, -5px, 0);   transform: translate3d(0, -5px, 0);  }  to {-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}@keyframes pwapp-bounceInUp {  from,  60%,  75%,  90%,  to {-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);  }  from {   opacity: 0;    -webkit-transform: translate3d(0, 3000px, 0);    transform: translate3d(0, 3000px, 0);  }  60% {opacity: 1;-webkit-transform: translate3d(0, -20px, 0);transform: translate3d(0, -20px, 0);  }  75% {-webkit-transform: translate3d(0, 10px, 0);transform: translate3d(0, 10px, 0);  }  90% {-webkit-transform: translate3d(0, -5px, 0);   transform: translate3d(0, -5px, 0);  }  to {-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}.pwapp-bounceInUp {-webkit-animation-name: pwapp-bounceInUp;  animation-name: pwapp-bounceInUp;}@-webkit-keyframes pwapp-fadeInDown {from {opacity: 0;-webkit-transform: translate3d(0, -100%, 0);    transform: translate3d(0, -100%, 0);  }  to {opacity: 1;-webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}@keyframes pwapp-fadeInDown {  from {opacity: 0;-webkit-transform: translate3d(0, -100%, 0);    transform: translate3d(0, -100%, 0);  }  to {    opacity: 1;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}.pwapp-fadeInDown {-webkit-animation-name: pwapp-fadeInDown;  animation-name: pwapp-fadeInDown;}@-webkit-keyframes pwapp-fadeInDownBig {from {opacity: 0;-webkit-transform: translate3d(0, -2000px, 0);    transform: translate3d(0, -2000px, 0);}  to {opacity: 1;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}@keyframes pwapp-fadeInDownBig {from {opacity: 0;-webkit-transform: translate3d(0, -2000px, 0);transform: translate3d(0, -2000px, 0);  }  to {    opacity: 1;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}.pwapp-fadeInDownBig {  -webkit-animation-name: pwapp-fadeInDownBig;  animation-name: pwapp-fadeInDownBig;}@-webkit-keyframes pwapp-fadeInLeft {from {opacity: 0;-webkit-transform: translate3d(-100%, 0, 0);    transform: translate3d(-100%, 0, 0);  }  to {opacity: 1;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}@keyframes pwapp-fadeInLeft {  from {opacity: 0;-webkit-transform: translate3d(-100%, 0, 0);transform: translate3d(-100%, 0, 0);  }  to {opacity: 1;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}.pwapp-fadeInLeft {-webkit-animation-name: pwapp-fadeInLeft;animation-name: pwapp-fadeInLeft;}@-webkit-keyframes pwapp-fadeInRight {from {opacity: 0;-webkit-transform: translate3d(100%, 0, 0);transform: translate3d(100%, 0, 0);  }  to {opacity: 1;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0); }}@keyframes pwapp-fadeInRight {  from {opacity: 0;-webkit-transform: translate3d(100%, 0, 0);transform: translate3d(100%, 0, 0);  } to {opacity: 1;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}.pwapp-fadeInRight {-webkit-animation-name: pwapp-fadeInRight;  animation-name: pwapp-fadeInRight;}@-webkit-keyframes pwapp-fadeInRightBig {from {opacity: 0;-webkit-transform: translate3d(2000px, 0, 0);    transform: translate3d(2000px, 0, 0); }  to {    opacity: 1;    -webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}@keyframes pwapp-fadeInRightBig {  from {opacity: 0;-webkit-transform: translate3d(2000px, 0, 0);transform: translate3d(2000px, 0, 0);  }  to {    opacity: 1;-webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}.pwapp-fadeInRightBig {  -webkit-animation-name: pwapp-fadeInRightBig;  animation-name: pwapp-fadeInRightBig;}@-webkit-keyframes pwapp-fadeInUp {from {opacity: 0;-webkit-transform: translate3d(0, 100%, 0);    transform: translate3d(0, 100%, 0);  }  to {opacity: 1;-webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}@keyframes pwapp-fadeInUp {  from {opacity: 0;-webkit-transform: translate3d(0, 100%, 0);transform: translate3d(0, 100%, 0);  }  to {    opacity: 1;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}.pwapp-fadeInUp {  -webkit-animation-name: pwapp-fadeInUp;  animation-name: pwapp-fadeInUp;}@-webkit-keyframes pwapp-fadeInUpBig {from {opacity: 0;-webkit-transform: translate3d(0, 2000px, 0);    transform: translate3d(0, 2000px, 0);  }  to {    opacity: 1; -webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}@keyframes pwapp-fadeInUpBig {  from {opacity: 0;-webkit-transform: translate3d(0, 2000px, 0);transform: translate3d(0, 2000px, 0);  }  to {opacity: 1;    -webkit-transform: translate3d(0, 0, 0); transform: translate3d(0, 0, 0);  }}.pwapp-fadeInUpBig {  -webkit-animation-name: pwapp-fadeInUpBig;  animation-name: pwapp-fadeInUpBig;}@-webkit-keyframes pwapp-flipInX {  from {-webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);-webkit-animation-timing-function: ease-in;animation-timing-function: ease-in;    opacity: 0;  }  40% {    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);transform: perspective(400px) rotate3d(1, 0, 0, -20deg);    -webkit-animation-timing-function: ease-in;animation-timing-function: ease-in;  }  60% {-webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);opacity: 1;  }  80% {-webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);  }  to {-webkit-transform: perspective(400px);    transform: perspective(400px);  }}@keyframes pwapp-flipInX {  from {    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);    -webkit-animation-timing-function: ease-in;animation-timing-function: ease-in;opacity: 0;  }  40% {   -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);    -webkit-animation-timing-function: ease-in;    animation-timing-function: ease-in;  }  60% {-webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);    opacity: 1;  }  80% {-webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);  }  to {-webkit-transform: perspective(400px);transform: perspective(400px);  }}.pwapp-flipInX {-webkit-backface-visibility: visible !important;  backface-visibility: visible !important;-webkit-animation-name: pwapp-flipInX;  animation-name: pwapp-flipInX;}@-webkit-keyframes pwapp-flipInY {  from {    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);-webkit-animation-timing-function: ease-in;animation-timing-function: ease-in;opacity: 0;  }  40% {-webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);    -webkit-animation-timing-function: ease-in;    animation-timing-function: ease-in;  }  60% {-webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);opacity: 1;  }  80% {-webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);    transform: perspective(400px) rotate3d(0, 1, 0, -5deg);  }  to {-webkit-transform: perspective(400px);    transform: perspective(400px);  }}@keyframes pwapp-flipInY {  from {-webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);-webkit-animation-timing-function: ease-in;    animation-timing-function: ease-in;    opacity: 0;  }  40% {-webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);-webkit-animation-timing-function: ease-in;    animation-timing-function: ease-in;  }  60% {-webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);    opacity: 1;  }  80% {-webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);transform: perspective(400px) rotate3d(0, 1, 0, -5deg);  }  to {-webkit-transform: perspective(400px);    transform: perspective(400px);  }}.pwapp-flipInY {-webkit-backface-visibility: visible !important;  backface-visibility: visible !important;  -webkit-animation-name: pwapp-flipInY;  animation-name: pwapp-flipInY;}@-webkit-keyframes pwapp-flipOutX {  from {    -webkit-transform: perspective(400px);    transform: perspective(400px);  }  30% {-webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);    opacity: 1;  }  to {    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);    opacity: 0;  }}@keyframes pwapp-flipOutX {  from {-webkit-transform: perspective(400px);    transform: perspective(400px);  }  30% {-webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);    opacity: 1;  }  to {-webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);opacity: 0;  }}.pwapp-flipOutX {  -webkit-animation-duration: 0.75s;  animation-duration: 0.75s;  -webkit-animation-name: pwapp-flipOutX;  animation-name: pwapp-flipOutX;  -webkit-backface-visibility: visible !important;  backface-visibility: visible !important;}@-webkit-keyframes pwapp-flipOutY {  from {    -webkit-transform: perspective(400px);    transform: perspective(400px);  }  30% {    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);    opacity: 1;  }  to {-webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);    opacity: 0;  }}@keyframes pwapp-flipOutY {  from {    -webkit-transform: perspective(400px);    transform: perspective(400px);  }  30% {-webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);    transform: perspective(400px) rotate3d(0, 1, 0, -15deg); opacity: 1;  }  to {-webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);opacity: 0;  }}.pwapp-flipOutY {  -webkit-animation-duration: 0.75s;  animation-duration: 0.75s;  -webkit-backface-visibility: visible !important;  backface-visibility: visible !important;  -webkit-animation-name: pwapp-flipOutY;  animation-name: pwapp-flipOutY;}@-webkit-keyframes pwapp-lightSpeedIn {  from {    -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);    transform: translate3d(100%, 0, 0) skewX(-30deg);opacity: 0;  }  60% {    -webkit-transform: skewX(20deg);    transform: skewX(20deg);    opacity: 1;  }  80% {    -webkit-transform: skewX(-5deg);    transform: skewX(-5deg);  }  to {    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}@keyframes pwapp-lightSpeedIn {  from {-webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);    transform: translate3d(100%, 0, 0) skewX(-30deg);    opacity: 0;  } 60% {  -webkit-transform: skewX(20deg);    transform: skewX(20deg);    opacity: 1;  }  80% {-webkit-transform: skewX(-5deg);    transform: skewX(-5deg);  }  to {    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}.pwapp-lightSpeedIn {  -webkit-animation-name: pwapp-lightSpeedIn;  animation-name: pwapp-lightSpeedIn;-webkit-animation-timing-function: ease-out;  animation-timing-function: ease-out;}@-webkit-keyframes pwapp-rotateIn {  from {-webkit-transform-origin: center;    transform-origin: center;    -webkit-transform: rotate3d(0, 0, 1, -200deg);    transform: rotate3d(0, 0, 1, -200deg);    opacity: 0;  }  to {    -webkit-transform-origin: center;    transform-origin: center;-webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);    opacity: 1;  }}@keyframes pwapp-rotateIn {  from {    -webkit-transform-origin: center;    transform-origin: center;    -webkit-transform: rotate3d(0, 0, 1, -200deg);    transform: rotate3d(0, 0, 1, -200deg); opacity: 0; }  to {-webkit-transform-origin: center;transform-origin: center;    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);    opacity: 1;  }}.pwapp-rotateIn {-webkit-animation-name: pwapp-rotateIn;  animation-name: pwapp-rotateIn;}@-webkit-keyframes pwapp-rotateInDownLeft {  from {-webkit-transform-origin: left bottom;    transform-origin: left bottom;    -webkit-transform: rotate3d(0, 0, 1, -45deg);    transform: rotate3d(0, 0, 1, -45deg);    opacity: 0;  }  to {    -webkit-transform-origin: left bottom;transform-origin: left bottom;-webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);opacity: 1;  }}@keyframes pwapp-rotateInDownLeft {  from {    -webkit-transform-origin: left bottom;transform-origin: left bottom;-webkit-transform: rotate3d(0, 0, 1, -45deg);    transform: rotate3d(0, 0, 1, -45deg);    opacity: 0;  }  to {    -webkit-transform-origin: left bottom;    transform-origin: left bottom;-webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);opacity: 1;  }}.pwapp-rotateInDownLeft {-webkit-animation-name: pwapp-rotateInDownLeft;  animation-name: pwapp-rotateInDownLeft;}@-webkit-keyframes pwapp-rotateInDownRight {  from {-webkit-transform-origin: right bottom;transform-origin: right bottom;    -webkit-transform: rotate3d(0, 0, 1, 45deg);transform: rotate3d(0, 0, 1, 45deg);opacity: 0;  }  to {    -webkit-transform-origin: right bottom;    transform-origin: right bottom;    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);    opacity: 1;  }}@keyframes pwapp-rotateInDownRight {  from {    -webkit-transform-origin: right bottom;    transform-origin: right bottom;-webkit-transform: rotate3d(0, 0, 1, 45deg);    transform: rotate3d(0, 0, 1, 45deg);    opacity: 0;  }  to {    -webkit-transform-origin: right bottom;    transform-origin: right bottom;    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);opacity: 1;  }}.pwapp-rotateInDownRight {  -webkit-animation-name: pwapp-rotateInDownRight;  animation-name: pwapp-rotateInDownRight;}@-webkit-keyframes pwapp-rotateInUpLeft {  from {    -webkit-transform-origin: left bottom;    transform-origin: left bottom;    -webkit-transform: rotate3d(0, 0, 1, 45deg);    transform: rotate3d(0, 0, 1, 45deg);    opacity: 0;  }  to {-webkit-transform-origin: left bottom;    transform-origin: left bottom;    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);opacity: 1;  }}@keyframes pwapp-rotateInUpLeft {  from {    -webkit-transform-origin: left bottom;    transform-origin: left bottom;    -webkit-transform: rotate3d(0, 0, 1, 45deg);    transform: rotate3d(0, 0, 1, 45deg);    opacity: 0;  }  to {-webkit-transform-origin: left bottom;    transform-origin: left bottom;    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);opacity: 1;  }}.pwapp-rotateInUpLeft {  -webkit-animation-name: pwapp-rotateInUpLeft;  animation-name: pwapp-rotateInUpLeft;}@-webkit-keyframes pwapp-rotateInUpRight {  from {-webkit-transform-origin: right bottom;transform-origin: right bottom;-webkit-transform: rotate3d(0, 0, 1, -90deg);transform: rotate3d(0, 0, 1, -90deg);    opacity: 0;  }  to {-webkit-transform-origin: right bottom;    transform-origin: right bottom;-webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);    opacity: 1;  }}@keyframes pwapp-rotateInUpRight {  from {-webkit-transform-origin: right bottom;    transform-origin: right bottom;-webkit-transform: rotate3d(0, 0, 1, -90deg);transform: rotate3d(0, 0, 1, -90deg);opacity: 0;  }  to {-webkit-transform-origin: right bottom;transform-origin: right bottom;    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);    opacity: 1;  }}.pwapp-rotateInUpRight {  -webkit-animation-name: pwapp-rotateInUpRight;  animation-name: pwapp-rotateInUpRight;} @-webkit-keyframes pwapp-slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes pwapp-slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.pwapp-slideInUp{-webkit-animation-name:pwapp-slideInUp;animation-name:pwapp-slideInUp} @-webkit-keyframes pwapp-slideInDown {  from {    -webkit-transform: translate3d(0, -100%, 0);transform: translate3d(0, -100%, 0);visibility: visible;  }  to {    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}@keyframes pwapp-slideInDown {  from {    -webkit-transform: translate3d(0, -100%, 0);    transform: translate3d(0, -100%, 0);visibility: visible;  }  to {-webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}.pwapp-slideInDown {  -webkit-animation-name: pwapp-slideInDown;  animation-name: pwapp-slideInDown;}	  @-webkit-keyframes pwapp-slideInLeft {  from {    -webkit-transform: translate3d(-100%, 0, 0);transform: translate3d(-100%, 0, 0);    visibility: visible;  }  to {    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}@keyframes pwapp-slideInLeft {  from {-webkit-transform: translate3d(-100%, 0, 0);    transform: translate3d(-100%, 0, 0);visibility: visible;  }  to {    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}.pwapp-slideInLeft {-webkit-animation-name: pwapp-slideInLeft;  animation-name: pwapp-slideInLeft;}@-webkit-keyframes pwapp-slideInRight {  from {-webkit-transform: translate3d(100%, 0, 0);transform: translate3d(100%, 0, 0);    visibility: visible;  }  to {    -webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);  }}@keyframes pwapp-slideInRight {  from {    -webkit-transform: translate3d(100%, 0, 0);    transform: translate3d(100%, 0, 0);    visibility: visible;  }  to {    -webkit-transform: translate3d(0, 0, 0);    transform: translate3d(0, 0, 0);  }}.pwapp-slideInRight {  -webkit-animation-name: pwapp-slideInRight;  animation-name: pwapp-slideInRight;}@-webkit-keyframes pwapp-zoomIn {  from {    opacity: 0;-webkit-transform: scale3d(0.3, 0.3, 0.3);    transform: scale3d(0.3, 0.3, 0.3);  }  50% {    opacity: 1;  }}@keyframes pwapp-zoomIn {  from {opacity: 0;-webkit-transform: scale3d(0.3, 0.3, 0.3);    transform: scale3d(0.3, 0.3, 0.3);  }  50% {opacity: 1;}}.pwapp-zoomIn {-webkit-animation-name: pwapp-zoomIn;  animation-name: pwapp-zoomIn;}@-webkit-keyframes pwapp-zoomInDown {  from {opacity: 0;-webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);-webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);  }  60% {opacity: 1;-webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);-webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);  }}@keyframes pwapp-zoomInDown {from {opacity: 0;-webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);  }  60% {opacity: 1;-webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);-webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);  }}.pwapp-zoomInDown {-webkit-animation-name: pwapp-zoomInDown;  animation-name: pwapp-zoomInDown;}@-webkit-keyframes pwapp-zoomInLeft {  from {opacity: 0;-webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);-webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);  }  60% {opacity: 1;-webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);  }}@keyframes pwapp-zoomInLeft {  from {opacity: 0;-webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);-webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);  }  60% {opacity: 1;-webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);-webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);  }}.pwapp-zoomInLeft {  -webkit-animation-name: pwapp-zoomInLeft;  animation-name: pwapp-zoomInLeft;}@-webkit-keyframes pwapp-zoomInRight {  from {opacity: 0;-webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);-webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);  }  60% {opacity: 1;-webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);-webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);  }}@keyframes pwapp-zoomInRight {  from {opacity: 0;-webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);-webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);  }  60% {opacity: 1;-webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);-webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);  }}.pwapp-zoomInRight {-webkit-animation-name: pwapp-zoomInRight;  animation-name: pwapp-zoomInRight;}@-webkit-keyframes pwapp-zoomInUp {  from {opacity: 0;-webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);-webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);}  60% { opacity: 1;-webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0); -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);  }}@keyframes pwapp-zoomInUp {  from {opacity: 0;-webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);-webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);  }  60% {opacity: 1;    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);-webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1); }}.pwapp-zoomInUp {-webkit-animation-name: pwapp-zoomInUp;  animation-name: pwapp-zoomInUp;}@-webkit-keyframes pwapp-jackInTheBox {  from {    opacity: 0;-webkit-transform: scale(0.1) rotate(30deg);transform: scale(0.1) rotate(30deg);-webkit-transform-origin: center bottom;transform-origin: center bottom;  }  50% {-webkit-transform: rotate(-10deg);transform: rotate(-10deg);}  70% {-webkit-transform: rotate(3deg);transform: rotate(3deg);  }  to {opacity: 1;-webkit-transform: scale(1);transform: scale(1);}}@keyframes pwapp-jackInTheBox {from {opacity: 0;-webkit-transform: scale(0.1) rotate(30deg);transform: scale(0.1) rotate(30deg);-webkit-transform-origin: center bottom;transform-origin: center bottom;  } 50% {-webkit-transform: rotate(-10deg);transform: rotate(-10deg);}  70% {-webkit-transform: rotate(3deg);transform: rotate(3deg); }  to {opacity: 1;    -webkit-transform: scale(1);    transform: scale(1);  }}.pwapp-jackInTheBox {-webkit-animation-name: pwapp-jackInTheBox;  animation-name: pwapp-jackInTheBox;}@-webkit-keyframes pwapp-rollIn {from {opacity: 0;webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);}to {opacity: 1;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);}}@keyframes pwapp-rollIn {from {opacity: 0;-webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);}to {opacity: 1;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);}}.pwapp-rollIn {-webkit-animation-name: pwapp-rollIn;animation-name: pwapp-rollIn;}";

    if ("undefined" == typeof jQuery) {
      var p = document.getElementsByTagName("head")[0],
        b = document.createElement("script");
      (b.type = "text/javascript"),
        (b.src =
          "https://ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js"),
        (b.onload = dal),
        p.appendChild(b);
    } else setTimeout(dal, 100);

    var pqq = document.getElementsByTagName("head")[0],
      bqq = document.createElement("script");
    //   bqq.type = "text/javascript", bqq.src = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.1/js/all.min.js", bqq.onload = dal, pqq.appendChild(bqq);
    //  bqq.type = "text/javascript", bqq.src = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.1/js/all.min.js", pqq.appendChild(bqq);



    //      setTimeout(function() {localStorage.setItem("optin_widget_last_shown", JSON.stringify(Date.now()))}, 100)

    function dal() {
      jQuery("head").append("<style>" + lpoha + "</style>");
    }

    var d = {
      id: "whatsapp",
      shop: null,
      settings: {
        style:{
     
          
        }
      },
      block: {},
      editor: {
        enabled: false,
      },
      selectors: {
        widget: "pushdaddy-widget",
        //	widget: 'kdaddy-body',
        dashboard: "kdaddy-dashboard",
        category: "kdaddy-category",
        article: "kdaddy-article",
        search: "kdaddy-search",
        box: "pushdaddy-box",
        greeting: "pushdaddy-greeting",
        greeting_close: "pushdaddy-greeting-close",
        modal: "kdaddy-modal",
        modal_close: "kdaddy-modal-close",
      },
      host: {
        path: "https://cdn.shopify.com/s/files/1/0033/3538/9233/files/faq-",
        version: "1615391572",
      },
      emojis: {
        frequently: [
          ["thumbs_up", "&#128077;"],
          ["-1", "&#128078;"],
          ["sob", "&#128557;"],
          ["confused", "&#128533;"],
          ["neutral_face", "&#128528;"],
          ["blush", "&#128522;"],
          ["heart_eyes", "&#128525;"],
        ],
        people: [
          ["smile", "&#128516;"],
          ["smiley", "&#128515;"],
          ["grinning", "&#128512;"],
          ["blush", "&#128522;"],
          ["wink", "&#128521;"],
          ["heart_eyes", "&#128525;"],
        ],
        nature: [
          ["dog", "&#128054;"],
          ["wolf", "&#128058;"],
          ["cat", "&#128049;"],
          ["mouse", "&#128045;"],
          ["hamster", "&#128057;"],
        ],
        objects: [
          ["bamboo", "&#127885;"],
          ["gift_heart", "&#128157;"],
          ["dolls", "&#127886;"],
          ["school_satchel", "&#127890;"],
          ["mortar_board", "&#127891;"],
        ],
        places: [
          ["house", "&#127968;"],
          ["house_with_garden", "&#127969;"],
          ["school", "&#127979;"],
          ["office", "&#127970;"],
          ["post_office", "&#127971;"],
          ["hospital", "&#127973;"],
        ],
        symbols: [
          ["keycap_ten", "&#128287;"],
          ["1234", "&#128290;"],
          ["symbols", "&#128291;"],
          ["capital_abcd", "&#128288;"],
          ["abcd", "&#128289;"],
          ["abc", "&#128292;"],
          ["arrow_up_small", "&#128316;"],
        ],
      },
      patterns: {
        0: ["#047c8d", "#2ff289", "#ffffff", "#020610"],
        1: ["#401dba", "#825bf0", "#ffffff", "#401dba"],
        2: ["#ff4e6f", "#fb9168", "#ffffff", "#ff4e6f"],
        3: ["#ace0f9", "#fff1eb", "#2f5680", "#82b2c9"],
        4: ["#29323c", "#485563", "#ffffff", "#29323c"],
        5: ["#4facfe", "#00f2fe", "#ffffff", "#4facfe"],
        6: ["#7c3ab7", "#ff9aad", "#ffffff", "#7c3ab7"],
        7: ["#a18cd1", "#fbc2eb", "#42265a", "#9d4eec"],
        8: ["#ff9a9e", "#fad0c4", "#843437", "#ff74b7"],
        9: ["#ff5858", "#f09819", "#ffffff", "#ff5858"],
        10: ["#fa709a", "#febb40", "#ffffff", "#fa709a"],
        11: ["#fda085", "#f6d365", "#784438", "#ff9a4a"],
        12: ["#daa475", "#ffe0b9", "#6b4b29", "#daa475"],
        13: ["#8a716d", "#e8b794", "#ffffff", "#8a716d"],
        14: ["#abecd6", "#fbed96", "#387861", "#b1c71d"],
        15: ["#3aa560", "#b7e66c", "#ffffff", "#3aa560"],
        16: ["#00c9ff", "#92fe9d", "#173e2b", "#00c9ff"],
        17: ["#13547a", "#80d0c7", "#ffffff", "#13547a"],
        18: ["#dfe9f3", "#ffffff", "#38425d", "#9fbedd"],
        19: ["#e9defa", "#fbfcdb", "#7d59a3", "#e9defa"],
        20: ["#accbee", "#e7f0fd", "#485195", "#999bb4"],
        21: ["#93a5cf", "#e4efe9", "#344973", "#93a5cf"],
        22: ["#09203f", "#537895", "#ffffff", "#09203f"],
        23: ["#000000", "#434343", "#ffffff", "#000000"],
        24: ["#0a0e88", "#00b1ce", "#ffffff", "#020610"],
        25: ["#19025c", "#6e28bf", "#ffffff", "#020610"],
        26: ["#31003e", "#c3286e", "#ffffff", "#020610"],
        27: ["#98033a", "#f74f28", "#ffffff", "#020610"],
        28: ["#2a27da", "#00ccff", "#ffffff", "#004dff"],
        29: ["#1ebea5", "#01E677", "#ffffff", "#020610"],
        30: ["#bdc3c7", "#2c3e50", "#ffffff", "#020610"],
        31: ["#ee9ca7", "#ffdde1", "#ffffff", "#020610"],
        32: ["#2193b0", "#6dd5ed", "#ffffff", "#020610"],
        33: ["#C6FFDD", "#FBD786", "#f7797d", "#020610"],
        34: ["#0F2027", "#203A43", "#2c5364", "#020610"],
        35: ["#12c2e9", "#c471ed", "#f64f59", "#020610"],
        36: ["#b92b27", "#1565C0", "#A5FECB", "#020610"],
        37: ["#373B44", "#4286f4", "#ffffff", "#020610"],
        38: ["#2980B9", "#6DD5FA", "#FFFFFF", "#020610"],
        39: ["#FF0099", "#493240", "#ffffff", "#020610"],
        40: ["#aa4b6b", "#6b6b83", "#3b8d99", "#020610"],
        41: ["#8E2DE2", "#4A00E0", "#ffffff", "#020610"],
        42: ["#1f4037", "#99f2c8", "#ffffff", "#020610"],
        43: ["#f953c6", "#b91d73", "#292E49", "#020610"],
        44: ["#7F7FD5", "#86A8E7", "#91EAE4", "#020610"],
        45: ["#c31432", "#240b36", "#ffffff", "#020610"],
        46: ["#f12711", "#f5af19", "#ffffff", "#020610"],
        47: ["#659999", "#f4791f", "#ffffff", "#020610"],
        48: ["#dd3e54", "#6be585", "#ffffff", "#020610"],
        49: ["#8360c3", "#2ebf91", "#ffffff", "#020610"],
        50: ["#544a7d", "#ffd452", "#ffffff", "#020610"],
        51: ["#009FFF", "#ec2F4B", "#ffffff", "#020610"],
        52: ["#654ea3", "#eaafc8", "#ffffff", "#020610"],
        53: ["#FF416C", "#FF4B2B", "#ffffff", "#020610"],
        54: ["#8A2387", "#E94057", "#F27121", "#020610"],
        55: ["#a8ff78", "#78ffd6", "#ffffff", "#020610"],
        56: ["#1E9600", "#FFF200", "#FF0000", "#020610"],
        57: ["#ED213A", "#93291E", "#ffffff", "#020610"],
        58: ["#FDC830", "#F37335", "#ffffff", "#020610"],
        59: ["#00B4DB", "#0083B0", "#ffffff", "#020610"],
        60: ["#FFEFBA", "#FFFFFF", "#ffffff", "#020610"],
        61: ["#59C173", "#a17fe0", "#5D26C1", "#020610"],
        62: ["#005AA7", "#FFFDE4", "#ffffff", "#020610"],
        63: ["#DA4453", "#89216B", "#ffffff", "#020610"],
        64: ["#636363", "#a2ab58", "#ffffff", "#020610"],
        65: ["#ad5389", "#3c1053", "#ffffff", "#020610"],
        66: ["#a8c0ff", "#3f2b96", "#ffffff", "#020610"],
        67: ["#333333", "#dd1818", "#7AA1D2", "#020610"],
        68: ["#4e54c8", "#8f94fb", "#ffffff", "#020610"],
        69: ["#355C7D", "#6C5B7B", "#C06C84", "#020610"],
        70: ["#bc4e9c", "#f80759", "#ffffff", "#020610"],
        71: ["#40E0D0", "#FF8C00", "#FF0080", "#020610"],
        72: ["#3E5151", "#DECBA4", "#ffffff", "#020610"],
        73: ["#11998e", "#38ef7d", "#ffffff", "#020610"],
        74: ["#108dc7", "#ef8e38", "#ffffff", "#020610"],
        75: ["#FC5C7D", "#6A82FB", "#ffffff", "#020610"],
        76: ["#FC466B", "#3F5EFB", "#A6FFCB", "#020610"],
        77: ["#c94b4b", "#4b134f", "#ffffff", "#020610"],
        78: ["#23074d", "#cc5333", "#ffffff", "#020610"],
        79: ["#fffbd5", "#b20a2c", "#ffffff", "#020610"],
        80: ["#0f0c29", "#302b63", "#24243e", "#020610"],
        81: ["#00b09b", "#96c93d", "#ffffff", "#020610"],
        82: ["#D3CCE3", "#E9E4F0", "#ffffff", "#020610"],
        83: ["#3C3B3F", "#605C3C", "#ffffff", "#020610"],
        84: ["#CAC531", "#F3F9A7", "#ffffff", "#020610"],
        85: ["#800080", "#ffc0cb", "#ffffff", "#020610"],
        86: ["#00F260", "#0575E6", "#ffffff", "#020610"],
        87: ["#fc4a1a", "#f7b733", "#ffffff", "#020610"],
        88: ["#74ebd5", "#ACB6E5", "#ffffff", "#020610"],
        89: ["#6D6027", "#D3CBB8", "#ffffff", "#020610"],
        90: ["#03001e", "#7303c0", "#ec38bc", "#fdeff9"],
        91: ["#667db6", "#0082c8", "#0082c8", "#667db6"],
        92: ["#ADA996", "#F2F2F2", "#dbdbdb", "#eaeaea"],
        93: ["#e1eec3", "#f05053", "#ffffff", "#020610"],
        94: ["#1a2a6c", "#b21f1f", "#fdbb2d", "#020610"],
        95: ["#22c1c3", "#fdbb2d", "#ffffff", "#020610"],
        96: ["#ff9966", "#ff5e62", "#ffffff", "#020610"],
        97: ["#7F00FF", "#E100FF", "#ffffff", "#020610"],
        98: ["#C9D6FF", "#E2E2E2", "#ffffff", "#020610"],
        99: ["#396afc", "#2948ff", "#ffffff", "#020610"],
        101: ["#d9a7c7", "#fffcdc", "#ffffff", "#020610"],
        102: ["#0cebeb", "#20e3b2", "#29ffc6", "#020610"],
        103: ["#06beb6", "#48b1bf", "#ffffff", "#020610"],
        104: ["#642B73", "#C6426E", "#ffffff", "#020610"],
        105: ["#1c92d2", "#f2fcfe", "#ffffff", "#020610"],
        106: ["#000000", "#0f9b0f", "#ffffff", "#020610"],
        107: ["#36D1DC", "#5B86E5", "#ffffff", "#020610"],
        108: ["#36D1DC", "#5B86E5", "#ffffff", "#020610"],
        109: ["#CB356B", "#BD3F32", "#ffffff", "#020610"],
        110: ["#3A1C71", "#D76D77", "#FFAF7B", "#020610"],
        111: ["#EF3B36", "#FFFFFF", "#ffffff", "#020610"],
        112: ["#c0392b", "#8e44ad", "#ffffff", "#020610"],
        113: ["#159957", "#155799", "#ffffff", "#020610"],
        114: ["#000046", "#1CB5E0", "#ffffff", "#020610"],
        115: ["#007991", "#78ffd6", "#ffffff", "#020610"],
        116: ["#56CCF2", "#2F80ED", "#ffffff", "#020610"],
        117: ["#F2994A", "#F2C94C", "#ffffff", "#020610"],
        118: ["#EB5757", "#000000", "#ffffff", "#020610"],
        119: ["#E44D26", "#F16529", "#ffffff", "#020610"],
        120: ["#4AC29A", "#BDFFF3", "#ffffff", "#020610"],
        121: ["#B2FEFA", "#0ED2F7", "#ffffff", "#020610"],
        122: ["#30E8BF", "#FF8235", "#ffffff", "#020610"],
        123: ["#D66D75", "#E29587", "#ffffff", "#020610"],
        124: ["#20002c", "#cbb4d4", "#ffffff", "#020610"],
        125: ["#C33764", "#1D2671", "#ffffff", "#020610"],
        126: ["#F7971E", "#FFD200", "#ffffff", "#020610"],
        127: ["#34e89e", "#0f3443", "#ffffff", "#020610"],
        128: ["#6190E8", "#A7BFE8", "#ffffff", "#020610"],
        129: ["#44A08D", "#093637", "#ffffff", "#020610"],
        130: ["#200122", "#6f0000", "#ffffff", "#020610"],
        131: ["#0575E6", "#021B79", "#ffffff", "#020610"],
        132: ["#4568DC", "#B06AB3", "#ffffff", "#020610"],
        133: ["#43C6AC", "#191654", "#ffffff", "#020610"],
        134: ["#093028", "#237A57", "#ffffff", "#020610"],
        135: ["#43C6AC", "#F8FFAE", "#ffffff", "#020610"],
        136: ["#FFAFBD", "#ffc3a0", "#ffffff", "#020610"],
        137: ["#F0F2F0", "#000C40", "#ffffff", "#020610"],
        138: ["#E8CBC0", "#636FA4", "#ffffff", "#020610"],
        139: ["#DCE35B", "#45B649", "#ffffff", "#020610"],
        140: ["#c0c0aa", "#1cefff", "#ffffff", "#020610"],
        141: ["#9CECFB", "#65C7F7", "#0052D4", "#020610"],
        142: ["#DBE6F6", "#C5796D", "#ffffff", "#020610"],
        143: ["#3494E6", "#EC6EAD", "#ffffff", "#020610"],
        144: ["#67B26F", "#4ca2cd", "#ffffff", "#020610"],
        145: ["#F3904F", "#3B4371", "#ffffff", "#020610"],
        146: ["#ee0979", "#ff6a00", "#ffffff", "#020610"],
        147: ["#A770EF", "#CF8BF3", "#FDB99B", "#020610"],
        148: ["#41295a", "#2F0743", "#ffffff", "#020610"],
        149: ["#f4c4f3", "#fc67fa", "#ffffff", "#020610"],
        150: ["#00c3ff", "#ffff1c", "#ffffff", "#020610"],
        151: ["#ff7e5f", "#feb47b", "#ffffff", "#020610"],
        152: ["#fffc00", "#ffffff", "#ffffff", "#020610"],
        153: ["#ff00cc", "#333399", "#ffffff", "#020610"],
        154: ["#de6161", "#2657eb", "#ffffff", "#020610"],
        155: ["#ef32d9", "#89fffd", "#ffffff", "#020610"],
        156: ["#3a6186", "#89253e", "#ffffff", "#020610"],
        157: ["#4ecdc4", "#556270", "#ffffff", "#020610"],
        158: ["#a1ffce", "#faffd1", "#ffffff", "#020610"],
        159: ["#be93c5", "#7bc6cc", "#4BC0C8", "#020610"],
        160: ["#bdc3c7", "#2c3e50", "#fcb045", "#020610"],
        161: ["#ffd89b", "#19547b", "#ffffff", "#020610"],
        162: ["#808080", "#3fada8", "#ffffff", "#020610"],
        163: ["#ffd89b", "#19547b", "#ffffff", "#020610"],
        164: ["#bdc3c7", "#2c3e50", "#ffffff", "#020610"],
        165: ["#BE93C5", "#7BC6CC", "#ffffff", "#020610"],
        166: ["#A1FFCE", "#FAFFD1", "#ffffff", "#020610"],
        167: ["#4ECDC4", "#556270", "#ffffff", "#020610"],
        168: ["#3a6186", "#89253e", "#ffffff", "#020610"],
        169: ["#ef32d9", "#89fffd", "#ffffff", "#020610"],
        170: ["#de6161", "#2657eb", "#ffffff", "#020610"],
        171: ["#115deg", "#ff00cc", "#333399", "#020610"],
        172: ["#fffc00", "#ffffff", "#ffffff", "#020610"],
        173: ["#ff7e5f", "#feb47b", "#ffffff", "#020610"],
        174: ["#00c3ff", "#ffff1c", "#ffffff", "#020610"],
        175: ["#f4c4f3", "#fc67fa", "#ffffff", "#020610"],
        176: ["#41295a", "#2F0743", "#ffffff", "#020610"],
        177: ["#A770EF", "#CF8BF3", "#FDB99B", "#020610"],
        178: ["#ee0979", "#ff6a00", "#ffffff", "#020610"],
        179: ["#F3904F", "#3B4371", "#ffffff", "#020610"],
        180: ["#67B26F", "#4ca2cd", "#ffffff", "#020610"],
        181: ["#3494E6", "#EC6EAD", "#ffffff", "#020610"],
        182: ["#DBE6F6", "#C5796D", "#ffffff", "#020610"],
        183: ["#9CECFB", "#65C7F7", "#0052D4", "#020610"],
        184: ["#c0c0aa", "#1cefff", "#ffffff", "#020610"],
        185: ["#DCE35B", "#45B649", "#ffffff", "#020610"],
        186: ["#E8CBC0", "#636FA4", "#ffffff", "#020610"],
        187: ["#F0F2F0", "#000C40", "#ffffff", "#020610"],
        188: ["#FFAFBD", "#ffc3a0", "#ffffff", "#020610"],
        189: ["#43C6AC", "#F8FFAE", "#ffffff", "#020610"],
        190: ["#093028", "#237A57", "#ffffff", "#020610"],
        191: ["#43C6AC", "#191654", "#ffffff", "#020610"],
        192: ["#4568DC", "#B06AB3", "#ffffff", "#020610"],
        193: ["#0575E6", "#021B79", "#ffffff", "#020610"],
        194: ["#200122", "#6f0000", "#ffffff", "#020610"],
        195: ["#44A08D", "#093637", "#ffffff", "#020610"],
        196: ["#6190E8", "#A7BFE8", "#ffffff", "#020610"],
        197: ["#34e89e", "#0f3443", "#ffffff", "#020610"],
        198: ["#F7971E", "#FFD200", "#ffffff", "#020610"],
        199: ["#C33764", "#1D2671", "#ffffff", "#020610"],
        200: ["#20002c", "#cbb4d4", "#ffffff", "#020610"],
        201: ["#D66D75", "#E29587", "#ffffff", "#020610"],
        202: ["#30E8BF", "#FF8235", "#ffffff", "#020610"],
        203: ["#B2FEFA", "#0ED2F7", "#ffffff", "#020610"],
        204: ["#B2FEFA", "#0ED2F7", "#ffffff", "#020610"],
        205: ["#4AC29A", "#BDFFF3", "#ffffff", "#020610"],
        206: ["#E44D26", "#F16529", "#ffffff", "#020610"],
        207: ["#EB5757", "#000000", "#ffffff", "#020610"],
        208: ["#F2994A", "#F2C94C", "#ffffff", "#020610"],
        209: ["#56CCF2", "#2F80ED", "#ffffff", "#020610"],
        210: ["#007991", "#78ffd6", "#ffffff", "#020610"],
        211: ["#000046", "#1CB5E0", "#ffffff", "#020610"],
        212: ["#159957", "#155799", "#ffffff", "#020610"],
        213: ["#c0392b", "#8e44ad", "#ffffff", "#020610"],
        214: ["#EF3B36", "#FFFFFF", "#ffffff", "#020610"],
        215: ["#283c86", "#45a247", "#ffffff", "#020610"],
        216: ["#3A1C71", "#D76D77", "#FFAF7B", "#020610"],
        217: ["#CB356B", "#BD3F32", "#ffffff", "#020610"],
        218: ["#36D1DC", "#5B86E5", "#ffffff", "#020610"],
        219: ["#000000", "#0f9b0f", "#ffffff", "#020610"],
        220: ["#1c92d2", "#f2fcfe", "#ffffff", "#020610"],
        221: ["#642B73", "#C6426E", "#ffffff", "#020610"],
        222: ["#06beb6", "#48b1bf", "#ffffff", "#020610"],
        223: ["#0cebeb", "#20e3b2", "#29ffc6", "#020610"],
        224: ["#d9a7c7", "#fffcdc", "#ffffff", "#020610"],
        225: ["#396afc", "#2948ff", "#ffffff", "#020610"],
        226: ["#C9D6FF", "#E2E2E2", "#ffffff", "#020610"],
        227: ["#7F00FF", "#E100FF", "#ffffff", "#020610"],
        228: ["#ff9966", "#ff5e62", "#ffffff", "#020610"],
        229: ["#22c1c3", "#fdbb2d", "#ffffff", "#020610"],
        230: ["#1a2a6c", "#b21f1f", "#fdbb2d", "#020610"],
        231: ["#e1eec3", "#f05053", "#ffffff", "#020610"],
        232: ["#ADA996", "#F2F2F2", "#DBDBDB", "#EAEAEA"],
        233: ["#667db6", "#0082c8", "#0082c8", "#667db6"],
        234: ["#03001e", "#7303c0", "#ec38bc", "#fdeff9"],
        235: ["#6D6027", "#D3CBB8", "#ffffff", "#020610"],
        236: ["#74ebd5", "#ACB6E5", "#ffffff", "#020610"],
        237: ["#fc4a1a", "#f7b733", "#ffffff", "#020610"],
        238: ["#00F260", "#0575E6", "#ffffff", "#020610"],
        239: ["#800080", "#ffc0cb", "#ffffff", "#020610"],
        240: ["#CAC531", "#F3F9A7", "#ffffff", "#020610"],
        241: ["#3C3B3F", "#605C3C", "#ffffff", "#020610"],
        242: ["#D3CCE3", "#E9E4F0", "#ffffff", "#020610"],
        243: ["#00b09b", "#96c93d", "#ffffff", "#020610"],
        244: ["#0f0c29", "#302b63", "#24243e", "#020610"],
        245: ["#fffbd5", "#b20a2c", "#ffffff", "#020610"],
        246: ["#23074d", "#cc5333", "#FDB99B", "#020610"],
        247: ["#c94b4b", "#4b134f", "#ffffff", "#020610"],
        248: ["#FC466B", "#3F5EFB", "#ffffff", "#020610"],
        249: ["#FC5C7D", "#6A82FB", "#ffffff", "#020610"],
        250: ["#108dc7", "#ef8e38", "#ffffff", "#020610"],
        251: ["#11998e", "#38ef7d", "#ffffff", "#020610"],
        252: ["#3E5151", "#DECBA4", "#0052D4", "#020610"],
        253: ["#40E0D0", "#FF8C00", "#FF0080", "#020610"],
        254: ["#bc4e9c", "#f80759", "#ffffff", "#020610"],
        255: ["#355C7D", "#6C5B7B", "#C06C84", "#020610"],
        256: ["#4e54c8", "#8f94fb", "#ffffff", "#020610"],
        257: ["#333333", "#dd1818", "#ffffff", "#020610"],
        258: ["#a8c0ff", "#3f2b96", "#ffffff", "#020610"],
        259: ["#ad5389", "#3c1053", "#ffffff", "#020610"],
        260: ["#636363", "#a2ab58", "#ffffff", "#020610"],
        261: ["#DA4453", "#89216B", "#ffffff", "#020610"],
        262: ["#005AA7", "#FFFDE4", "#ffffff", "#020610"],
        263: ["#59C173", "#a17fe0", "#5D26C1", "#020610"],
        264: ["#FFEFBA", "#FFFFFF", "#ffffff", "#020610"],
        265: ["#00B4DB", "#0083B0", "#ffffff", "#020610"],
        266: ["#FDC830", "#F37335", "#ffffff", "#020610"],
        267: ["#ED213A", "#93291E", "#ffffff", "#020610"],
        268: ["#1E9600", "#FFF200", "#FF0000", "#020610"],
        269: ["#a8ff78", "#78ffd6", "#ffffff", "#020610"],
        270: ["#8A2387", "#E94057", "#F27121", "#020610"],
        271: ["#FF416C", "#FF4B2B", "#ffffff", "#020610"],
        272: ["#654ea3", "#eaafc8", "#ffffff", "#020610"],
        273: ["#009FFF", "#ec2F4B", "#ffffff", "#020610"],
        274: ["#8360c3", "#2ebf91", "#ffffff", "#020610"],
        275: ["#dd3e54", "#6be585", "#ffffff", "#020610"],
        276: ["#659999", "#f4791f", "#ffffff", "#020610"],
        277: ["#f12711", "#f5af19", "#ffffff", "#020610"],
        278: ["#c31432", "#240b36", "#ffffff", "#020610"],
        279: ["#7F7FD5", "#86A8E7", "#91EAE4", "#020610"],
        280: ["#f953c6", "#b91d73", "#ffffff", "#020610"],
        281: ["#1f4037", "#99f2c8", "#ffffff", "#020610"],
        282: ["#8E2DE2", "#4A00E0", "#ffffff", "#020610"],
        283: ["#aa4b6b", "#6b6b83", "#3b8d99", "#020610"],
        284: ["#FF0099", "#493240", "#FFAF7B", "#020610"],
        285: ["#2980B9", "#6DD5FA", "#FFFFFF", "#020610"],
        286: ["#373B44", "#4286f4", "#ffffff", "#020610"],
        287: ["#b92b27", "#1565C0", "#ffffff", "#020610"],
        288: ["#12c2e9", "#c471ed", "#f64f59", "#020610"],
        289: ["#0F2027", "#203A43", "#2C5364", "#020610"],
        290: ["#C6FFDD", "#FBD786", "#f7797d", "#020610"],
        291: ["#2193b0", "#6dd5ed", "#29ffc6", "#020610"],
        292: ["#ee9ca7", "#ffdde1", "#ffffff", "#020610"],
        293: ["#bdc3c7", "#2c3e50", "#ffffff", "#020610"],
      },

//cssUrl:"https://way2enjoy.com/shopify/1/whatsapp-chat/proxy/js/pwhatsapp62.scss.css",
cssUrl: "https://cdn.shopify.com/s/files/1/0033/3538/9233/files/pwhatsapp97.scss.css"
    };

    function ukkk() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    }

    //alert(huuu());
    // huuu();

    function pouty() {
      for (
        var e = document.getElementsByTagName("script"), t = 0;
        t < e.length;
        t++
      ) {
        if (e[t].src.indexOf("pushdaddy_v46_test") > -1)
          return e[t].src.substring(
            e[t].src.indexOf("shop=") + 5,
            e[t].src.length
          );
      }
      return document.domain;
    }

    function tuuu(e, a) {
      (e = String(e).replace(/[^0-9a-f]/gi, "")).length < 6 &&
        (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]),
        (a = a || 0);
      var t,
        n,
        r = "#";
      for (n = 0; n < 3; n++)
        (t = parseInt(e.substr(2 * n, 2), 16)),
          (r += (
            "00" +
            (t = Math.round(Math.min(Math.max(0, t + t * a), 255)).toString(16))
          ).substr(t.length));
      return r;
    }

    function r(e, a) {

      var t = new XMLHttpRequest();
      // t.open("GET", e), t.responseType = "text", t.setRequestHeader("X-Requested-With", "XMLHttpRequest"), a && (t.onload = function() {
      t.open("GET", e),
   //     t.setRequestHeader("X-Requested-With", "XMLHttpRequest"),
        a &&
          (t.onload = function () {
            (4 == t.readyState && 200 == t.status) || 401 == t.status
              ? a(null, t.responseText)
              : a(t.status, t.responseText);
          }),
        t.send();
    }

    function e() {

      return new Promise(function (n, e) {
        r(
          "/index.json?q=" + d.id + "&view=pwhatsapp&cache=false",
          function (e, a) {
            var t = !1;
            null == e &&
              (a = (function (e) {
                e = e.replace(/<!-[\S\s]*?-->/gm, "");
                try {
                  return JSON.parse(e);
                } catch (e) {
                  // failed code starts here
                  //   console.log('Error77777777');

                  var siteoriginn =
                    "https://way2enjoy.com/shopify/1/whatsapp-chat/";
                  var resultuu = "";
              //  setTimeout(
                    jQuery.ajax({
                      url: siteoriginn + "pab_get_chat.php?shop=" + pouty(),
                      method: "GET",
                      dataType: "json",
                      async: false,
                      success: function (euup) {
                        !function (euup, t) {
                          try {
                            sessionStorage.setItem(euup, t);
                          } catch (euup) {
                            return;
                          }
                        };
                        resultuu = JSON.stringify(euup);
                      },
                      error: function () {
                        console.log("Error");
                      },
                    });
                 //   100
                //  );
                  var resultuuppp = "";

                  var resultuuppp = resultuu;

                  var epo = resultuuppp.replace(/<!-[\S\s]*?-->/gm, "");

                  return JSON.parse(epo);
                  // failed code ends here
                  // return !1
                }
              })(a)) &&
              ((d.shop = a.metafields.shop),
              (d.settings = a.metafields.settings),
              0 == d.settings.charge &&
                (d.settings.block_order = d.settings.block_order.slice(0, 1)),
              (t = !0)),
              n(t);
          }
        );
      });
    }

    function _() {

      return 0 == d.settings.charge
        ? '<div class="pushdaddy-branding"><svg viewBox="0 0 512 512"><linearGradient id="branding-gradient" gradientTransform="rotate(25)"><stop offset="0%"></stop><stop offset="100%"></stop></linearGradient><path fill="url(#branding-gradient)" d="M376.5,51c-61.654,0-101.78,30.666-120.5,49.342C237.28,81.666,197.154,51,135.5,51C56.541,51,0,115.444,0,192.667    c0,45.362,20.417,92.318,59.043,135.791c42.54,47.877,106.673,91.998,190.619,131.137c4.016,1.873,8.659,1.874,12.677,0    c83.946-39.139,148.079-83.26,190.619-131.137C491.583,284.984,512,238.029,512,192.667C512,115.483,455.491,51,376.5,51z     M298.873,270.121l-15.892,55.62c-2.275,7.962-10.575,12.579-18.544,10.302c-7.965-2.276-12.578-10.578-10.302-18.544L264.563,281    H227.55c-9.967,0-17.155-9.557-14.423-19.121l15.892-55.62c2.276-7.965,10.577-12.577,18.544-10.302    c7.965,2.276,12.578,10.578,10.302,18.544L247.437,251h37.013C294.417,251,301.605,260.557,298.873,270.121z"></path></svg><span>by <a href="https://apps.shopify.com/partners/ai-first" target="_blank">Pushdaddy</a></span></div>'
        : "";
    }


    function o() {

      setTimeout(function () {
        jQuery("#pushdaddy-share").addClass("hide_share");
      }, d.settings.style.customized.auto_hide_share);
      //	setTimeout(function() {jQuery("#pushdaddy-widget").addClass("hide_share");}, d.settings.style.customized.auto_hide_chat);

      //	console.log(d.settings.style.customized.auto_hide_chat);


      if (
        d.settings.style.customized.share_icons_display != "Whatsapp" &&
        d.settings.style.customized.updown_share == "30"
      ) {
        var share_position_finaal = "60";
      } else {
        var share_position_finaal = d.settings.style.customized.updown_share;
      }

      var share_position =
        "#pushdaddy-share{bottom: " + share_position_finaal + "%;}";

      setTimeout(function () {
        jQuery("head").append("<style>" + share_position + "</style>");

        // var fonturll = "https://fonts.googleapis.com/css?family=" + d.settings.style.customized.font.replace(/ /g, "+");
        // var fonturlltt = "https://fonts.googleapis.com/css?family=Lobster";

        // <link href="https://fonts.googleapis.com/css?family=Chewy" type="text/css" rel="stylesheet">

        // $('head').append(''+fonturlltt+'');
      }, 400);

      // var epop = document.createElement("link"),
      // npoi = document.getElementsByTagName("head")[0];
      // epop.setAttribute("href", "https://fonts.googleapis.com/css?family=" + d.settings.style.customized.font.replace(/ /g, "+")), epop.setAttribute("type", "text/css"), epop.setAttribute("rel", "stylesheet"), epop.onload = npoi.insertBefore(epop, npoi.firstChild);

      // jQuery('head').append('<link href="https://fonts.googleapis.com/css?family=Lobster" type="text/css" rel="stylesheet">');

      // if(d.settings.style.customized.secondary_button !='1')
      if (d.settings.style.customized.share_icons_display == "Whatsapp") {
        var e =
          '<%= widget_share_label %><div class="pushdaddy-button" id="toggle_merged"><%= widget_whatsapp_icon %></div>';
        return (e = e
          .replace(
            /<%= widget_share_label %>/g,
            d.settings.share.texts.button.length
              ? '<div class="pushdaddy-share-label"><span>' +
                  d.settings.share.texts.button +
                  "</span></div>"
              : ""
          )
          .replace(
            /<%= widget_whatsapp_icon %>/g,
            '<svg class="svg-whatsapp" viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path></svg>'
          ));
      } else {
        if (
          d.settings.style.customized.share_trans != "1" &&
          d.settings.style.customized.share_trans != ""
        ) {
          var sharebggg = "";
        } else {
          var sharebggg = "background-color: transparent;";
        }

        var onlysizeee = d.settings.style.customized.share_size + "px";

        if (d.settings.style.customized.share_radius != "") {
          var final_share_radius = d.settings.style.customized.share_radius;
        } else {
          var final_share_radius = "0";
        }

        var share_iconnss = d.settings.style.customized.share_icons_display;
        var sizingggg =
          'style="width:' +
          d.settings.style.customized.share_size +
          "px;height:" +
          d.settings.style.customized.share_size +
          "px;line-height:" +
          d.settings.style.customized.share_size +
          "px;border-radius: " +
          final_share_radius +
          "%; " +
          sharebggg +
          '"';

        var siteaddress = window.location;

        if (share_iconnss.indexOf("Telegram") !== -1) {
          var linksharewapp =
            "https://telegram.me/share/url?url=" +
            siteaddress +
            "";

          var telegramss =
            '<li class="li-social telegram-social"><a ' +
            sizingggg +
            ' title="Telegram" href="' +
            linksharewapp +
            '" target="_blank"><span style="line-height:' +
            onlysizeee +
            ';" class="fa fa-telegram-plane icon-social"></span></a></li>';
        }

        if (share_iconnss.indexOf("Whatsapp") !== -1) {
          // var opoal = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
          var opoaluu =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
              navigator.userAgent
            ) && !window.MSStream;

    var IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;


          if (true == opoaluu) {
			 if (true == IOS) {  
		            var pathhhughgg = "whatsapp://send";
	  
			 }
			 else
			 {
            var pathhhughgg = "https://api.whatsapp.com/send";
			 }
          } else {
            // var pathhhughgg= "https://api.whatsapp.com/send";
            var pathhhughgg = "https://web.whatsapp.com/send";
          }
		  	  
		  
		  

          var linksharewapp = pathhhughgg + "?text=" + siteaddress + "";
          var whatsapp =
            '<li class="li-social whatsapp-social"><a ' +
            sizingggg +
            ' title="Whatsapp" href="' +
            linksharewapp +
            '" target="_blank"><span style="line-height:' +
            onlysizeee +
            ';" class="fa fa-whatsapp icon-social"></span></a></li>';
        }
        if (share_iconnss.indexOf("Facebook") !== -1) {
          var linksharewapp =
            "https://www.facebook.com/sharer/sharer.php?u=" + siteaddress + "";
          var facebook =
            '<li class="li-social facebook-social"><a ' +
            sizingggg +
            ' title="Facebook" href="' +
            linksharewapp +
            '" target="_blank"><span style="line-height:' +
            onlysizeee +
            ';" class="fa fa-facebook-f icon-social"></span></a></li>';
        }

        if (share_iconnss.indexOf("Instagram") !== -1) {
          var linksharewapp =
            "https://www.instagram.com/sharer.php?u=" + siteaddress + "";

          var instagram =
            '<li class="li-social instagram-social"><a ' +
            sizingggg +
            ' title="Instagram" href="' +
            linksharewapp +
            '" target="_blank"><span style="line-height:' +
            onlysizeee +
            ';" class="fa fa-instagram icon-social"></span></a></li>';
        }

        if (share_iconnss.indexOf("Twitter") !== -1) {
          var linksharewapp =
            "https://twitter.com/intent/tweet?url=" + siteaddress + "";

          var twitter =
            '<li class="li-social twitter-social"><a ' +
            sizingggg +
            ' title="twitter" href="' +
            linksharewapp +
            '" target="_blank"><span style="line-height:' +
            onlysizeee +
            ';" class="fa fa-twitter icon-social"></span></a></li>';
        }

        if (share_iconnss.indexOf("Pinterest") !== -1) {
          var linksharewapp =
            "http://pinterest.com/pin/create/button/?url=" + siteaddress + "";

          var pinterest =
            '<li class="li-social pinterest-social"><a ' +
            sizingggg +
            ' title="pinterest" href="' +
            linksharewapp +
            '" target="_blank"><span style="line-height:' +
            onlysizeee +
            ';" class="fa fa-pinterest-p icon-social"></span></a></li>';
        }

        if (share_iconnss.indexOf("Reddit") !== -1) {
          var linksharewapp =
            "https://reddit.com/submit?url=" + siteaddress + "";

          var reddit =
            '<li class="li-social reddit-social"><a ' +
            sizingggg +
            ' title="Reddit" href="' +
            linksharewapp +
            '" target="_blank"><span style="line-height:' +
            onlysizeee +
            ';" class="fa fa-reddit-alien icon-social"></span></a></li>';
        }

        if (share_iconnss.indexOf("VK") !== -1) {
          var linksharewapp =
            "https://vk.com/share.php?act=count&url=" + siteaddress + "";
          var vk =
            '<li class="li-social vk-social"><a ' +
            sizingggg +
            ' title="vk" href="' +
            linksharewapp +
            '" target="_blank"><span  style="line-height:' +
            onlysizeee +
            ';"  class="fa fa-vk icon-social"></span></a></li>';
        }

        if (share_iconnss.indexOf("Snapchat") !== -1) {
          var linksharewapp =
            "https://snapchat.com/scan?attachmentUrl=" + siteaddress + "";
          var snapchat =
            '<li class="li-social snapchat-social"><a ' +
            sizingggg +
            ' title="snapchat" href="' +
            linksharewapp +
            '" target="_blank"><span style="line-height:' +
            onlysizeee +
            ';" class="fa fa-snapchat icon-social"></span></a></li>';
        }
        if (share_iconnss.indexOf("Wechat") !== -1) {
          var linksharewapp =
            "https://web.whatsapp.com/send?text=" + siteaddress + "";

          var wechat =
            '<li class="li-social wechat-social"><a ' +
            sizingggg +
            ' title="wechat" href="' +
            linksharewapp +
            '" target="_blank"><span style="line-height:' +
            onlysizeee +
            ';" class="fa fa-weixin icon-social"></span></a></li>';
        }

        var final_ee =
          '<div class="socials-wrap left hidden-sm hidden-xs"><ul style="padding-left:0px">' +
          whatsapp +
          "   " +
          facebook +
          " " +
          instagram +
          " " +
          twitter +
          "  " +
          pinterest +
          "  " +
          reddit +
          "  " +
          vk +
          "  " +
          snapchat +
          "  " +
          wechat +
          "  " +
          telegramss +
          "</ul></div>";

        var e = final_ee
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "");

        return e;
      }
    }

    function g() {
		

      if (d.settings.style.customized.font_size == "") {
        var label_fontsizee = "font-size: 14px;";
      } else {
        var label_fontsizee =
          "font-size: " + d.settings.style.customized.font_size + "px;";
      }

      if (d.settings.style.pattern == "100") {
        var colooorrs = d.settings.style.customized.secondary_button_tcolor;
      } else {
        var colooorrs = "#FFFFFF";
      }

      var final_background_img_url = d.settings.style.customized.background_img;

      var final_background_img_url2 =
        d.settings.style.customized.background_img_main;

      if (d.settings.style.customized.icon_width <= 70) {
		  
		            var smallimgiconpp = d.settings.style.customized.background_img_main;

   if (smallimgiconpp.match("1905.png")) 
	  {
		        var final_widthhhtt = '70';
		        var final_heighttt = '70';
  
	  }
		else
		{
        var final_heighttt = d.settings.style.customized.icon_width;

		}
		
		  
        var svg_imgggg_width_height =
          d.settings.style.customized.icon_width * 0.6;
        var svg_imgggg_marginn = d.settings.style.customized.icon_width * 0.3;
        //	var lable_marginnn = d.settings.style.customized.icon_width*0.3;
        var leeftt_marginnn = "50";
        //var lable_rightt_marginnn = 'right: 100%;';

        if (d.settings.desktop.position != "left") {
          var lable_marginnn = d.settings.style.customized.icon_width / 4;

          if (d.settings.style.customized.leftt_rightt <= 50) {
            var left_right_secondary_first = "right";
          } else {
            var left_right_secondary_first = "left";
          }

          // this is for secondary button
          if (d.settings.style.customized.leftt_rightt_sec <= 50) {
            var left_right_secondary = "right";
            // var lable_rightt_marginnn_secon = 'right: unset;';
            //	var lable_rightt_marginnn_secon = 'right: unset;';
          } else {
            var left_right_secondary = "left";
            //	var lable_rightt_marginnn_secon = 'right: unset;';
          }
          // secondary button setting ends here
          var left_right_secondary_first2 =
            d.settings.style.customized.final_leftright_second_position;
          var lable_rightt_marginnn_secon =
            "" + left_right_secondary_first2 + ": 100%;";
        } else {
          var lable_marginnn = d.settings.style.customized.icon_width / 4;

          if (d.settings.style.customized.leftt_rightt <= 50) {
            var left_right_secondary_first = "left";
          } else {
            var left_right_secondary_first = "right";
          }

          // this is for secondary button
          if (d.settings.style.customized.leftt_rightt_sec <= 50) {
            var left_right_secondary = "right";
            //var lable_rightt_marginnn_secon = 'right: unset;';
          } else {
            var left_right_secondary = "left";
            //	var lable_rightt_marginnn_secon = 'right: unset;';
          }

          var left_right_secondary_first2 =
            d.settings.style.customized.final_leftright_second_position;
          var lable_rightt_marginnn_secon =
            "" + left_right_secondary_first2 + ": 100%;";

          // secondary button setting ends here
        }

        var lable_rightt_marginnn = ";";
        var lable_paddinggg1 = d.settings.style.customized.icon_width / 6;
        var lable_paddinggg2 = d.settings.style.customized.icon_width / 4;
   //     var lable_bgroundcolor = ";";
   		var lable_bgroundcolor = 'background-color: '+d.settings.style.customized.label_bgcolor+';';

        //var lable_bgroundcolor2 = 'background-color: '+d.settings.style.customized.secondary_button_bgcolor+';color: '+d.settings.style.customized.secondary_button_tcolor+';box-shadow:none;';

        if (d.settings.style.customized.remove_bg == "1") {
          var lable_bgroundcolor2 =
            "background-color: transparent;color: " +
            colooorrs +
            ";box-shadow:none;";
        } else {
          var lable_bgroundcolor2 =
            "background-color: " +
            d.settings.style.customized.secondary_button_bgcolor +
            ";color: " +
            colooorrs +
            ";box-shadow:none;";
        }

        //		var lable_bgroundcolor2 = ';';
        var lable_bgroundcolor21 =
          "background-color: transparent;color: " +
          d.settings.style.customized.secondary_button_lcolor +
          ";box-shadow:none;";
      } else {
		  
		  var final_widthhhtt = d.settings.style.customized.icon_width; 
		  
        if (d.settings.style.customized.icon_width <= 130) {
          //	var final_heighttt = d.settings.style.customized.icon_width/3;
          if (d.settings.style.customized.compact_normal == "0") {
            var final_heighttt = d.settings.style.customized.icon_width / 3;
          } else if (d.settings.style.customized.compact_normal == "1") {
            // var final_heighttt = d.settings.style.customized.icon_width/3-5;
            var final_heighttt =
              parseFloat(d.settings.style.customized.icon_width / 3, 10) - 5;
          } else if (d.settings.style.customized.compact_normal == "2") {
            // var final_heighttt = d.settings.style.customized.icon_width/3-10;
            var final_heighttt =
              parseFloat(d.settings.style.customized.icon_width / 3, 10) - 10;
          } else if (d.settings.style.customized.compact_normal == "3") {
            var final_heighttt = d.settings.style.customized.icon_width / 2;
          } else {
            var final_heighttt = d.settings.style.customized.icon_width / 3;
          }

          var svg_imgggg_width_height =
            d.settings.style.customized.icon_width * 0.2;
          var svg_imgggg_marginn = d.settings.style.customized.icon_width * 0.1;
          var leeftt_marginnn = d.settings.style.customized.icon_position;
          if (d.settings.desktop.position != "left") {
            if (d.settings.style.customized.leftt_rightt <= 50) {
              var lable_rightt_marginnn = "right: unset;";
              var left_right_secondary_first = "right";
            } else {
              var lable_rightt_marginnn = "right: unset;";
              var left_right_secondary_first = "left";
            }

            // this is for secondary button
            if (d.settings.style.customized.leftt_rightt_sec <= 50) {
              var left_right_secondary = "right";
              var lable_rightt_marginnn_secon = "right: unset;";
            } else {
              var left_right_secondary = "left";
              var lable_rightt_marginnn_secon = "right: unset;";
            }
            // secondary button setting ends here
            var left_right_secondary_first2 =
              d.settings.style.customized.final_leftright_second_position;
          } else {
            if (d.settings.style.customized.leftt_rightt <= 50) {
              var lable_rightt_marginnn = "left: unset;";
              var left_right_secondary_first = "left";
            } else {
              var lable_rightt_marginnn = "left: unset;";
              var left_right_secondary_first = "right";
            }

            // this is for secondary button
            if (d.settings.style.customized.leftt_rightt_sec <= 50) {
              var left_right_secondary = "right";
              var lable_rightt_marginnn_secon = "right: unset;";
            } else {
              var left_right_secondary = "left";
              var lable_rightt_marginnn_secon = "right: unset;";
            }

            var left_right_secondary_first2 =
              d.settings.style.customized.final_leftright_second_position;

            // secondary button setting ends here
          }
          var lable_paddinggg1 = "4";
          var lable_paddinggg2 = "4";
          // var lable_bgroundcolor = "background-color: transparent;color: " + d.settings.style.customized.color +";box-shadow:none;";

  //        var lable_bgroundcolor = "background-color: transparent;color: " + d.settings.style.customized.color +";box-shadow:none;";
          var lable_bgroundcolor = "background-color: transparent;color: " + d.settings.style.customized.chatnow_color +";box-shadow:none;";



          if (d.settings.style.customized.remove_bg == "1") {
            var lable_bgroundcolor2 =
              "background-color: transparent;color: " +
              colooorrs +
              ";box-shadow:none;";
          } else {
            var lable_bgroundcolor2 =
              "background-color: " +
              d.settings.style.customized.secondary_button_bgcolor +
              ";color: " +
              colooorrs +
              ";box-shadow:none;";
          }

          //	var lable_bgroundcolor2 = 'background-color: transparent;color: '+d.settings.style.customized.secondary_button_tcolor+';box-shadow:none;';
          var lable_bgroundcolor21 =
            "background-color: transparent;color: " +
            d.settings.style.customized.secondary_button_lcolor +
            ";box-shadow:none;";

          //		var lable_bgroundcolor2 = 'background-color: transparent;color: '+d.settings.style.customized.secondary_button_tcolor+';box-shadow:none;';

          // var lable_marginnn = d.settings.style.customized.icon_width*0.3-5;
          var lable_marginnn =
            parseFloat(d.settings.style.customized.icon_width * 0.3, 10) - 5;
        } else {
          //	var final_heighttt = '45';
          if (d.settings.style.customized.compact_normal == "0") {
            var final_heighttt = 45;
          } else if (d.settings.style.customized.compact_normal == "1") {
            var final_heighttt = 35;
          } else if (d.settings.style.customized.compact_normal == "2") {
            var final_heighttt = 30;
          } else if (d.settings.style.customized.compact_normal == "3") {
            var final_heighttt = 55;
          } else {
            var final_heighttt = d.settings.style.customized.icon_width / 3;
          }

          var svg_imgggg_width_height = "26";
          var svg_imgggg_marginn = "13";
          var leeftt_marginnn = d.settings.style.customized.icon_position;
          if (d.settings.desktop.position != "left") {
            if (d.settings.style.customized.leftt_rightt <= 50) {
              var lable_rightt_marginnn = "right: unset;";
              var left_right_secondary_first = "right";
            } else {
              var lable_rightt_marginnn = "right: unset;";
              var left_right_secondary_first = "left";
            }

            // this is for secondary button
            if (d.settings.style.customized.leftt_rightt_sec <= 50) {
              var left_right_secondary = "right";
              var lable_rightt_marginnn_secon = "right: unset;";
            } else {
              var left_right_secondary = "left";
              var lable_rightt_marginnn_secon = "right: unset;";
            }
            // secondary button setting ends here

            var left_right_secondary_first2 =
              d.settings.style.customized.final_leftright_second_position;
          } else {
            if (d.settings.style.customized.leftt_rightt <= 50) {
              var lable_rightt_marginnn = "left: unset;";
              var left_right_secondary_first = "left";
            } else {
              var lable_rightt_marginnn = "left: unset;";
              var left_right_secondary_first = "right";
            }

            // this is for secondary button
            if (d.settings.style.customized.leftt_rightt_sec <= 50) {
              var left_right_secondary = "right";
              var lable_rightt_marginnn_secon = "right: unset;";
            } else {
              var left_right_secondary = "left";
              var lable_rightt_marginnn_secon = "right: unset;";
            }

            var left_right_secondary_first2 =
              d.settings.style.customized.final_leftright_second_position;

            // secondary button setting ends here
          }
          var lable_paddinggg1 = "4";
          var lable_paddinggg2 = "4";
    //      var lable_bgroundcolor ="background-color: transparent;color: " + d.settings.style.customized.color + ";box-shadow:none;";
var lable_bgroundcolor ="background-color: transparent;color: " + d.settings.style.customized.chatnow_color + ";box-shadow:none;";



		  // var lable_bgroundcolor2 = 'background-color: '+d.settings.style.customized.secondary_button_bgcolor+';color: '+d.settings.style.customized.secondary_button_tcolor+';box-shadow:none;';
          if (d.settings.style.customized.remove_bg == "1") {
            var lable_bgroundcolor2 =
              "background-color: transparent;color: " +
              colooorrs +
              ";box-shadow:none;";
          } else {
            var lable_bgroundcolor2 =
              "background-color: " +
              d.settings.style.customized.secondary_button_bgcolor +
              ";color: " +
              colooorrs +
              ";box-shadow:none;";
          }

          //	var lable_bgroundcolor2 = 'background-color: transparent;color: '+d.settings.style.customized.secondary_button_tcolor+';box-shadow:none;';
          var lable_bgroundcolor21 =
            "background-color: transparent;color: " +
            d.settings.style.customized.secondary_button_lcolor +
            ";box-shadow:none;";

          //	var lable_bgroundcolor2 = 'background-color: transparent;color: '+d.settings.style.customized.secondary_button_tcolor+';box-shadow:none;';

          var lable_marginnn = "34";
        }
      }

      if (
        d.settings.style.customized.leftright_label == "" ||
        d.settings.style.customized.leftright_label == "0" ||
        d.settings.style.customized.leftright_label === undefined
      ) {
        var lable_marginnn_finnnnn = lable_marginnn;
      } else {
        var lable_marginnn_finnnnn =
          d.settings.style.customized.leftright_label;
      }

      if (d.settings.style.customized.compact_normal == "3") {
        if (d.settings.style.customized.icon_width >= 70) {
          var svg_imgggg_width_height_finaluu = svg_imgggg_width_height * 1.4;

          if (svg_imgggg_width_height_finaluu <= "25") {
            var svg_imgggg_width_height_final = "25";
          } else {
            var svg_imgggg_width_height_final = svg_imgggg_width_height_finaluu;
          }

          var lable_marginnn_finnnnn_finaaalll =
            parseFloat(lable_marginnn_finnnnn, 10) + 6;

          var svg_imgggg_marginn = svg_imgggg_width_height_final / 2;
          var svg_imgggg_marginn1_final = svg_imgggg_marginn;

          //console.log('333331111');
        } else {
          var svg_imgggg_width_height_final = svg_imgggg_width_height * 1.4;
          var lable_marginnn_finnnnn_finaaalll = "10";
          var svg_imgggg_marginn = svg_imgggg_width_height_final / 2;
          var svg_imgggg_marginn1_final = svg_imgggg_marginn;
          //console.log('333332222');
        }
      } else if (d.settings.style.customized.compact_normal == "0") {
        if (d.settings.style.customized.icon_width >= 70) {
          var svg_imgggg_width_height_finaluu = svg_imgggg_width_height * 1.2;

          if (svg_imgggg_width_height_finaluu <= "25") {
            var svg_imgggg_width_height_final = "25";
          } else {
            var svg_imgggg_width_height_final = svg_imgggg_width_height_finaluu;
          }

          // var lable_marginnn_finnnnn_finaaalll = parseFloat(lable_marginnn_finnnnn, 10) + 6;
          var lable_marginnn_finnnnn_finaaalll = parseFloat(
            lable_marginnn_finnnnn,
            10
          );

          var svg_imgggg_marginn = svg_imgggg_width_height_final / 2;
          var svg_imgggg_marginn1_final = svg_imgggg_marginn;
          //console.log('00001111');
        } else {
          var svg_imgggg_width_height_final = svg_imgggg_width_height * 1.2;
          var lable_marginnn_finnnnn_finaaalll = "10";
          var svg_imgggg_marginn = svg_imgggg_width_height_final / 2;
          var svg_imgggg_marginn1_final = svg_imgggg_marginn;
          //console.log('00001111');
        }
      } else if (d.settings.style.customized.compact_normal == "1") {
        if (d.settings.style.customized.icon_width >= 70) {
          var svg_imgggg_width_height_finaluu = svg_imgggg_width_height * 1.1;

          if (svg_imgggg_width_height_finaluu <= "25") {
            var svg_imgggg_width_height_final = "25";
          } else {
            var svg_imgggg_width_height_final = svg_imgggg_width_height_finaluu;
          }

          // var lable_marginnn_finnnnn_finaaalll = parseFloat(lable_marginnn_finnnnn, 10) + 6;
          var lable_marginnn_finnnnn_finaaalll = parseFloat(
            lable_marginnn_finnnnn,
            10
          );

          var svg_imgggg_marginn = svg_imgggg_width_height_final / 2;
          var svg_imgggg_marginn1_final = svg_imgggg_marginn;
          //console.log('111111300000');
        } else {
          var svg_imgggg_width_height_final = svg_imgggg_width_height * 1.1;
          var lable_marginnn_finnnnn_finaaalll = "10";
          var svg_imgggg_marginn = svg_imgggg_width_height_final / 2;
          var svg_imgggg_marginn1_final = svg_imgggg_marginn;
          //console.log('11111131111');
        }
      } else if (d.settings.style.customized.compact_normal == "2") {
        if (d.settings.style.customized.icon_width >= 70) {
          var svg_imgggg_width_height_finaluu = svg_imgggg_width_height * 1.0;

          if (svg_imgggg_width_height_finaluu <= "25") {
            var svg_imgggg_width_height_final = "25";
          } else {
            var svg_imgggg_width_height_final = svg_imgggg_width_height_finaluu;
          }
          // var lable_marginnn_finnnnn_finaaalll = parseFloat(lable_marginnn_finnnnn, 10) + 6;
          var lable_marginnn_finnnnn_finaaalll = parseFloat(
            lable_marginnn_finnnnn,
            10
          );

          var svg_imgggg_marginn = svg_imgggg_width_height_final / 2;
          var svg_imgggg_marginn1_final = svg_imgggg_marginn;
          //console.log('222222000000');
        } else {
          var svg_imgggg_width_height_final = svg_imgggg_width_height * 1.0;
          var lable_marginnn_finnnnn_finaaalll = "10";
          var svg_imgggg_marginn = svg_imgggg_width_height_final / 2;
          var svg_imgggg_marginn1_final = svg_imgggg_marginn;
          //console.log('222221111');
        }
      } else {
        var svg_imgggg_marginn = svg_imgggg_width_height / 2;
        var svg_imgggg_width_height_final = svg_imgggg_width_height;
        var svg_imgggg_marginn1_final = svg_imgggg_marginn;
        var lable_marginnn_finnnnn_finaaalll = lable_marginnn_finnnnn;
        //console.log('88888333331111');
      }

      // new code ends hereee
	  if(d.settings.style.customized.font != 'Helvetica')
	  {
      var fonturllpp =
        "https://fonts.googleapis.com/css?family=" +
        d.settings.style.customized.font.replace(/ /g, "+");
      var faviconuu = document.createElement("link");
      faviconuu.rel = "stylesheet";
      faviconuu.type = "text/css";
      faviconuu.href = fonturllpp;
      document.head.appendChild(faviconuu);
	  }
      setTimeout(function () {
        if (d.settings.style.customized.extend_header_img == "1") {
          jQuery(".pushdaddy-note").css("background", "transparent");
        }

        if (
          d.settings.style.customized.header_bg_color != "" &&
          d.settings.style.customized.header_bg_color != "#"
        ) {
          jQuery(".pushdaddy-note").css("background", "transparent");
        }
      }, 1300);

      // settimeout ends here

      if (d.settings.style.customized.secondary_text.length == "0") {
        var display_yn333 = "display:none;";
      } else {
        var display_yn333 = "display:inline;";
      }
      var fb_page_id = d.settings.style.customized.secondary_button_link.replace(
        "https://m.me/",
        ""
      );

      if (d.settings.style.customized.secondary_button == "0") {
        var secondary_btnn = "";
      } else {
        if (d.settings.style.customized.secondary_button == "1") {
          var svgpathh =
            '<path d="M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"></path>';

          setTimeout(function () {
            jQuery("body").append("<div class='pdFacbookChat'></div>");
          }, 400);

          var greeting_message = d.block.chat.greeting
            .replace(/&/g, "&amp;")
            .replace(/>/g, "&gt;")
            .replace(/</g, "&lt;")
            .replace(/"/g, "&quot;");

          var fbfiless =
            '<style>.fb_iframe_widget iframe {right: 90.29999999999995px!important;bottom: 60px!important;min-height: 0!important;}@media screen and (max-width:768px) {.fb_iframe_widget iframe {right: 1px!important;bottom: 80px!important;bottom: 60px!important;width: 255px;}.fb_iframe_widget.fb_iframe_widget_fluid iframe.fb_customer_chat_bounce_in_v2_mobile_chat_started {right: 0px!important;}}.fb_dialog {right: 10%!important;}.fb_dialog {display: none!important;}.fb_dialog.fb_dialog_mobile{bottom: -100px!important;width: 0px!important;display: block!important;}.pd-fb-logo.facebook-chat-button {display: none!important;background-color: #ffffff;fill: #0084FF;box-shadow: 0 3pt 12pt rgba(0,0,0,.15);border-radius: 30px;width: auto;}.pd-fb-logo.facebook-chat-button.medium svg {width: 32px;height: 32px;}.pd-fb-logo.facebook-chat-button.medium span {font-size: 16px;margin-top: 3px;}.pd-fb-logo.facebook-chat-button.small svg {width: 24px;height: 24px;}.pd-fb-logo.facebook-chat-button.small span {font-size: 14px;margin-top: 2px;}.pd-fb-logo.facebook-chat-button.large {}.pd-fb-logo.facebook-chat-button.large svg {width: 40px;height: 40px;}.pd-fb-logo.facebook-chat-button.large span {font-size: 20px;margin-top: 3px;}</style><div id="fb-root"></div><script>window.fbAsyncInit = function() {FB.init({appId: "1912261035577226",autoLogAppEvents : true,xfbml: true,version: "v7.0" });};(function(d, s, id) {var js, fjs =d.getElementsByTagName(s)[0];js = d.createElement(s); js.id = id;js.src ="https://connect.facebook.net/en_GB/sdk/xfbml.customerchat.js";fjs.parentNode.insertBefore(js, fjs);}(document, "script", "facebook-jssdk"));</script>';

          setTimeout(function () {
            jQuery(".pdFacbookChat").append(fbfiless);
          }, 700);

          var fbchatt =
            '<div class="fb-customerchat" attribution="setup_tool" fb-xfbml-state="rendered" page_id="' +
            fb_page_id +
            '" themeColor="' +
            d.settings.style.customized.secondary_button_bgcolor +
            '" logged_in_greeting="' +
            greeting_message +
            '" logged_out_greeting="' +
            greeting_message +
            '" rel="' +
            d.shop +
            '" greeting_dialog_display="fade" greeting_dialog_delay="999999999"></div>';

          setTimeout(function () {
            jQuery(document).on("click", ".pd-fb-logo", function (e) {
              var object = jQuery(
                ".fb-customerchat.fb_invisible_flow.fb_iframe_widget iframe"
              );

              // var object222 = jQuery(".fb-customerchat.fb_invisible_flow.fb_iframe_widget.fb_iframe_widget_fluid iframe");

              jQuery("#fb-root").css("display", "block");
              let window_width = jQuery(window).outerWidth();
              //  if (window_width < 800) {
              //     if (jQuery(".pd-fb-logo.redirect_icon").length > 0) {
              //    window.open("https://www.messenger.com/t/" + fb_page_id, "_blank");
              //     }
              //   }

              if (object.css("max-height") === "0px") {
                FB.Event.subscribe(
                  "customerchat.dialogShow",
                  processShowDialog(object)
                );
              } else {
                FB.Event.subscribe(
                  "customerchat.dialogHide",
                  processHideDialog(object)
                );
              }
            });
          }, 700);
        } else if (d.settings.style.customized.secondary_button == "2") {
          var svgpathh =
            '<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-46.0041" y1="634.1208" x2="-32.9334" y2="647.1917" gradientTransform="matrix(32 0 0 -32 1519 20757)"><stop  offset="0" style="stop-color:#FFC107"/><stop  offset="0.507" style="stop-color:#F44336"/><stop  offset="0.99" style="stop-color:#9C27B0"/></linearGradient><path style="fill:url(#SVGID_1_);" d="M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192 c88.352,0,160-71.648,160-160V160C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112 V160C48,98.24,98.24,48,160,48h192c61.76,0,112,50.24,112,112V352z"/><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="-42.2971" y1="637.8279" x2="-36.6404" y2="643.4846" gradientTransform="matrix(32 0 0 -32 1519 20757)"><stop  offset="0" style="stop-color:#FFC107"/><stop  offset="0.507" style="stop-color:#F44336"/><stop  offset="0.99" style="stop-color:#9C27B0"/></linearGradient><path style="fill:url(#SVGID_2_);" d="M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128	S326.688,128,256,128z M256,336c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80 C336,300.096,300.096,336,256,336z"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="-35.5456" y1="644.5793" x2="-34.7919" y2="645.3331" gradientTransform="matrix(32 0 0 -32 1519 20757)"><stop  offset="0" style="stop-color:#FFC107"/><stop  offset="0.507" style="stop-color:#F44336"/><stop  offset="0.99" style="stop-color:#9C27B0"/></linearGradient><circle style="fill:url(#SVGID_3_);" cx="393.6" cy="118.4" r="17.056"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>';
        } else if (d.settings.style.customized.secondary_button == "3") {
          var svgpathh =
            '<g><g><path d="M192,32C86.112,32,0,103.776,0,192c0,46.624,23.808,89.888,65.824,120.608l-16.128,32.256	c-3.008,5.984-1.952,13.248,2.656,18.112C55.424,366.24,59.68,368,64,368c2.112,0,4.256-0.416,6.304-1.28l56.576-24.224	c26.528,8.032,54.816,10.464,83.2,8.832c8.832-0.448,15.616-8,15.136-16.832c-0.48-8.864-8.864-16.096-16.832-15.104 c-26.496,1.344-52.8-0.992-77.248-9.152c-3.712-1.216-7.744-1.024-11.36,0.48l-21.92,9.408l2.88-5.792	c3.68-7.36,1.152-16.352-5.856-20.704C54.912,268.672,32,231.648,32,192c0-70.592,71.776-128,160-128s160,57.408,160,128 c0,4.8-0.224,9.312-1.024,13.824c-1.568,8.704,4.256,17.024,12.928,18.56c8.832,1.632,16.992-4.224,18.56-12.928 C383.584,205.088,384,198.72,384,192C384,103.776,297.888,32,192,32z"/></g></g><g><g><path d="M457.76,415.712C491.968,391.52,512,356.64,512,320c0-70.592-71.776-128-160-128s-160,57.408-160,128		c0,78.176,87.04,141.28,188.928,125.792l76.768,32.928c2.016,0.832,4.192,1.28,6.304,1.28c4.32,0,8.576-1.76,11.648-5.056 c4.64-4.864,5.696-12.096,2.688-18.112L457.76,415.712z M429.056,396.096c-7.36,4.224-10.144,13.44-6.368,21.024l7.456,14.976			l-40.896-17.568c-1.984-0.832-4.16-1.28-6.304-1.28c-0.928,0-1.824,0.064-2.72,0.224C370.4,415.2,361.152,416,352,416 c-70.592,0-128-43.072-128-96c0-52.928,57.408-96,128-96s128,43.072,128,96C480,349.824,461.44,377.568,429.056,396.096z"/></g></g><g><g><path d="M128.64,128h-0.32c-8.832,0-15.84,7.168-15.84,16c0,8.832,7.328,16,16.16,16c8.832,0,16-7.168,16-16 C144.64,135.168,137.472,128,128.64,128z"/></g></g><g><g><path d="M256.64,128h-0.32c-8.832,0-15.84,7.168-15.84,16c0,8.832,7.328,16,16.16,16c8.832,0,16-7.168,16-16			C272.64,135.168,265.472,128,256.64,128z"/></g></g><g><g><path d="M304.64,272h-0.32c-8.864,0-15.84,7.168-15.84,16c0,8.832,7.328,16,16.16,16c8.832,0,16-7.168,16-16 C320.64,279.168,313.472,272,304.64,272z"/></g></g><g><g><path d="M400.64,272h-0.32c-8.832,0-15.84,7.168-15.84,16c0,8.832,7.36,16,16.16,16c8.832,0,16-7.168,16-16 C416.64,279.168,409.472,272,400.64,272z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>';
        } else if (d.settings.style.customized.secondary_button == "4") {
          var svgpathh =
            '<path d="M507.399,370.471c-1.376-2.304-9.888-20.8-50.848-58.816c-42.88-39.808-37.12-33.344,14.528-102.176			c31.456-41.92,44.032-67.52,40.096-78.464c-3.744-10.432-26.88-7.68-26.88-7.68l-76.928,0.448c0,0-5.696-0.768-9.952,1.76			c-4.128,2.496-6.784,8.256-6.784,8.256s-12.192,32.448-28.448,60.032c-34.272,58.208-48,61.28-53.6,57.664			c-13.024-8.416-9.76-33.856-9.76-51.904c0-56.416,8.544-79.936-16.672-86.016c-8.384-2.016-14.528-3.36-35.936-3.584			c-27.456-0.288-50.72,0.096-63.872,6.528c-8.768,4.288-15.52,13.856-11.392,14.4c5.088,0.672,16.608,3.104,22.72,11.424			c7.904,10.72,7.616,34.848,7.616,34.848s4.544,66.4-10.592,74.656c-10.4,5.664-24.64-5.888-55.2-58.72			c-15.648-27.04-27.488-56.96-27.488-56.96s-2.272-5.568-6.336-8.544c-4.928-3.616-11.84-4.768-11.84-4.768l-73.152,0.448			c0,0-10.976,0.32-15.008,5.088c-3.584,4.256-0.288,13.024-0.288,13.024s57.28,133.984,122.112,201.536			c59.488,61.92,127.008,57.856,127.008,57.856h30.592c0,0,9.248-1.024,13.952-6.112c4.352-4.672,4.192-13.44,4.192-13.44			s-0.608-41.056,18.464-47.104c18.784-5.952,42.912,39.68,68.48,57.248c19.328,13.28,34.016,10.368,34.016,10.368l68.384-0.96 C488.583,400.807,524.359,398.599,507.399,370.471z"/>';
        } else if (d.settings.style.customized.secondary_button == "5") {
          var svgpathh =
            '<path d="m74.414 480.548h-36.214l25.607-25.607c13.807-13.807 22.429-31.765 24.747-51.246-59.127-38.802-88.554-95.014-88.554-153.944 0-108.719 99.923-219.203 256.414-219.203 165.785 0 254.682 101.666 254.682 209.678 0 108.724-89.836 210.322-254.682 210.322-28.877 0-59.01-3.855-85.913-10.928-25.467 26.121-59.973 40.928-96.087 40.928z"/>';
        } else if (d.settings.style.customized.secondary_button == "6") {
          var svgpathh =
            '<path d="m74.414 480.548h-36.214l25.607-25.607c13.807-13.807 22.429-31.765 24.747-51.246-59.127-38.802-88.554-95.014-88.554-153.944 0-108.719 99.923-219.203 256.414-219.203 165.785 0 254.682 101.666 254.682 209.678 0 108.724-89.836 210.322-254.682 210.322-28.877 0-59.01-3.855-85.913-10.928-25.467 26.121-59.973 40.928-96.087 40.928z"/>';
        } else if (d.settings.style.customized.secondary_button == "7") {
          var svgpathh =
            '<path d="M226.735,1.636C111.259,14.518,17.472,106.202,2.285,221.396c-21.518,163.24,111.938,302.116,273.589,289.849 c59.464-4.513,115.124-31.086,158.736-71.759l3.746-3.492c4.309-4.018,4.544-10.768,0.526-15.076l-14.555-15.607 c-4.018-4.309-10.767-4.544-15.076-0.526l-7.803,7.277c-48.51,45.232-115.104,65.582-182.284,54.141			c-95.215-16.216-168.411-97.052-175.846-193.352C33.487,145.508,136.207,39.093,262.324,42.758			c116.288,3.381,207.009,102.616,207.009,218.953v15.622c0,24.934-21.486,44.932-46.921,42.46			C400.246,317.637,384,297.714,384,275.442v-94.108c0-5.892-4.776-10.667-10.667-10.667H352c-4.283,0-7.921,2.56-9.618,6.203			c-21.465-23.413-52.19-38.203-86.382-38.203c-64.698,0-117.333,52.635-117.333,117.333S191.302,373.334,256,373.334			c40.755,0,76.691-20.909,97.732-52.54c15.842,26.475,45.276,43.922,78.78,41.677c45.303-3.035,79.488-42.746,79.488-88.15V256			C512,105.202,380.931-15.566,226.735,1.636z M256,330.667c-41.167,0-74.667-33.5-74.667-74.667			c0-41.167,33.5-74.667,74.667-74.667c41.167,0,74.667,33.5,74.667,74.667C330.667,297.167,297.167,330.667,256,330.667z"/>';
        } else if (d.settings.style.customized.secondary_button == "8") {
          var svgpathh =
            '<path d="M502.05,407.127l-56.761-37.844L394.83,335.65c-9.738-6.479-22.825-4.355-30.014,4.873l-31.223,40.139				c-6.707,8.71-18.772,11.213-28.39,5.888c-21.186-11.785-46.239-22.881-101.517-78.23c-55.278-55.349-66.445-80.331-78.23-101.517 c-5.325-9.618-2.822-21.683,5.888-28.389l40.139-31.223c9.227-7.188,11.352-20.275,4.873-30.014l-32.6-48.905L104.879,9.956	C98.262,0.03,85.016-2.95,74.786,3.185L29.95,30.083C17.833,37.222,8.926,48.75,5.074,62.277				C-7.187,106.98-9.659,205.593,148.381,363.633s256.644,155.56,301.347,143.298c13.527-3.851,25.055-12.758,32.194-24.876 l26.898-44.835C514.956,426.989,511.976,413.744,502.05,407.127z"/><path d="M291.309,79.447c82.842,0.092,149.977,67.226,150.069,150.069c0,4.875,3.952,8.828,8.828,8.828 c4.875,0,8.828-3.952,8.828-8.828c-0.102-92.589-75.135-167.622-167.724-167.724c-4.875,0-8.828,3.952-8.828,8.828 C282.481,75.494,286.433,79.447,291.309,79.447z"/><path d="M291.309,132.412c53.603,0.063,97.04,43.501,97.103,97.103c0,4.875,3.952,8.828,8.828,8.828 c4.875,0,8.828-3.952,8.828-8.828c-0.073-63.349-51.409-114.686-114.759-114.759c-4.875,0-8.828,3.952-8.828,8.828 C282.481,128.46,286.433,132.412,291.309,132.412z"/><path d="M291.309,185.378c24.365,0.029,44.109,19.773,44.138,44.138c0,4.875,3.952,8.828,8.828,8.828 c4.875,0,8.828-3.952,8.828-8.828c-0.039-34.111-27.682-61.754-61.793-61.793c-4.875,0-8.828,3.952-8.828,8.828			C282.481,181.426,286.433,185.378,291.309,185.378z"/>';
        } else if (d.settings.style.customized.secondary_button == "9") {
          var svgpathh =
            '<path style="fill:#EBF0FA;"d="M135.876,280.962L10.105,225.93c-14.174-6.197-13.215-26.621,1.481-31.456L489.845,36.811	c12.512-4.121,24.705,7.049,21.691,19.881l-95.571,406.351c-2.854,12.14-17.442,17.091-27.09,9.19l-112.3-91.887L135.876,280.962z"/><path style="fill:#BEC3D2;" d="M396.465,124.56L135.876,280.962l31.885,147.899c2.86,13.269,18.5,19.117,29.364,10.981	l79.451-59.497l-65.372-53.499l193.495-191.693C410.372,129.532,403.314,120.449,396.465,124.56z"/><path style="fill:#AFB4C8;" d="M178.275,441.894c5.858,2.648,13.037,2.302,18.85-2.052l79.451-59.497l-32.686-26.749l-32.686-26.749	L178.275,441.894z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>';
        } else if (d.settings.style.customized.secondary_button == "10") {
          var svgpathh =
            '<path style="fill:#EBF0FA;"d="M135.876,280.962L10.105,225.93c-14.174-6.197-13.215-26.621,1.481-31.456L489.845,36.811	c12.512-4.121,24.705,7.049,21.691,19.881l-95.571,406.351c-2.854,12.14-17.442,17.091-27.09,9.19l-112.3-91.887L135.876,280.962z"/><path style="fill:#BEC3D2;" d="M396.465,124.56L135.876,280.962l31.885,147.899c2.86,13.269,18.5,19.117,29.364,10.981	l79.451-59.497l-65.372-53.499l193.495-191.693C410.372,129.532,403.314,120.449,396.465,124.56z"/><path style="fill:#AFB4C8;" d="M178.275,441.894c5.858,2.648,13.037,2.302,18.85-2.052l79.451-59.497l-32.686-26.749l-32.686-26.749	L178.275,441.894z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>';
        } else if (d.settings.style.customized.secondary_button == "11") {
          var svgpathh =
            '<path d="M501.94,374.42c-68.448-11.264-99.296-81.376-100.544-84.352c-0.096-0.192-0.16-0.384-0.288-0.576			c-3.488-7.104-4.32-12.96-2.4-17.408c3.744-8.768,18.08-13.312,27.552-16.32c2.752-0.864,5.344-1.696,7.488-2.528 c9.344-3.68,16-7.68,20.416-12.192c5.248-5.408,6.272-10.592,6.208-13.952c-0.16-8.192-6.432-15.488-16.448-19.04		c-3.36-1.376-7.232-2.112-11.136-2.112c-2.656,0-6.624,0.352-10.368,2.112c-8,3.744-15.168,5.792-21.344,6.08 c-3.264-0.16-5.568-0.864-7.072-1.536c0.192-3.2,0.384-6.496,0.608-9.888l0.096-1.472c2.208-34.656,4.928-77.76-6.528-103.36 c-7.84-17.536-18.368-32.608-31.328-44.832c-10.848-10.24-23.456-18.56-37.472-24.704c-24.352-10.752-47.072-12.352-58.464-12.352 h-0.032c-0.448,0-0.864,0-1.248,0c-3.168,0.032-8.32,0.096-8.8,0.096c-11.36,0-34.112,1.6-58.528,12.352 		c-13.984,6.144-26.528,14.432-37.344,24.672c-12.896,12.224-23.392,27.264-31.2,44.736c-11.456,25.568-8.736,68.672-6.56,103.296 v0.064c0.224,3.712,0.48,7.584,0.704,11.36c-1.664,0.736-4.384,1.568-8.384,1.568c-6.464,0-14.144-2.048-22.816-6.112	c-2.56-1.184-5.472-1.792-8.672-1.792c-5.152,0-10.624,1.504-15.328,4.288c-5.952,3.488-9.792,8.384-10.848,13.856 c-0.672,3.584-0.64,10.72,7.296,17.952c4.384,3.968,10.784,7.648,19.072,10.912c2.176,0.864,4.768,1.664,7.488,2.528	 c9.472,3.008,23.84,7.552,27.584,16.32c1.888,4.448,1.056,10.304-2.432,17.408c-0.096,0.192-0.192,0.384-0.256,0.576	c-0.896,2.048-9.056,20.448-25.792,39.872c-9.504,11.04-19.968,20.288-31.104,27.456c-13.6,8.768-28.288,14.464-43.68,16.992 c-6.048,0.992-10.368,6.368-10.016,12.48c0.096,1.76,0.512,3.52,1.248,5.216v0.032c2.464,5.728,8.128,10.56,17.344,14.816 c11.264,5.216,28.096,9.6,50.08,13.024c1.12,2.112,2.272,7.392,3.072,11.008c0.832,3.84,1.696,7.808,2.944,12			c1.344,4.544,4.8,9.984,13.728,9.984c3.392,0,7.264-0.768,11.776-1.632c6.592-1.28,15.616-3.04,26.848-3.04	c6.24,0,12.704,0.544,19.2,1.632c12.544,2.08,23.36,9.696,35.872,18.528c18.304,12.928,39.04,27.552,70.72,27.552		c0.864,0,1.728-0.032,2.592-0.096c1.024,0.064,2.336,0.096,3.68,0.096c31.68,0,52.416-14.624,70.72-27.52l0.032-0.032 c12.512-8.8,23.328-16.416,35.872-18.496c6.496-1.088,12.96-1.632,19.2-1.632c10.752,0,19.264,1.376,26.848,2.848		c4.96,0.96,8.8,1.44,11.776,1.44h0.288h0.288c6.528,0,11.328-3.584,13.152-9.824c1.216-4.128,2.08-7.968,2.944-11.90 c0.736-3.392,1.952-8.832,3.04-10.944c21.984-3.456,38.816-7.808,50.08-13.024c9.184-4.256,14.848-9.088,17.312-14.784	c0.736-1.696,1.184-3.456,1.28-5.28C512.308,380.788,507.988,375.38,501.94,374.42z"/>';
        } else {
          var svgpathh = "";
        }

        var updownn1 = d.settings.style.customized.updown_bottom;
        var updownn2 = d.settings.style.customized.updown_bottom2;
        if (updownn2 == "") {
          var updownn2_final = "0";
        } else {
          var updownn2_final = updownn2;
        }

        var updown_final =
          parseFloat(updownn1, 10) + parseFloat(updownn2_final, 10);

        if (d.settings.style.customized.secondary_button == "1") {
          var newtabornot = "";
          //var newtabornot ='onclick=" window.open(\''+d.settings.style.customized.secondary_button_link+'\',\'_blank\')"';
          var gtyytyttt =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
              navigator.userAgent
            ) && !window.MSStream;

          if (true == gtyytyttt) {
            var displayneoootr = "display:none;";
          } else {
            var displayneoootr = ";";
          }
        } else {
          var newtabornot =
            "onclick=\" window.open('" +
            d.settings.style.customized.secondary_button_link +
            "','_blank')\"";
        }
		
if (d.settings.style.customized.chatnow_color == "" || d.settings.style.customized.chatnow_color == undefined) 
		{
var lableeecoloooor ='black;';
		}

else
{
var lableeecoloooor = d.settings.style.customized.chatnow_color +";";

}	
	
	if (lableeecoloooor == undefined) 
	{
var lableeecoloooorff = 'black;';
	}

else

{
var lableeecoloooorff = lableeecoloooor;

}	
		
	 var final_widthhhttuuu = d.settings.style.customized.icon_width; 	

        var secondary_btnn =
          "" +
          fbchatt +
          '<div id="pushdaddy-widget1" ' +
          newtabornot +
          ' class="pushdaddy-position-' +
          left_right_secondary +
          ' pushdaddy-button"><div id="pushdaddy-button1" class="pushdaddy-button1 pd-fb-logo" style="width:' +
          final_widthhhttuuu +
          "px;height:" +
          final_heighttt +
          "px;border-radius: " +
          d.settings.style.customized.border_radius +
          "px;bottom: " +
          updown_final +
          "px;" +
          lable_bgroundcolor2 +
          " " +
          left_right_secondary_first2 +
          ":" +
          d.settings.style.customized.leftt_rightt_sec +
          "%; " +
          displayneoootr +
          '"><div class="pushdaddy-button-label1" style="margin:0 ' +
          lable_marginnn +
          "px;color:" +
          lableeecoloooorff +
          ";padding:" +
          lable_paddinggg1 +
          "px " +
          lable_paddinggg1 +
          "px; " +
          lable_rightt_marginnn_secon +
          "  " +
          display_yn333 +
          " font-family: " +
          d.settings.style.customized.font +
          ";font-weight: " +
          d.settings.style.customized.font_weight +
          "; " +
          label_fontsizee +
          " " +
          lable_bgroundcolor21 +
          ' ">' +
          d.settings.style.customized.secondary_text +
          '</div><svg class="svg-whatsapp" style="width:' +
          svg_imgggg_width_height_final +
          "px;height:" +
          svg_imgggg_width_height_final +
          "px;margin-top: -" +
          svg_imgggg_marginn1_final +
          "px;margin-left: -" +
          svg_imgggg_marginn +
          "px;left:" +
          leeftt_marginnn +
          '%;" viewBox="0 0 512 512">' +
          svgpathh +
          "</svg></div></div>";

      }

      // if(d.settings.style.customized.background_img_main =='' || d.settings.style.customized.background_img_main === undefined && d.settings.style.customized.background_img =='')

      // new code starts from here

      if (
        d.settings.style.customized.background_img_main == "" &&
        d.settings.style.customized.background_img == ""
      ) {
        var hidesvg = ";";
        var hidesvg2 = "display:none;";
        var bgimgicon = "";
        var smallimgicon = "";
        var transparenttt = ";";

        //console.log('11111');
      } else {
        if (d.settings.style.customized.icon_width <= 70) {
          var hidesvg2 = "display:none;";
          var bgimgicon = "";
          var smallimgicon = d.settings.style.customized.background_img_main;

   if (smallimgicon.match("1905.png")) 
	  {
    var transparenttt =
            "--pushdaddy-background: transparent;--pushdaddy-box-shadow: none;background-size: 50px;";
	  }	
else
{
 var transparenttt =
            "--pushdaddy-background: transparent;--pushdaddy-box-shadow: none;background-size: contain;";	
}
		  
		  
		  
		  
         
        } else {
          var hidesvg2 = "display:inline;";
          var bgimgicon = d.settings.style.customized.background_img_main;

          var smallimgicon = "";

          //	console.log('3333');

          var transparenttt = ";";
        }

        var hidesvg = "display:none;";
      }

      // new code ends hereeeeee e

      // here we are trying path filtering
      var allowed_path = d.settings.style.customized.pages_display;
      var replace_danta = allowed_path.replace("/", "/");
      var nameArr = replace_danta.split(",");
      //	var finallnamee = nameArr[0] + nameArr[1] + nameArr[2] + nameArr[3] + nameArr[4] + nameArr[5] + nameArr[6] + nameArr[7];

      if (
        window.location.pathname.match("(.*)/collections/(.*)") ||
        window.location.pathname.match("(.*)/collections")
      ) {
        if (
          nameArr[0] == "/collections/" ||
          nameArr[1] == "/collections/" ||
          nameArr[2] == "/collections/" ||
          nameArr[3] == "/collections/" ||
          nameArr[4] == "/collections/" ||
          nameArr[5] == "/collections/" ||
          nameArr[6] == "/collections/" ||
          nameArr[7] == "/collections/" ||
          nameArr[8] == "/collections/"
        ) {
          var display_yn_main = ";";
        } else {
          var display_yn_main = "display:none;";
        }
      }

      if (
        window.location.pathname.match("(.*)/cart/(.*)") ||
        window.location.pathname.match("(.*)/cart") ||
        window.location.pathname.match("(.*)/orders/(.*)") ||
        window.location.pathname.match("(.*)/orders")
      ) {
        if (
          nameArr[0] == "/cart/" ||
          nameArr[1] == "/cart/" ||
          nameArr[2] == "/cart/" ||
          nameArr[3] == "/cart/" ||
          nameArr[4] == "/cart/" ||
          nameArr[5] == "/cart/" ||
          nameArr[6] == "/cart/" ||
          nameArr[7] == "/cart/" ||
          nameArr[8] == "/cart/" ||
          nameArr[0] == "/orders/" ||
          nameArr[1] == "/orders/" ||
          nameArr[2] == "/orders/" ||
          nameArr[3] == "/orders/" ||
          nameArr[4] == "/orders/" ||
          nameArr[5] == "/orders/" ||
          nameArr[6] == "/orders/" ||
          nameArr[7] == "/orders/" ||
          nameArr[8] == "/orders/"
        ) {
          var display_yn_main = ";";
        } else {
          var display_yn_main = "display:none;";
        }
      }

      if (
        window.location.pathname.match("(.*)/products/(.*)") ||
        window.location.pathname.match("(.*)/products")
      ) {
        if (
          nameArr[0] == "/products/" ||
          nameArr[1] == "/products/" ||
          nameArr[2] == "/products/" ||
          nameArr[3] == "/products/" ||
          nameArr[4] == "/products/" ||
          nameArr[5] == "/products/" ||
          nameArr[6] == "/products/" ||
          nameArr[7] == "/products/" ||
          nameArr[8] == "/products/"
        ) {
          var display_yn_main = ";";
        } else {
          var display_yn_main = "display:none;";
        }
      }

      if (
        window.location.pathname.match("(.*)/checkouts/(.*)") ||
        window.location.pathname.match("(.*)/checkouts")
      ) {
        if (
          nameArr[0] == "/checkouts/" ||
          nameArr[1] == "/checkouts/" ||
          nameArr[2] == "/checkouts/" ||
          nameArr[3] == "/checkouts/" ||
          nameArr[4] == "/checkouts/" ||
          nameArr[5] == "/checkouts/" ||
          nameArr[6] == "/checkouts/" ||
          nameArr[7] == "/checkouts/" ||
          nameArr[8] == "/checkouts/"
        ) {
          var display_yn_main = ";";
        } else {
          var display_yn_main = "display:none;";
        }
      }

      if (
        window.location.pathname.match("(.*)/pages/(.*)") ||
        window.location.pathname.match("(.*)/pages")
      ) {
        if (
          nameArr[0] == "/pages/" ||
          nameArr[1] == "/pages/" ||
          nameArr[2] == "/pages/" ||
          nameArr[3] == "/pages/" ||
          nameArr[4] == "/pages/" ||
          nameArr[5] == "/pages/" ||
          nameArr[6] == "/pages/" ||
          nameArr[7] == "/pages/" ||
          nameArr[8] == "/pages/"
        ) {
          var display_yn_main = ";";
        } else {
          var display_yn_main = "display:none;";
        }
      }

      if (
        window.location.pathname.match("(.*)/blogs/(.*)") ||
        window.location.pathname.match("(.*)/blogs")
      ) {
        if (
          nameArr[0] == "/blogs/" ||
          nameArr[1] == "/blogs/" ||
          nameArr[2] == "/blogs/" ||
          nameArr[3] == "/blogs/" ||
          nameArr[4] == "/blogs/" ||
          nameArr[5] == "/blogs/" ||
          nameArr[6] == "/blogs/" ||
          nameArr[7] == "/blogs/" ||
          nameArr[8] == "/blogs/"
        ) {
          var display_yn_main = ";";
        } else {
          var display_yn_main = "display:none;";
        }
      }

      if ("/" === window.location.pathname) {
        if (
          nameArr[0] == "/" ||
          nameArr[1] == "/" ||
          nameArr[2] == "/" ||
          nameArr[3] == "/" ||
          nameArr[4] == "/" ||
          nameArr[5] == "/" ||
          nameArr[6] == "/" ||
          nameArr[7] == "/" ||
          nameArr[8] == "/"
        ) {
          var display_yn_main = ";";
        } else {
          if ("/" !== window.location.pathname) {
            //	var display_yn_main ='display:none;';
          }
        }
      }

      if (
        window.location.pathname.match("(.*)/password/(.*)") ||
        window.location.pathname.match("(.*)/password")
      ) {
        if (
          nameArr[0] == "/password/" ||
          nameArr[1] == "/password/" ||
          nameArr[2] == "/password/" ||
          nameArr[3] == "/password/" ||
          nameArr[4] == "/password/" ||
          nameArr[5] == "/password/" ||
          nameArr[6] == "/password/" ||
          nameArr[7] == "/password/" ||
          nameArr[8] == "/password/"
        ) {
          var display_yn_main = ";";
        } else {
          // var display_yn_main ='display:none;';
          var display_yn_main = ";";
        }
      }

      if (display_yn_main == undefined) {
        var display_yn_main_finaal = "";
      } else {
        var display_yn_main_finaal = display_yn_main;
      }

      if (d.settings.style.customized.icon_width <= 70) {
        var merge_iconnn_wh = d.settings.style.customized.icon_width;
      } else {
        var merge_iconnn_wh = 50;
      }

      if (d.settings.style.customized.merged_icons == "1") {
        var merged_iconss = d.settings.style.customized.merged_icons_display;
        // var sizingggg = 'style="width:'+d.settings.style.customized.share_size+'px;height:'+d.settings.style.customized.share_size+'px;line-height:'+d.settings.style.customized.share_size+'px;border-radius: '+d.settings.style.customized.share_radius+'%; '+sharebggg+'"';

        var iconsss_sizyuu =
          "line-height: " +
          merge_iconnn_wh +
          "px; width: " +
          merge_iconnn_wh +
          "px; height: " +
          merge_iconnn_wh +
          "px;margin-top: 4px;margin-bottom: 4px;";

        var margin_svgggguu =
          "transform: rotate(0deg);margin-top: 4px;margin-bottom: 4px;";
        // var margin_svgggguu ='transform: rotate(0deg);';

        if (merged_iconss.indexOf("Telegram") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_11;
          var telegramss_merge =
            '<a target="_blank" href="https://telegram.me/' +
            link_mergeddchat +
            '" class="telegram" data-placement="333333"><div class="svgtooltip2"><svg class="telegrammm" width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#3E99D8"></circle><path d="M3.56917 -2.55497e-07L0 6.42978L7.5349 1.87535L3.56917 -2.55497e-07Z" transform="translate(13.9704 24.6145)" fill="#E0E0E0"></path><path d="M20.8862 0.133954C20.754 0 20.4897 0 20.2253 0L0.396574 8.03723C0.132191 8.17118 0 8.43909 0 8.707C0 8.97491 0.132191 9.24282 0.396574 9.37677L17.5814 17.414C17.7136 17.414 17.7136 17.414 17.8458 17.414C17.978 17.414 18.1102 17.414 18.1102 17.28C18.2424 17.1461 18.3746 17.0121 18.5068 16.7442L21.1506 0.669769C21.1506 0.535815 21.1506 0.267908 20.8862 0.133954Z" transform="translate(7.36069 10.9512)" fill="white"></path><path d="M13.8801 0L0 11.52V19.4233L3.70136 13.2614L13.8801 0Z" transform="translate(13.9704 11.6208)" fill="#F2F2F2"></path></svg><div class="toltipuwa">Telegram</div></div></a>';
        }

        if (merged_iconss.indexOf("Whatsapp") !== -1) {
          var opoaluuyyy =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
              navigator.userAgent
            ) && !window.MSStream;
			      var opoaliosdd = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;


		  
		      if (true == opoaluuyyy) {

			 if (true == opoaliosdd) {  
		            var pathhhughgguu = "whatsapp://send";
	  
			 }
			 else
			 {
            var pathhhughgguu = "https://api.whatsapp.com/send";
			 } 
		        } 
		  
		  
		  else {
            var pathhhughgguu = "https://web.whatsapp.com/send";
          }
          var linksharewapp =
            pathhhughgguu +
            "?phone=" +
            d.block.number +
            "&text=" +
            d.block.message +
            "";

          var whatsapp_merge =
            '<a target="_blank" href="' +
            linksharewapp +
            '" class="whatsapp mergguu" data-placement="33333"><div class="svgtooltip2"><svg class="ico_d" width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#49E670"></circle><path d="M12.9821 10.1115C12.7029 10.7767 11.5862 11.442 10.7486 11.575C10.1902 11.7081 9.35269 11.8411 6.84003 10.7767C3.48981 9.44628 1.39593 6.25317 1.25634 6.12012C1.11674 5.85403 2.13001e-06 4.39053 2.13001e-06 2.92702C2.13001e-06 1.46351 0.83755 0.665231 1.11673 0.399139C1.39592 0.133046 1.8147 1.01506e-06 2.23348 1.01506e-06C2.37307 1.01506e-06 2.51267 1.01506e-06 2.65226 1.01506e-06C2.93144 1.01506e-06 3.21063 -2.02219e-06 3.35022 0.532183C3.62941 1.19741 4.32736 2.66092 4.32736 2.79397C4.46696 2.92702 4.46696 3.19311 4.32736 3.32616C4.18777 3.59225 4.18777 3.59224 3.90858 3.85834C3.76899 3.99138 3.6294 4.12443 3.48981 4.39052C3.35022 4.52357 3.21063 4.78966 3.35022 5.05576C3.48981 5.32185 4.18777 6.38622 5.16491 7.18449C6.42125 8.24886 7.39839 8.51496 7.81717 8.78105C8.09636 8.91409 8.37554 8.9141 8.65472 8.648C8.93391 8.38191 9.21309 7.98277 9.49228 7.58363C9.77146 7.31754 10.0507 7.1845 10.3298 7.31754C10.609 7.45059 12.2841 8.11582 12.5633 8.38191C12.8425 8.51496 13.1217 8.648 13.1217 8.78105C13.1217 8.78105 13.1217 9.44628 12.9821 10.1115Z" transform="translate(12.9597 12.9597)" fill="#FAFAFA"></path><path d="M0.196998 23.295L0.131434 23.4862L0.323216 23.4223L5.52771 21.6875C7.4273 22.8471 9.47325 23.4274 11.6637 23.4274C18.134 23.4274 23.4274 18.134 23.4274 11.6637C23.4274 5.19344 18.134 -0.1 11.6637 -0.1C5.19344 -0.1 -0.1 5.19344 -0.1 11.6637C-0.1 13.9996 0.624492 16.3352 1.93021 18.2398L0.196998 23.295ZM5.87658 19.8847L5.84025 19.8665L5.80154 19.8788L2.78138 20.8398L3.73978 17.9646L3.75932 17.906L3.71562 17.8623L3.43104 17.5777C2.27704 15.8437 1.55796 13.8245 1.55796 11.6637C1.55796 6.03288 6.03288 1.55796 11.6637 1.55796C17.2945 1.55796 21.7695 6.03288 21.7695 11.6637C21.7695 17.2945 17.2945 21.7695 11.6637 21.7695C9.64222 21.7695 7.76778 21.1921 6.18227 20.039L6.17557 20.0342L6.16817 20.0305L5.87658 19.8847Z" transform="translate(7.7758 7.77582)" fill="white" stroke="white" stroke-width="0.2"></path></svg><div class="toltipuwa">Whatsapp</div></div></a>';
        }
        if (merged_iconss.indexOf("Facebook") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_2;

          var facebook_merge =
            '<a target="_blank" href="https://facebook.com/' +
            link_mergeddchat +
            '" class="facebook mergguu" data-tooltip="Facebook" data-placement="left"><i style="' +
            iconsss_sizyuu +
            '" class="fa fa-facebook"></i></a>';
        }

        if (merged_iconss.indexOf("Instagram") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_5;

          var instagram_merge =
            '<a target="_blank" href="https://instagram.com/' +
            link_mergeddchat +
            '" class="instagram mergguu" data-placement="33333"><div class="svgtooltip2"><svg class="instagrammm" width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><defs><linearGradient id="linear-gradient" x1="0.892" y1="0.192" x2="0.128" y2="0.85" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#4a64d5"></stop><stop offset="0.322" stop-color="#9737bd"></stop><stop offset="0.636" stop-color="#f15540"></stop><stop offset="1" stop-color="#fecc69"></stop></linearGradient></defs><circle class="color-element" cx="19.5" cy="19.5" r="19.5" fill="url(#linear-gradient)"></circle><path id="Path_1923" data-name="Path 1923" d="M13.177,0H5.022A5.028,5.028,0,0,0,0,5.022v8.155A5.028,5.028,0,0,0,5.022,18.2h8.155A5.028,5.028,0,0,0,18.2,13.177V5.022A5.028,5.028,0,0,0,13.177,0Zm3.408,13.177a3.412,3.412,0,0,1-3.408,3.408H5.022a3.411,3.411,0,0,1-3.408-3.408V5.022A3.412,3.412,0,0,1,5.022,1.615h8.155a3.412,3.412,0,0,1,3.408,3.408v8.155Z" transform="translate(10 10.4)" fill="#fff"></path><path id="Path_1924" data-name="Path 1924" d="M45.658,40.97a4.689,4.689,0,1,0,4.69,4.69A4.695,4.695,0,0,0,45.658,40.97Zm0,7.764a3.075,3.075,0,1,1,3.075-3.075A3.078,3.078,0,0,1,45.658,48.734Z" transform="translate(-26.558 -26.159)" fill="#fff"></path><path id="Path_1925" data-name="Path 1925" d="M120.105,28.251a1.183,1.183,0,1,0,.838.347A1.189,1.189,0,0,0,120.105,28.251Z" transform="translate(-96.119 -14.809)" fill="#fff"></path></svg><div class="toltipuwa">Instagram</div></div></a>';
        }

        if (merged_iconss.indexOf("Twitter") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_6;

          var twitter_merge =
            '<a target="_blank" href="https://twitter.com/' +
            link_mergeddchat +
            '" class="twitter mergguu" data-placement="333333"><div class="svgtooltip2"><svg width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px"  viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.5" cy="19.5" r="19.5" fill="#1ab2e8"></circle><path id="path_color_twitter" d="M18.532,59.222a7.592,7.592,0,0,1-2.183.6,3.817,3.817,0,0,0,1.671-2.1,7.664,7.664,0,0,1-2.416.923,3.8,3.8,0,0,0-6.478,3.466,10.792,10.792,0,0,1-7.835-3.972A3.806,3.806,0,0,0,2.469,63.21a3.8,3.8,0,0,1-1.722-.477v.047A3.805,3.805,0,0,0,3.8,66.508a3.85,3.85,0,0,1-1,.133,3.649,3.649,0,0,1-.716-.071,3.8,3.8,0,0,0,3.55,2.64A7.627,7.627,0,0,1,.908,70.835,8.079,8.079,0,0,1,0,70.783a10.745,10.745,0,0,0,5.827,1.71A10.741,10.741,0,0,0,16.643,61.678l-.013-.492A7.591,7.591,0,0,0,18.532,59.222Z" transform="translate(9.999 -45.441)" fill="#fff"></path></svg><div class="toltipuwa">Twitter</div></div></a>';
        }

        if (merged_iconss.indexOf("Pinterest") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_7;

          var pinterest_merge =
            '<a target="_blank" href="https://pinterest.com/' +
            link_mergeddchat +
            '" class="pinterest mergguu" data-tooltip="Pinterest" data-placement="left"><i style="' +
            iconsss_sizyuu +
            '" class="fa fa-pinterest-p"></i></a>';
        }

        if (merged_iconss.indexOf("Slack") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_22;

          var slack_merge =
            '<a target="_blank" href="https://' +
            link_mergeddchat +
            '.slack.com/messages/" class="slack mergguu" data-placement="333333"><div class="svgtooltip2"><svg width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#3f0e40"></circle><g id="Group_521" data-name="Group 521" transform="translate(3.719 3.719)"><path class="slack-path" data-name="Path 10688" d="M24,23.046,18.767,7.182a1.994,1.994,0,1,1,3.788-1.25l5.237,15.86A1.995,1.995,0,1,1,24,23.046Zm0,0" transform="translate(-3.511)" fill="#ffc305"></path><path class="slack-path" data-name="Path 10689" d="M13.387,26.487,8.15,10.627a1.995,1.995,0,1,1,3.788-1.253l5.237,15.86a1.995,1.995,0,1,1-3.788,1.253Zm0,0" transform="translate(-0.868 -0.857)" fill="#7daf93"></path><path class="slack-path" data-name="Path 10690" d="M8.1,26.645a2,2,0,0,1,1.27-2.52l15.863-5.24a2,2,0,1,1,1.25,3.79l-15.86,5.237A2,2,0,0,1,8.1,26.645Zm0,0" transform="translate(-0.857 -3.541)" fill="#e1325a"></path><path class="slack-path" data-name="Path 10691" d="M12.633,24.551l3.791-1.25,1.25,3.791-3.791,1.25Zm0,0" transform="translate(-2.009 -4.665)" fill="#1b444f"></path><path class="slack-path" data-name="Path 10692" d="M23.23,21.051l3.79-1.25,1.25,3.791-3.791,1.25Zm0,0" transform="translate(-4.647 -3.794)" fill="#e64b55"></path><path class="slack-path" data-name="Path 10693" d="M4.662,16.028a2,2,0,0,1,1.27-2.52l15.86-5.237a1.995,1.995,0,1,1,1.253,3.788L7.185,17.3A2,2,0,0,1,4.662,16.028Zm0,0" transform="translate(0 -0.898)" fill="#91cdff"></path><path class="slack-path" data-name="Path 10694" d="M9.133,13.953,12.92,12.7l1.253,3.788-3.791,1.253Zm0,0" transform="translate(-1.138 -2.027)" fill="#51946f"></path><path class="slack-path" data-name="Path 10695" d="M19.73,10.456,23.518,9.2l1.253,3.791-3.791,1.25Zm0,0" transform="translate(-3.776 -1.155)" fill="#82962d"></path></g></svg><div class="toltipuwa">Slack</div></div></a>';
        }

        if (merged_iconss.indexOf("Map") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_23;

          var map_merge =
            '<a target="_blank" href="https://maps.google.com/?ll=' +
            link_mergeddchat +
            '" class="map mergguu" data-placement="333333"><div class="svgtooltip2"><svg width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg"style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#37AA66"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M0 8.06381C0 3.68631 3.68633 0 8.06383 0C12.4413 0 16.1276 3.68631 16.1276 8.06381C16.1276 12.2109 9.67659 19.5835 8.9854 20.2747C8.755 20.5051 8.29422 20.7355 8.06383 20.7355C7.83344 20.7355 7.37263 20.5051 7.14224 20.2747C6.45107 19.5835 0 12.2109 0 8.06381ZM11.5203 8.06378C11.5203 9.97244 9.97302 11.5197 8.06436 11.5197C6.15572 11.5197 4.60844 9.97244 4.60844 8.06378C4.60844 6.15515 6.15572 4.60788 8.06436 4.60788C9.97302 4.60788 11.5203 6.15515 11.5203 8.06378Z" transform="translate(11.3764 9.07178)" fill="white"></path></svg><div class="toltipuwa">Google Map</div></div></a>';
        }

        if (merged_iconss.indexOf("Reddit") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_8;

          var reddit_merge =
            '<a target="_blank" href="https://www.reddit.com/user/' +
            link_mergeddchat +
            '" class="reddit mergguu" data-tooltip="Reddit" data-placement="left"><i style="' +
            iconsss_sizyuu +
            '" class="fa fa-reddit-alien"></i></a>';
        }

        if (merged_iconss.indexOf("VK") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_9;

          var vk_merge =
            '<a target="_blank" href="https://vk.com/' +
            link_mergeddchat +
            '" class="vk mergguu"  data-placement="3333333"><div class="svgtooltip2"><svg width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#5076AA"></circle><path d="M11.0953 12.4775H12.5097C12.5097 12.4775 12.934 12.4774 13.0755 12.1971C13.2169 12.0569 13.2169 11.6363 13.2169 11.6363C13.2169 11.6363 13.2169 9.81373 14.0656 9.53334C14.9142 9.25294 15.9043 11.2157 17.0359 12.0569C17.8845 12.6176 18.5917 12.4775 18.5917 12.4775H21.562C21.562 12.4775 23.1178 12.3373 22.4106 11.2157C22.4106 11.0755 21.9863 10.2343 20.1476 8.69216C18.3088 7.0098 18.4503 7.29019 20.8548 4.20588C22.2692 2.38333 22.835 1.26176 22.6935 0.700978C22.5521 0.28039 21.562 0.42059 21.562 0.42059H18.1674C18.1674 0.42059 17.8845 0.420588 17.7431 0.560784C17.6016 0.70098 17.4602 0.981371 17.4602 0.981371C17.4602 0.981371 16.8944 2.38333 16.1872 3.6451C14.6313 6.16863 14.0656 6.30882 13.7827 6.16863C13.2169 5.74804 13.3584 4.62647 13.3584 3.92549C13.3584 1.40196 13.7827 0.420589 12.6512 0.140197C12.2268 1.06543e-06 11.944 -2.13922e-06 11.0953 -2.13922e-06C9.82233 -2.13922e-06 8.83224 -1.06543e-06 8.26647 0.280391C7.84215 0.420587 7.55927 0.841177 7.70071 0.841177C7.9836 0.841177 8.40792 0.98137 8.6908 1.40196C8.97368 1.82255 8.97368 2.94412 8.97368 2.94412C8.97368 2.94412 9.11513 5.88824 8.54936 6.16863C8.12503 6.44902 7.41783 5.88824 6.14485 3.6451C5.43764 2.52353 4.87188 1.12157 4.87188 1.12157C4.87188 1.12157 4.73044 0.841174 4.589 0.700978C4.30611 0.560782 4.02323 0.560784 4.02323 0.560784H0.770071C0.770071 0.560784 0.345746 0.560785 0.0628629 0.841177C-0.0785787 0.981374 0.0628629 1.40196 0.0628629 1.40196C0.0628629 1.40196 2.60881 7.2902 5.43764 10.2343C8.12503 12.7578 11.0953 12.4775 11.0953 12.4775Z" transform="translate(6.78613 14.4898)" fill="white"></path></svg><div class="toltipuwa">VK</div></div></a>';
        }

        if (merged_iconss.indexOf("Snapchat") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_10;

          var snapchat_merge =
            '<a target="_blank" href="https://www.snapchat.com/add/' +
            link_mergeddchat +
            '" class="snapchat mergguu" data-placement="3333333"><div class="svgtooltip2"><svg width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#FFE81D"></circle><path d="M21.5684 15.5864C18.7017 15.0298 17.3366 12.1073 17.3366 11.9681C17.2001 11.6898 17.2001 11.4115 17.2001 11.2723C17.3366 10.8548 18.0191 10.7157 18.4287 10.5765C18.5652 10.5765 18.7017 10.4373 18.7017 10.4373C19.1112 10.2982 19.3842 10.159 19.5207 9.88067C19.7938 9.60234 19.7938 9.46318 19.7938 9.32402C19.7938 8.90652 19.5207 8.62819 19.1112 8.48903C18.9747 8.48903 18.8382 8.34986 18.7017 8.34986C18.5652 8.34986 18.4287 8.34986 18.2922 8.48903C17.8826 8.62819 17.6096 8.76736 17.3366 8.76736C17.2001 8.76736 17.0636 8.76736 17.0636 8.76736C17.0636 8.62819 17.0636 8.48903 17.0636 8.34986C17.2001 6.81906 17.3366 5.00992 16.7906 3.8966C16.5175 3.20078 15.9715 2.50496 15.4255 1.9483C15.016 1.53081 14.4699 1.11332 13.7874 0.834987C12.6953 4.97691e-07 11.7397 0 11.3302 0C11.1937 0 10.9207 0 10.9207 0C10.3747 0 9.4191 0.139164 8.46354 0.556657C7.9175 0.834986 7.37147 1.25248 6.82544 1.66997C6.2794 2.22663 5.86988 2.92245 5.46035 3.61827C4.91431 4.73159 5.05082 6.54073 5.18733 8.07153C5.18733 8.2107 5.18733 8.34986 5.18733 8.62819C5.05082 8.62819 5.05082 8.62819 4.77781 8.62819C4.50479 8.62819 4.23177 8.48903 3.82224 8.34986C3.68574 8.34986 3.54923 8.2107 3.41272 8.2107C3.1397 8.2107 3.00319 8.2107 2.73018 8.34986C2.45716 8.48903 2.32065 8.76736 2.32065 8.90652C2.32065 9.04568 2.32065 9.32401 2.59366 9.74151C2.73017 9.88067 3.00319 10.0198 3.41272 10.159C3.54923 10.159 3.54922 10.2982 3.68573 10.2982C4.09526 10.4373 4.6413 10.5765 4.91431 10.994C5.05082 11.1332 4.91431 11.4115 4.77781 11.6898C4.77781 11.829 4.36828 12.5248 3.68573 13.3598C3.27621 13.7773 2.86668 14.1948 2.32065 14.6123C1.77461 15.0298 1.09207 15.3081 0.409527 15.3081C0.13651 15.3081 2.08296e-06 15.5864 2.08296e-06 15.8647C2.08296e-06 16.0039 2.08296e-06 16.0039 2.08296e-06 16.1431C0.136511 16.4214 0.409528 16.5606 0.682546 16.8389C1.22858 17.1172 1.91112 17.2564 2.86668 17.3955C2.86668 17.5347 3.00319 17.6739 3.00319 17.813C3.00319 17.9522 3.1397 18.0914 3.1397 18.3697C3.1397 18.5089 3.41272 18.7872 3.68573 18.7872C3.82224 18.7872 3.95875 18.7872 4.23177 18.648C4.50479 18.648 4.91431 18.5089 5.32384 18.5089C5.59686 18.5089 5.86988 18.5089 6.14289 18.648C6.68893 18.7872 7.09845 19.0655 7.64449 19.483C8.46354 20.0397 9.28259 20.7355 10.6477 20.7355H10.7842H10.9207C12.2858 20.7355 13.1048 20.0397 13.9239 19.483C14.4699 19.0655 14.8794 18.7872 15.4255 18.648C15.6985 18.648 15.9715 18.5089 16.2445 18.5089C16.6541 18.5089 17.0636 18.5089 17.3366 18.648C17.6096 18.648 17.7461 18.648 17.8826 18.648C18.1557 18.648 18.4287 18.5089 18.4287 18.2305C18.4287 18.0914 18.5652 17.9522 18.5652 17.6739C18.5652 17.5347 18.7017 17.2564 18.7017 17.2564C19.6572 17.1172 20.3398 16.9781 20.8858 16.6997C21.2954 16.5606 21.5684 16.2822 21.5684 16.0039C21.5684 15.8647 21.5684 15.8647 21.5684 15.7256C21.9779 15.8647 21.8414 15.5864 21.5684 15.5864Z" transform="translate(8.52631 9.07178)" fill="white"></path></svg><div class="toltipuwa">Snapchat</div></div></a>';
        }
        if (merged_iconss.indexOf("Wechat") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_11;

          var wechat_merge =
            '<a target="_blank" href="weixin://dl/chat?' +
            link_mergeddchat +
            '" class="wechat mergguu"  data-placement="33333"><div class="svgtooltip2"><svg width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#45DC00"></circle><path d="M17.3707 6.90938C15.0508 7.03077 13.0281 7.71242 11.3888 9.26248C9.73039 10.8312 8.97307 12.7455 9.18397 15.1172C8.27327 15.0052 7.44884 14.8838 6.61482 14.8184C6.32723 14.7904 5.99171 14.8278 5.74246 14.9585C4.93721 15.4067 4.16071 15.9016 3.24042 16.4619C3.41298 15.7242 3.51843 15.0705 3.71015 14.4449C3.85395 13.9874 3.78685 13.7353 3.35546 13.4364C0.584998 11.5222 -0.594125 8.65553 0.287821 5.69547C1.10266 2.95952 3.09663 1.30674 5.80957 0.447674C9.50991 -0.728879 13.68 0.475687 15.9232 3.33303C16.738 4.36952 17.2365 5.53673 17.3707 6.90938ZM6.69152 5.98494C6.71069 5.44336 6.23137 4.95779 5.65619 4.93912C5.07142 4.92044 4.5921 5.35932 4.57293 5.91958C4.55375 6.48918 5.00431 6.94673 5.58908 6.95607C6.18344 6.97474 6.67234 6.53587 6.69152 5.98494ZM12.2612 4.93912C11.686 4.94846 11.2067 5.42468 11.2163 5.96627C11.2259 6.52653 11.7052 6.9654 12.29 6.9654C12.8843 6.95607 13.3253 6.51719 13.3253 5.93825C13.3157 5.37799 12.846 4.92978 12.2612 4.93912Z" transform="translate(7 9)" fill="white"></path><path d="M12.48 13.2605C11.7418 12.943 11.0708 12.4668 10.3518 12.3921C9.63283 12.3174 8.88509 12.7189 8.13735 12.7936C5.8558 13.0177 3.8139 12.4014 2.13629 10.8887C-1.06556 8.00334 -0.605416 3.57726 3.09492 1.21482C6.38305 -0.886168 11.2146 -0.185839 13.5345 2.72753C15.5572 5.26739 15.3175 8.64764 12.8538 10.786C12.1349 11.4023 11.876 11.9158 12.3362 12.7282C12.4225 12.8776 12.432 13.0737 12.48 13.2605ZM4.11108 5.3701C4.58081 5.3701 4.96426 5.01527 4.98344 4.56706C5.00261 4.09084 4.60957 3.68932 4.12066 3.68932C3.63176 3.68932 3.22913 4.09084 3.2483 4.55772C3.26748 5.00593 3.65093 5.3701 4.11108 5.3701ZM9.5082 3.68932C9.05764 3.68932 8.6646 4.04415 8.64543 4.49236C8.62626 4.96858 9.00971 5.36077 9.48903 5.36077C9.95876 5.36077 10.3326 5.01527 10.3422 4.55772C10.371 4.09084 9.98752 3.68932 9.5082 3.68932Z" transform="translate(17.1057 16.7395)" fill="white"></path></svg><div class="toltipuwa">WeChat</div></div></a>';
        }

        if (merged_iconss.indexOf("Email") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_12;

          var email_merge =
            '<a target="_blank" href="mailto:' +
            link_mergeddchat +
            '" class="email mergguu"   data-placement="33333"><div class="svgtooltip2"><svg class="ico_d" width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#FF485F"></circle><path d="M20.5379 14.2557H1.36919C0.547677 14.2557 0 13.7373 0 12.9597V1.29597C0 0.518387 0.547677 0 1.36919 0H20.5379C21.3594 0 21.9071 0.518387 21.9071 1.29597V12.9597C21.9071 13.7373 21.3594 14.2557 20.5379 14.2557ZM20.5379 12.9597V13.6077V12.9597ZM1.36919 1.29597V12.9597H20.5379V1.29597H1.36919Z" transform="translate(8.48619 12.3117)" fill="white"></path><path d="M10.9659 8.43548C10.829 8.43548 10.692 8.43548 10.5551 8.30588L0.286184 1.17806C0.012346 0.918864 -0.124573 0.530073 0.149265 0.270879C0.423104 0.0116857 0.833862 -0.117911 1.1077 0.141283L10.9659 7.00991L20.8241 0.141283C21.0979 -0.117911 21.5087 0.0116857 21.7825 0.270879C22.0563 0.530073 21.9194 0.918864 21.6456 1.17806L11.3766 8.30588C11.2397 8.43548 11.1028 8.43548 10.9659 8.43548Z" transform="translate(8.47443 12.9478)" fill="white"></path><path d="M9.0906 7.13951C8.95368 7.13951 8.81676 7.13951 8.67984 7.00991L0.327768 1.17806C-0.0829894 0.918864 -0.0829899 0.530073 0.190849 0.270879C0.327768 0.0116855 0.738525 -0.117911 1.14928 0.141282L9.50136 5.97314C9.7752 6.23233 9.91212 6.62112 9.63828 6.88032C9.50136 7.00991 9.36444 7.13951 9.0906 7.13951Z" transform="translate(20.6183 18.7799)" fill="white"></path><path d="M0.696942 7.13951C0.423104 7.13951 0.286185 7.00991 0.149265 6.88032C-0.124573 6.62112 0.012346 6.23233 0.286185 5.97314L8.63826 0.141282C9.04902 -0.117911 9.45977 0.0116855 9.59669 0.270879C9.87053 0.530073 9.73361 0.918864 9.45977 1.17806L1.1077 7.00991C0.970781 7.13951 0.833862 7.13951 0.696942 7.13951Z" transform="translate(8.47443 18.7799)" fill="white"></path></svg><div class="toltipuwa">Email</div></div></a>';
        }

        if (merged_iconss.indexOf("Viber") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_20;

          var viber_merge =
            '<a target="_blank" href="viber://chat?number=+' +
            link_mergeddchat +
            '"" class="viber mergguu"  data-placement="33333"><div class="svgtooltip2"><svg class="ico_d" width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#665CAC"></circle><path d="M17.6837 2.14833C17.16 1.64578 15.0497 0.0389578 10.3496 0.0158143C10.3496 0.0158143 4.80418 -0.334645 2.10085 2.26405C0.596193 3.84111 0.0662511 6.14886 0.0126261 9.01205C-0.0441534 11.8752 -0.116705 17.2346 4.8168 18.6894H4.81995L4.8168 20.9078C4.8168 20.9078 4.78525 21.8071 5.3499 21.989C6.03125 22.2105 6.43186 21.5294 7.08482 20.7921C7.44127 20.3888 7.93651 19.7936 8.30874 19.3407C11.6808 19.6382 14.2769 18.9572 14.5702 18.858C15.2516 18.6265 19.1063 18.1075 19.7309 12.7481C20.3775 7.22338 19.4154 3.7254 17.6837 2.14833ZM18.2546 12.3513C17.7247 16.828 14.5986 17.1123 14.0245 17.3041C13.7785 17.3867 11.501 17.9818 8.63679 17.7835C8.63679 17.7835 6.50126 20.4813 5.83567 21.1856C5.73158 21.2947 5.60856 21.341 5.52654 21.3178C5.41298 21.2881 5.38144 21.1459 5.38144 20.9376C5.38459 20.64 5.40037 17.2512 5.40037 17.2512C5.39721 17.2512 5.39721 17.2512 5.40037 17.2512C1.23023 16.0378 1.47312 11.4719 1.52044 9.08148C1.56775 6.69108 1.99675 4.73379 3.26798 3.41792C5.55493 1.24904 10.2645 1.57305 10.2645 1.57305C14.2422 1.59288 16.1475 2.84594 16.5891 3.26583C18.0527 4.58501 18.8003 7.73585 18.2546 12.3513Z" transform="translate(9.47299 8.4238)" fill="white"></path><path d="M1.58982 1.72254C1.53935 0.628182 1.00941 0.0562059 0 1.00898e-07" transform="translate(20.166 15.5914)" stroke="white" stroke-width="0.518873" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.35945 3.69636C3.38153 2.67804 3.09448 1.82834 2.49514 1.14395C1.8958 0.459565 1.06619 0.0793496 1.9253e-07 2.01796e-07" transform="translate(19.7592 14.0966)" stroke="white" stroke-width="0.518873" stroke-linecap="round" stroke-linejoin="round"></path><path d="M5.22371 5.71646C5.21109 3.94763 4.70639 2.55902 3.71275 1.5407C2.71911 0.525689 1.47942 0.00991877 -3.8506e-07 1.00898e-07" transform="translate(19.2931 12.6479)" stroke="white" stroke-width="0.518873" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.35738 8.04532C6.35738 8.04532 6.73276 8.07838 6.93149 7.81719L7.32263 7.30142C7.5119 7.04353 7.96929 6.88153 8.41722 7.14272C8.66641 7.2915 9.11434 7.57914 9.39193 7.79405C9.68844 8.02218 10.2972 8.55448 10.2972 8.55448C10.5875 8.80906 10.6537 9.18597 10.4581 9.58271C10.4581 9.58602 10.455 9.58933 10.455 9.58933C10.2531 9.96293 9.9818 10.3167 9.63797 10.644C9.63482 10.6473 9.63482 10.6473 9.63167 10.6506C9.35092 10.8953 9.07333 11.0375 8.80205 11.0705C8.77051 11.0771 8.7295 11.0804 8.68219 11.0771C8.56232 11.0771 8.44561 11.0606 8.32889 11.0209L8.31943 11.0077C7.89989 10.8854 7.20277 10.5746 6.03879 9.90342C5.28173 9.467 4.654 9.02066 4.12406 8.57762C3.84331 8.34619 3.55626 8.08169 3.2629 7.77752C3.25344 7.7676 3.24398 7.75768 3.23451 7.74776C3.22505 7.73784 3.21559 7.72792 3.20612 7.718C3.19666 7.70808 3.1872 7.69817 3.17773 7.68825C3.16827 7.67833 3.15881 7.66841 3.14934 7.65849C2.85914 7.35101 2.60678 7.05015 2.38597 6.75589C1.96328 6.20045 1.53744 5.5392 1.12105 4.74902C0.480708 3.52902 0.184194 2.79834 0.0674803 2.35862L0.0548623 2.3487C0.0170094 2.22637 -0.00191702 2.10404 0.0012374 1.9784C-0.00191702 1.92881 0.0012373 1.88583 0.00754613 1.85276C0.0390903 1.56843 0.17473 1.27748 0.408157 0.983227C0.411312 0.979921 0.411311 0.979921 0.414466 0.976615C0.726753 0.616237 1.06112 0.331902 1.42072 0.120304C1.42388 0.120304 1.42703 0.116997 1.42703 0.116997C1.80556 -0.0879887 2.16517 -0.0185578 2.40806 0.285615C2.41121 0.288921 2.91592 0.923716 3.13357 1.2345C3.33861 1.52875 3.6162 1.99493 3.75499 2.25612C4.00419 2.72561 3.84962 3.20501 3.60358 3.40338L3.11149 3.81335C2.86229 4.02495 2.89384 4.41509 2.89384 4.41509C2.89384 4.41509 3.62566 7.31464 6.35738 8.04532Z" transform="translate(13.863 13.0014)" fill="white"></path></svg><div class="toltipuwa">Viber</div></div></a>';
        }

        if (merged_iconss.indexOf("Line") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_21;

          var line_merge =
            '<a target="_blank" href="line://ti/p/@' +
            link_mergeddchat +
            '" class="line mergguu"  data-placement="33333"><div class="svgtooltip2"><svg width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#38B900"></circle><path d="M24 9.36561C24 4.19474 18.6178 0 12 0C5.38215 0 0 4.19474 0 9.36561C0 13.9825 4.25629 17.8606 10.0229 18.5993C10.4073 18.6785 10.9565 18.8368 11.0664 19.1797C11.1762 19.4699 11.1487 19.9184 11.0938 20.235C11.0938 20.235 10.9565 21.0528 10.9291 21.2111C10.8741 21.5013 10.6819 22.3456 11.9725 21.8443C13.2632 21.3167 18.8924 17.9398 21.3913 15.1433C23.1487 13.2702 24 11.4234 24 9.36561Z" transform="translate(7 10)" fill="white"></path><path d="M1.0984 0H0.24714C0.10984 0 -2.09503e-07 0.105528 -2.09503e-07 0.211056V5.22364C-2.09503e-07 5.35555 0.10984 5.43469 0.24714 5.43469H1.0984C1.2357 5.43469 1.34554 5.32917 1.34554 5.22364V0.211056C1.34554 0.105528 1.2357 0 1.0984 0Z" transform="translate(15.4577 16.8593)" fill="#38B900" class="color-element"></path><path d="M4.66819 0H3.81693C3.67963 0 3.56979 0.105528 3.56979 0.211056V3.19222L1.18078 0.0791458C1.18078 0.0791458 1.18078 0.0527642 1.15332 0.0527642C1.15332 0.0527642 1.15332 0.0527641 1.12586 0.0263821C1.12586 0.0263821 1.12586 0.0263821 1.0984 0.0263821H0.247139C0.10984 0.0263821 4.19006e-07 0.13191 4.19006e-07 0.237438V5.25002C4.19006e-07 5.38193 0.10984 5.46108 0.247139 5.46108H1.0984C1.2357 5.46108 1.34554 5.35555 1.34554 5.25002V2.26885L3.73455 5.38193C3.76201 5.40831 3.76201 5.43469 3.78947 5.43469C3.78947 5.43469 3.78947 5.43469 3.81693 5.43469C3.81693 5.43469 3.81693 5.43469 3.84439 5.43469C3.87185 5.43469 3.87185 5.43469 3.89931 5.43469H4.75057C4.88787 5.43469 4.99771 5.32917 4.99771 5.22364V0.211056C4.91533 0.105528 4.80549 0 4.66819 0Z" transform="translate(17.6819 16.8593)" fill="#38B900" class="color-element"></path><path d="M3.62471 4.22112H1.34554V0.237438C1.34554 0.105528 1.2357 0 1.0984 0H0.24714C0.10984 0 -5.23757e-08 0.105528 -5.23757e-08 0.237438V5.25002C-5.23757e-08 5.30278 0.0274599 5.35555 0.0549198 5.40831C0.10984 5.43469 0.16476 5.46108 0.21968 5.46108H3.56979C3.70709 5.46108 3.78947 5.35555 3.78947 5.22364V4.4058C3.87185 4.32665 3.76201 4.22112 3.62471 4.22112Z" transform="translate(10.8993 16.8593)" fill="#38B900" class="color-element"></path><path d="M3.56979 1.29272C3.70709 1.29272 3.78947 1.18719 3.78947 1.05528V0.237438C3.78947 0.105528 3.67963 -1.00639e-07 3.56979 -1.00639e-07H0.219679C0.164759 -1.00639e-07 0.10984 0.0263821 0.0549199 0.0527641C0.02746 0.105528 -2.09503e-07 0.158292 -2.09503e-07 0.211056V5.22364C-2.09503e-07 5.2764 0.02746 5.32917 0.0549199 5.38193C0.10984 5.40831 0.164759 5.43469 0.219679 5.43469H3.56979C3.70709 5.43469 3.78947 5.32917 3.78947 5.19726V4.37941C3.78947 4.2475 3.67963 4.14198 3.56979 4.14198H1.29062V3.29775H3.56979C3.70709 3.29775 3.78947 3.19222 3.78947 3.06031V2.24247C3.78947 2.11056 3.67963 2.00503 3.56979 2.00503H1.29062V1.16081H3.56979V1.29272Z" transform="translate(23.421 16.8329)" fill="#38B900" class="color-element"></path></svg><div class="toltipuwa">Line</div></div></a>';
        }

        if (merged_iconss.indexOf("Call") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_13;

          var call_merge =
            '<a target="_blank" href="tel: ' +
            link_mergeddchat +
            '" class="call mergguu"  data-placement="33333"><div class="svgtooltip2"><svg width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#03E78B"></circle><path d="M19.3929 14.9176C17.752 14.7684 16.2602 14.3209 14.7684 13.7242C14.0226 13.4259 13.1275 13.7242 12.8292 14.4701L11.7849 16.2602C8.65222 14.6193 6.11623 11.9341 4.47529 8.95057L6.41458 7.90634C7.16046 7.60799 7.45881 6.71293 7.16046 5.96705C6.56375 4.47529 6.11623 2.83435 5.96705 1.34259C5.96705 0.596704 5.22117 0 4.47529 0H0.745882C0.298353 0 5.69062e-07 0.298352 5.69062e-07 0.745881C5.69062e-07 3.72941 0.596704 6.71293 1.93929 9.3981C3.87858 13.575 7.30964 16.8569 11.3374 18.7962C14.0226 20.1388 17.0061 20.7355 19.9896 20.7355C20.4371 20.7355 20.7355 20.4371 20.7355 19.9896V16.4094C20.7355 15.5143 20.1388 14.9176 19.3929 14.9176Z" transform="translate(9.07179 9.07178)" fill="white"></path></svg><div class="toltipuwa">Call</div></div></a>';
        }

        if (merged_iconss.indexOf("Messenger") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_3;

          // var messenger_merge = '<a target="_blank" href="https://m.me/'+link_mergeddchat+'" class="messenger"   data-placement="33333"><div class="svgtooltip2"><svg style="'+margin_svgggguu+'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 39 39" width= "'+d.settings.style.customized.icon_width+'px" height= "'+d.settings.style.customized.icon_width+'px" class="messenger99"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#1E88E5"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.63934C0 4.29861 4.68939 0 10.4209 0C16.1524 0 20.8418 4.29861 20.8418 9.63934C20.8418 14.98 16.1524 19.2787 10.4209 19.2787C9.37878 19.2787 8.33673 19.1484 7.42487 18.8879L3.90784 20.8418V17.1945C1.56311 15.3708 0 12.6353 0 9.63934ZM8.85779 10.1604L11.463 13.0261L17.1945 6.90384L12.1143 9.76959L9.37885 6.90384L3.64734 13.0261L8.85779 10.1604Z" transform="translate(9.01854 10.3146)" fill="white"></path></svg><div class="toltipuwa">Messenger</div></div></a>';

          var opoalurre =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
              navigator.userAgent
            ) && !window.MSStream;

          if (true == opoalurre) {
            var addthinss = "";
            var linkksfjdkjsk =
              'target="_blank" href="https://m.me/' + link_mergeddchat + '"';
          } else {
            var addthinss = "pd-fb-logoss";
            var linkksfjdkjsk = "";
          }

          jQuery("body").append("<div class='pdFacbookChatss'></div>");
          var greeting_message = d.block.chat.greeting
            .replace(/&/g, "&amp;")
            .replace(/>/g, "&gt;")
            .replace(/</g, "&lt;")
            .replace(/"/g, "&quot;");

          var fbfiless999 =
            '<style>.fb_iframe_widget iframe {right: 90.29999999999995px!important;bottom: 60px!important;min-height: 0!important;}@media screen and (max-width:768px) {.fb_iframe_widget iframe {right: 1px!important;bottom: 80px!important;bottom: 60px!important;width: 255px;}.fb_iframe_widget.fb_iframe_widget_fluid iframe.fb_customer_chat_bounce_in_v2_mobile_chat_started {right: 0px!important;}}.fb_dialog {right: 10%!important;}.fb_dialog {display: none!important;}.fb_dialog.fb_dialog_mobile{bottom: -100px!important;width: 0px!important;}.pd-fb-logoss.facebook-chat-button {display: none!important;background-color: #ffffff;fill: #0084FF;box-shadow: 0 3pt 12pt rgba(0,0,0,.15);border-radius: 30px;width: auto;}.pd-fb-logoss.facebook-chat-button.medium svg {width: 32px;height: 32px;}.pd-fb-logoss.facebook-chat-button.medium span {font-size: 16px;margin-top: 3px;}.pd-fb-logoss.facebook-chat-button.small svg {width: 24px;height: 24px;}.pd-fb-logoss.facebook-chat-button.small span {font-size: 14px;margin-top: 2px;}.pd-fb-logoss.facebook-chat-button.large {}.pd-fb-logoss.facebook-chat-button.large svg {width: 40px;height: 40px;}.pd-fb-logoss.facebook-chat-button.large span {font-size: 20px;margin-top: 3px;}</style><div id="fb-root"></div><script>window.fbAsyncInit = function() {FB.init({appId: "1912261035577226",autoLogAppEvents : true,xfbml: true,version: "v7.0" });};(function(d, s, id) {var js, fjs =d.getElementsByTagName(s)[0];js = d.createElement(s); js.id = id;js.src ="https://connect.facebook.net/en_GB/sdk/xfbml.customerchat.js";fjs.parentNode.insertBefore(js, fjs);}(document, "script", "facebook-jssdk"));</script>';

          jQuery(".pdFacbookChatss").append(fbfiless999);

          var fb_page_id999 = d.settings.style.customized.secondary_button_link.replace(
            "https://m.me/",
            ""
          );

          var fbchatt666666 =
            '<div class="fb-customerchat" attribution="setup_tool" fb-xfbml-state="rendered" page_id="' +
            fb_page_id999 +
            '" themeColor="' +
            d.settings.style.customized.secondary_button_bgcolor +
            '" logged_in_greeting="' +
            greeting_message +
            '" logged_out_greeting="' +
            greeting_message +
            '" rel="' +
            d.shop +
            '" greeting_dialog_display="fade" greeting_dialog_delay="999999999"></div>';

          jQuery(document).on("click", ".pd-fb-logoss", function (e) {
            var object = jQuery(
              ".fb-customerchat.fb_invisible_flow.fb_iframe_widget iframe"
            );
            jQuery("#fb-root").css("display", "block");
            let window_width = jQuery(window).outerWidth();
            //   if (window_width < 800) {
            //     if (jQuery(".pd-fb-logoss.redirect_icon").length > 0) {
            //   window.open("https://www.messenger.com/t/" + fb_page_id999, "_blank");
            //    }
            //   }
            if (object.css("max-height") === "0px") {
              FB.Event.subscribe(
                "customerchat.dialogShow",
                processShowDialog(object)
              );
            } else {
              FB.Event.subscribe(
                "customerchat.dialogHide",
                processHideDialog(object)
              );
            }
          });

          var messenger_merge =
            '<a class="messenger mergguu" ' +
            linkksfjdkjsk +
            '  data-placement="33333"><div class="svgtooltip2 ' +
            addthinss +
            '"><svg style="' +
            margin_svgggguu +
            '" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 39 39" width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" class="messenger99"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#1E88E5"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.63934C0 4.29861 4.68939 0 10.4209 0C16.1524 0 20.8418 4.29861 20.8418 9.63934C20.8418 14.98 16.1524 19.2787 10.4209 19.2787C9.37878 19.2787 8.33673 19.1484 7.42487 18.8879L3.90784 20.8418V17.1945C1.56311 15.3708 0 12.6353 0 9.63934ZM8.85779 10.1604L11.463 13.0261L17.1945 6.90384L12.1143 9.76959L9.37885 6.90384L3.64734 13.0261L8.85779 10.1604Z" transform="translate(9.01854 10.3146)" fill="white"></path></svg><div class="toltipuwa">Messenger</div></div></a>';
        }

        if (merged_iconss.indexOf("Skype") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_15;

          var skype_merge =
            '<a target="_blank" href="skype:' +
            link_mergeddchat +
            '?chat" class="skype mergguu"   data-placement="333333"><div class="svgtooltip2"><svg width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.4395" cy="19.4395" r="19.4395" fill="#03A9F4"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5634 0.777588C16.0406 0.777588 20.4747 5.05426 20.4747 10.4973C20.4747 11.1453 20.4747 11.9229 20.0834 12.5709C20.4747 13.2189 20.7355 14.1261 20.7355 15.0332C20.7355 18.1436 18.1273 20.7355 14.9974 20.7355C13.9541 20.7355 13.0412 20.4763 12.2587 20.0875C11.6067 20.2171 11.085 20.2171 10.433 20.2171C4.95566 20.2171 0.521637 15.9404 0.521637 10.4973C0.521637 9.84955 0.652008 9.20175 0.782349 8.55392L0.782471 8.55338C0.260834 7.77582 0 6.73904 0 5.70227C0 2.59195 2.60825 0 5.73813 0C6.91183 0 7.95514 0.388794 8.86801 0.907166C9.38965 0.777588 10.0417 0.777588 10.5634 0.777588ZM13.5627 16.718C14.4756 16.3292 15.1276 15.8108 15.6493 15.1628C16.1709 14.5149 16.3013 13.7373 16.0405 12.9597C16.0405 12.3117 15.9101 11.7933 15.6493 11.2749C15.3884 10.7565 14.9972 10.3677 14.4756 10.1086L14.4752 10.1084C13.9536 9.84924 13.4321 9.59012 12.7802 9.33096C12.5034 9.27597 12.2031 9.1976 11.8893 9.11572C11.4638 9.0047 11.0135 8.88718 10.5632 8.81259C10.1953 8.66635 9.86893 8.60263 9.60748 8.55157C9.40552 8.51215 9.24231 8.48029 9.12866 8.4238C8.86792 8.4238 8.60721 8.29428 8.34647 8.16473L8.34619 8.16461C8.08536 8.035 7.82455 7.90543 7.69412 7.77582C7.43329 7.64621 7.43329 7.51663 7.43329 7.25742C7.43329 6.86862 7.69412 6.60944 8.08536 6.35025C8.47659 6.09106 9.12866 5.96146 9.78073 5.96146C10.5632 5.96146 11.0848 6.09106 11.4761 6.35025C11.8673 6.60944 12.1281 6.86865 12.3889 7.38702C12.6497 7.77563 12.9104 8.03476 13.0408 8.16443L13.041 8.16461C13.3018 8.29419 13.5627 8.4238 13.9539 8.4238C14.3451 8.4238 14.7364 8.29419 14.9972 8.035C15.258 7.77582 15.3884 7.51663 15.3884 7.12784C15.3884 6.73904 15.3884 6.35025 15.1276 5.96146C15.0313 5.67429 14.7927 5.45782 14.5169 5.20764C14.4193 5.11908 14.317 5.02631 14.2147 4.92468C13.6931 4.6655 13.1714 4.40631 12.5194 4.14709C11.8673 4.01752 11.0848 3.88791 10.172 3.88791C9.12866 3.88791 8.08536 4.01752 7.30289 4.2767C6.39001 4.53589 5.73795 5.05429 5.34671 5.57266C4.95547 6.09106 4.69464 6.73904 4.69464 7.51663C4.69464 8.29419 4.95547 8.9422 5.34671 9.46057C5.73795 9.97897 6.39001 10.3677 7.04205 10.627C7.69412 10.8861 8.60703 11.1453 9.6503 11.4045C10.4328 11.5341 11.0848 11.6637 11.4761 11.7933C11.8673 11.9229 12.2585 12.0525 12.5194 12.3117C12.7802 12.5709 12.9106 12.8301 12.9106 13.2189C12.9106 13.6077 12.6498 13.9965 12.1281 14.3853C11.6065 14.774 10.9544 14.9036 10.172 14.9036C9.6503 14.9036 9.12866 14.774 8.73743 14.6444C8.47659 14.5149 8.21576 14.2556 7.95496 13.9965C7.91547 13.918 7.86407 13.8277 7.80792 13.7291C7.67859 13.5019 7.52423 13.2308 7.43329 12.9597C7.40817 12.9098 7.38306 12.855 7.35703 12.7983C7.24783 12.5604 7.12225 12.2867 6.91165 12.1821C6.65085 12.0525 6.39001 11.9229 5.99878 11.9229C5.60754 11.9229 5.21631 12.0525 4.95547 12.3117C4.69464 12.5709 4.56424 12.8301 4.56424 13.2189C4.56424 13.8669 4.82507 14.3853 5.21631 15.0332C5.73795 15.6812 6.25961 16.07 6.91165 16.4588C7.82455 16.9772 8.99823 17.2364 10.4328 17.2364C11.6065 17.2364 12.6498 17.1068 13.5627 16.718Z" transform="translate(9.07178 9.07178)" fill="white"></path></svg><div class="toltipuwa">Skype</div></div></a>';
        }

        if (merged_iconss.indexOf("Linkedin") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_16;

          var linkedin_merge =
            '<a target="_blank" href="https://www.linkedin.com/in/' +
            link_mergeddchat +
            '" class="linkedin mergguu" data-placement="333333"><div class="svgtooltip2"><svg width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg" style="' +
            margin_svgggguu +
            '"><circle class="color-element" cx="19.5" cy="19.5" r="19.5" fill="#0077b5"></circle><path id="LinkedIn_color" d="M18,20.1v6.655H14.142V20.549c0-1.56-.558-2.624-1.954-2.624a2.111,2.111,0,0,0-1.98,1.411,2.64,2.64,0,0,0-.128.941v6.481H6.221s.052-10.516,0-11.606H10.08V16.8c-.008.012-.018.026-.025.037h.025V16.8a3.832,3.832,0,0,1,3.478-1.918C16.1,14.88,18,16.539,18,20.1ZM2.184,9.558a2.011,2.011,0,1,0-.051,4.011h.026a2.012,2.012,0,1,0,.025-4.011ZM.229,26.758H4.087V15.152H.229Z" transform="translate(11 1.442)" fill="#fff"></path></svg><div class="toltipuwa">Linkedin</div></div></a>';
        }

        if (merged_iconss.indexOf("Weibo") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_17;

          var weibo_merge =
            '<a target="_blank" href="https://weibo.com/u/' +
            link_mergeddchat +
            '" class="weibo mergguu" data-tooltip="Weibo" data-placement="left"><i style="' +
            iconsss_sizyuu +
            '" class="fa fa-weibo"></i></a>';
        }

        if (merged_iconss.indexOf("QQ") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_18;

          var qq_merge =
            '<a target="_blank" href="http://weixin.qq.com/r/' +
            link_mergeddchat +
            '" class="qq mergguu" data-tooltip="QQ" data-placement="left"><i style="' +
            iconsss_sizyuu +
            '" class="fa fa-qq"></i></a>';
        }

        if (merged_iconss.indexOf("Youtube") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_4;

          var youtube_merge =
            '<a target="_blank" href="https://www.youtube.com/user/' +
            link_mergeddchat +
            '" class="youtube mergguu" data-tooltip="Youtube" data-placement="left"><i style="' +
            iconsss_sizyuu +
            '" class="fa fa-youtube"></i></a>';
        }

        if (merged_iconss.indexOf("Twitch") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_19;

          var twitch_merge =
            '<a target="_blank" href="https://www.twitch.tv/' +
            link_mergeddchat +
            '" class="twitch mergguu" data-tooltip="Twitch" data-placement="left"><i style="' +
            iconsss_sizyuu +
            '" class="fa fa-twitch"></i></a>';
        }

        if (merged_iconss.indexOf("Tiktok") !== -1) {
          var link_mergeddchat = d.settings.style.customized.network_24;

          var tiktok_merge =
            '<a target="_blank" href="https://www.tiktok.com/@' +
            link_mergeddchat +
            '" class="tiktok mergguu" data-placement="left"><div class="svgtooltip2"><svg style="' +
            margin_svgggguu +
            '"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width= "' +
            merge_iconnn_wh +
            'px" height= "' +
            merge_iconnn_wh +
            'px" viewBox="0 0 39 39" version="1.1"><g id="surface1"><path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 19.359375 0 C 8.671875 0 0 8.671875 0 19.359375 C 0 30.046875 8.671875 38.71875 19.359375 38.71875 C 30.046875 38.71875 38.71875 30.046875 38.71875 19.359375 C 38.71875 8.671875 30.046875 0 19.359375 0 Z M 29.074219 14.8125 L 29.074219 17.433594 C 27.832031 17.433594 26.636719 17.191406 25.5 16.714844 C 24.773438 16.40625 24.09375 16.011719 23.472656 15.53125 L 23.492188 23.597656 C 23.484375 25.417969 22.765625 27.125 21.464844 28.410156 C 20.40625 29.457031 19.066406 30.121094 17.609375 30.335938 C 17.269531 30.390625 16.921875 30.414062 16.570312 30.414062 C 15.011719 30.414062 13.535156 29.910156 12.328125 28.976562 C 12.097656 28.804688 11.882812 28.613281 11.675781 28.410156 C 10.265625 27.011719 9.535156 25.128906 9.660156 23.140625 C 9.753906 21.628906 10.359375 20.183594 11.367188 19.058594 C 12.703125 17.5625 14.570312 16.730469 16.570312 16.730469 C 16.921875 16.730469 17.269531 16.753906 17.609375 16.808594 L 17.609375 20.46875 C 17.285156 20.363281 16.941406 20.304688 16.582031 20.304688 C 14.757812 20.304688 13.28125 21.792969 13.304688 23.621094 C 13.320312 24.789062 13.960938 25.808594 14.902344 26.375 C 15.347656 26.636719 15.855469 26.804688 16.394531 26.835938 C 16.824219 26.855469 17.234375 26.796875 17.609375 26.671875 C 18.914062 26.242188 19.855469 25.015625 19.855469 23.570312 L 19.859375 18.167969 L 19.859375 8.304688 L 23.46875 8.304688 C 23.472656 8.664062 23.507812 9.011719 23.578125 9.351562 C 23.851562 10.71875 24.621094 11.90625 25.695312 12.714844 C 26.628906 13.421875 27.792969 13.839844 29.0625 13.839844 C 29.0625 13.839844 29.074219 13.839844 29.074219 13.839844 Z M 29.074219 14.8125 "/></g></svg><div class="toltipuwa">TikTok</div></div></a>';
        }

        var tytyytttt =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
            navigator.userAgent
          ) && !window.MSStream;

        if (true == tytyytttt) {
          //		if (d.settings.style.customized.mobile_label_yn == '0')
          if (
            d.settings.style.customized.mobile_label_yn == "0" &&
            d.settings.style.customized.icon_width <= 70
          ) {
            var disable_labelinmobileyy = "";
          } else {
            var disable_labelinmobileyy =
              'data-tooltip="' + d.settings.texts.button + '";';
          }
        } else {
          var disable_labelinmobileyy =
            'data-tooltip="' + d.settings.texts.button + '";';
        }

if (true == ukkk()) 
{
	var dskmlooobupll = d.settings.style.customized.updown_bottom_m;
}
else
{
	var dskmlooobupll = d.settings.style.customized.updown_bottom;
	
}

      if (d.settings.style.pattern == "100") {
        var colooorrsyy = d.settings.style.customized.background;
      } else {
        var colooorrsyy = "var(--pushdaddyx-background);var(--pushdaddy-background)";
      }



        var final_eeyuyt =
          '<div id="sy-whatshelp" style="bottom:'+dskmlooobupll+'px;'+left_right_secondary_first +
        ':' + d.settings.style.customized.leftt_rightt + '%;">' +
          fbchatt666666 +
          '<div class="sywh-services" style="width:' +
          merge_iconnn_wh +
          'px">' +
          skype_merge +
          " " +
          linkedin_merge +
          " " +
          weibo_merge +
          " " +
          viber_merge +
          " " +
          qq_merge +
          " " +
          snapchat_merge +
          "  " +
          wechat_merge +
          "  " +
          telegramss_merge +
          " " +
          twitch_merge +
          " " +
          email_merge +
          " " +
          youtube_merge +
          "  " +
          call_merge +
          "  " +
          vk_merge +
          " " +
          reddit_merge +
          " " +
          pinterest_merge +
          "  " +
          twitter_merge +
          " " +
          tiktok_merge +
          " " +
          facebook_merge +
          " " +
          instagram_merge +
          "  " +
          messenger_merge +
          "  " +
          whatsapp_merge +
          '</div><a style="width:' +
          merge_iconnn_wh +
          "px;height:" +
          merge_iconnn_wh +
          "px;font-family: " +
          d.settings.style.customized.font +
          ";background:" +
          colooorrsyy +
          '" id="sywh-open-services" class="sywh-open-services"" ' +
          disable_labelinmobileyy +
          ' data-placement="leftuu"><i style="line-height: ' +
          merge_iconnn_wh +
          'px;" class="fa fa-comments"></i><i style="line-height: ' +
          merge_iconnn_wh +
          'px;" class="fa fa-times" ></i></a></div>';

        var euupyy = final_eeyuyt
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "")
          .replace("undefined", "");

        //	return euu;

        var mergeed_iconsdata = euupyy;

        var hide_boxxss = ";display:none;";
      } else {
        var mergeed_iconsdata = "";
        var hide_boxxss = display_yn_main_finaal;
      }

      // here we are trying path filtering ends here

      if (d.settings.style.pattern == "100") {
        if (final_background_img_url == "") {
          if (d.settings.style.customized.icon_width <= 70) {
            var bg_imggggg =
              "background-image:url(" + final_background_img_url2 + ")";
          } else {
            var bg_imggggg = "";
          }
        } else {
          if (d.settings.style.customized.icon_width <= 70) {
            var bg_imggggg =
              "background-image:url(" + final_background_img_url + ")";
          } else {
            var bg_imggggg = "";
          }
        }
      } else {
        var bg_imggggg = "";
      }

      if (d.settings.style.customized.whatsapp_yn == "1") {
        var disable_whatsappp = "display:none;";
      } else {
        var disable_whatsappp = ";";
      }

      //			if (d.settings.style.customized.mobile_label_yn == '0')
      if (
        d.settings.style.customized.mobile_label_yn == "0" &&
        d.settings.style.customized.icon_width <= 70
      ) {
        var opoalrrtrr =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
            navigator.userAgent
          ) && !window.MSStream;

        if (true == opoalrrtrr) {
          var disable_labelinmobile = "display:none;";
        } else {
          var disable_labelinmobile = ";";
        }
      } else {
        var disable_labelinmobile = ";";
      }

      if (d.settings.style.customized.shadow_yn == "1") {
        var boxshadowww = ";box-shadow: none;";
      } else {
       // var boxshadowww = ";box-shadow: none;";
	           var boxshadowww = ";;";

      }

      // testing here

      if (d.settings.style.customized.svg_yes == "0") {
        var newwwsvgicon =
          '<svg class="svg-whatsapp" style="width:' +
          svg_imgggg_width_height_final +
          "px;height:" +
          svg_imgggg_width_height_final +
          "px;margin-top: -" +
          svg_imgggg_marginn1_final +
          "px;margin-left: -" +
          svg_imgggg_marginn +
          "px;left:" +
          leeftt_marginnn +
          "%; " +
          hidesvg +
          ' " viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path></svg>';
      } else if (d.settings.style.customized.svg_yes == "1") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM128 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "2") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM288 264c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm96-96c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "3") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 32"><path d="M28,32 C28,32 23.2863266,30.1450667 19.4727818,28.6592 L3.43749107,28.6592 C1.53921989,28.6592 0,27.0272 0,25.0144 L0,3.6448 C0,1.632 1.53921989,0 3.43749107,0 L24.5615088,0 C26.45978,0 27.9989999,1.632 27.9989999,3.6448 L27.9989999,22.0490667 L28,22.0490667 L28,32 Z M23.8614088,20.0181333 C23.5309223,19.6105242 22.9540812,19.5633836 22.5692242,19.9125333 C22.5392199,19.9392 19.5537934,22.5941333 13.9989999,22.5941333 C8.51321617,22.5941333 5.48178311,19.9584 5.4277754,19.9104 C5.04295119,19.5629428 4.46760991,19.6105095 4.13759108,20.0170667 C3.97913051,20.2124916 3.9004494,20.4673395 3.91904357,20.7249415 C3.93763774,20.9825435 4.05196575,21.2215447 4.23660523,21.3888 C4.37862552,21.5168 7.77411059,24.5386667 13.9989999,24.5386667 C20.2248893,24.5386667 23.6203743,21.5168 23.7623946,21.3888 C23.9467342,21.2215726 24.0608642,20.9827905 24.0794539,20.7254507 C24.0980436,20.4681109 24.0195551,20.2135019 23.8614088,20.0181333 Z"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "4") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800"><path d="M400 26.2c-193.3 0-350 156.7-350 350 0 136.2 77.9 254.3 191.5 312.1 15.4 8.1 31.4 15.1 48.1 20.8l-16.5 63.5c-2 7.8 5.4 14.7 13 12.1l229.8-77.6c14.6-5.3 28.8-11.6 42.4-18.7C672 630.6 750 512.5 750 376.2c0-193.3-156.7-350-350-350zm211.1 510.7c-10.8 26.5-41.9 77.2-121.5 77.2-79.9 0-110.9-51-121.6-77.4-2.8-6.8 5-13.4 13.8-11.8 76.2 13.7 147.7 13 215.3.3 8.9-1.8 16.8 4.8 14 11.7z"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "5") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256.064,0h-0.128C114.784,0,0,114.816,0,256c0,56,18.048,107.904,48.736,150.048l-31.904,95.104l98.4-31.456 C155.712,496.512,204,512,256.064,512C397.216,512,512,397.152,512,256S397.216,0,256.064,0z M405.024,361.504 c-6.176,17.44-30.688,31.904-50.24,36.128c-13.376,2.848-30.848,5.12-89.664-19.264C189.888,347.2,141.44,270.752,137.664,265.792 c-3.616-4.96-30.4-40.48-30.4-77.216s18.656-54.624,26.176-62.304c6.176-6.304,16.384-9.184,26.176-9.184 c3.168,0,6.016,0.16,8.576,0.288c7.52,0.32,11.296,0.768,16.256,12.64c6.176,14.88,21.216,51.616,23.008,55.392 c1.824,3.776,3.648,8.896,1.088,13.856c-2.4,5.12-4.512,7.392-8.288,11.744c-3.776,4.352-7.36,7.68-11.136,12.352 c-3.456,4.064-7.36,8.416-3.008,15.936c4.352,7.36,19.392,31.904,41.536,51.616c28.576,25.44,51.744,33.568,60.032,37.024 c6.176,2.56,13.536,1.952,18.048-2.848c5.728-6.176,12.8-16.416,20-26.496c5.12-7.232,11.584-8.128,18.368-5.568 c6.912,2.4,43.488,20.48,51.008,24.224c7.52,3.776,12.48,5.568,14.304,8.736C411.2,329.152,411.2,344.032,405.024,361.504z"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "6") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M432,0H80C35.817,0,0,35.817,0,80v256c0,44.183,35.817,80,80,80h313.44l91.2,91.36c3.02,2.995,7.107,4.665,11.36,4.64 c8.837,0,16-7.163,16-16V80C512,35.817,476.183,0,432,0z M480,457.44l-68.64-68.8c-3.019-2.995-7.107-4.665-11.36-4.64H80 c-26.51,0-48-21.49-48-48V80c0-26.51,21.49-48,48-48h352c26.51,0,48,21.49,48,48V457.44z"/><circle cx="256" cy="208" r="32"/><circle cx="368" cy="208" r="32"/><circle cx="144" cy="208" r="32"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "7") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M432,0H80C35.817,0,0,35.817,0,80v256c0,44.183,35.817,80,80,80h313.44l91.2,91.36c3.02,2.995,7.107,4.665,11.36,4.64 c8.837,0,16-7.163,16-16V80C512,35.817,476.183,0,432,0z M480,457.44l-68.64-68.8c-3.019-2.995-7.107-4.665-11.36-4.64H80 c-26.51,0-48-21.49-48-48V80c0-26.51,21.49-48,48-48h352c26.51,0,48,21.49,48,48V457.44z"/><rect x="112" y="112" width="160" height="32"/><rect x="112" y="192" width="288" height="32"/><rect x="112" y="272" width="288" height="32"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "8") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M336,0H176C78.798,0,0,78.798,0,176v64c0,97.202,78.798,176,176,176h16v80c0,8.837,7.163,16,16,16 c4.197-0.018,8.22-1.684,11.2-4.64L310.56,416H336c97.202,0,176-78.798,176-176v-64C512,78.798,433.202,0,336,0z M480,240 c0,79.529-64.471,144-144,144h-32c-4.276,0.018-8.367,1.746-11.36,4.8L224,457.44V400c0-8.837-7.163-16-16-16h-32 c-79.529,0-144-64.471-144-144v-64C32,96.471,96.471,32,176,32h160c79.529,0,144,64.471,144,144V240z"/><circle cx="256" cy="208" r="32"/><circle cx="368" cy="208" r="32"/><circle cx="144" cy="208" r="32"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "9") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M336.047,0h-160c-97.202,0-176,78.798-176,176v64c0,97.202,78.798,176,176,176h16v80 c-0.051,8.836,7.07,16.041,15.907,16.093c4.299,0.025,8.426-1.681,11.453-4.733l91.2-91.36h25.44c97.202,0,176-78.798,176-176 v-64C512.047,78.798,433.249,0,336.047,0z M480.047,240c0,79.529-64.471,144-144,144h-32c-4.253-0.025-8.34,1.645-11.36,4.64 l-68.64,68.8V400c0-8.837-7.163-16-16-16h-32c-79.529,0-144-64.471-144-144v-64c0-79.529,64.471-144,144-144h160 c79.529,0,144,64.471,144,144V240z"/><rect x="128.047" y="192" width="256" height="32"/><rect x="128.047" y="112" width="256" height="32"/><rect x="128.047" y="272" width="128" height="32"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "10") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "11") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M136,210c-24.814,0-45,20.186-45,45v122c0,24.814,20.186,45,45,45c24.814,0,45-20.186,45-45V255 C181,230.186,160.814,210,136,210z"/><path d="M61,255c0-4.327,0.571-8.507,1.278-12.634C44.2,248.209,31,265.001,31,285v62c0,19.999,13.2,36.791,31.278,42.634 C61.571,385.507,61,381.327,61,377V255z"/><path d="M376,210c-24.814,0-45,20.186-45,45v122c0,24.814,20.186,45,45,45c4.51,0,8.782-0.868,12.892-2.108 C383.308,438.401,366.305,452,346,452h-47.763c-6.213-17.422-22.707-30-42.237-30c-24.814,0-45,20.186-45,45 c0,24.814,20.186,45,45,45c19.53,0,36.024-12.578,42.237-30H346c41.353,0,75-33.647,75-75v-30V255 C421,230.186,400.814,210,376,210z"/><path d="M449.722,242.366C450.429,246.493,451,250.673,451,255v122c0,4.327-0.571,8.507-1.278,12.634 C467.8,383.791,481,366.999,481,347v-62C481,265.001,467.8,248.209,449.722,242.366z"/><path d="M256,0C131.928,0,31,100.928,31,225v0.383c8.937-6.766,19.277-11.717,30.687-13.934C68.698,110.251,153.054,30,256,30 s187.302,80.251,194.313,181.448c11.409,2.217,21.749,7.169,30.687,13.934V225C481,100.928,380.072,0,256,0z"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "12") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 -26 512 512"><path d="m422.257812 0h-331.445312c-50.074219 0-90.8125 40.648438-90.8125 90.609375v338.878906c0 12.003907 7.28125 22.964844 18.558594 27.921875 3.984375 1.753906 8.207031 2.609375 12.394531 2.605469 7.503906 0 14.898437-2.734375 20.628906-7.949219 41.546875-37.59375 95.320313-58.292968 151.421875-58.292968h.015625l219.296875.015624c49.449219 0 89.683594-40.320312 89.683594-89.882812v-214.363281c0-49.375-40.257812-89.542969-89.742188-89.542969zm59.742188 303.90625c0 33.019531-26.773438 59.882812-59.683594 59.882812l-219.296875-.015624h-.015625c-63.550781 0-124.480468 23.457031-171.582031 66.078124-.144531.128907-.550781.203126-.789063.097657-.332031-.144531-.5625-.417969-.632812-.5625v-338.777344c0-33.417969 27.28125-60.609375 60.8125-60.609375h331.441406c32.941406 0 59.742188 26.710938 59.742188 59.542969v214.363281zm0 0"/><path d="m200.136719 159.507812h38.933593c8.285157 0 15-6.714843 15-15 0-8.28125-6.714843-15-15-15h-38.933593c-18.242188 0-33.082031 14.84375-33.082031 33.085938v80.851562c0 18.242188 14.839843 33.082032 33.082031 33.082032h38.933593c8.285157 0 15-6.714844 15-15s-6.714843-15-15-15h-38.933593c-1.699219 0-3.082031-1.382813-3.082031-3.082032v-25.425781h42.015624c8.285157 0 15-6.714843 15-15 0-8.285156-6.714843-15-15-15h-42.015624v-25.425781c0-1.703125 1.382812-3.085938 3.082031-3.085938zm0 0"/><path d="m334.28125 246.527344h-27.132812c-2.695313 0-4.886719-2.191406-4.886719-4.886719v-97.132813c0-8.28125-6.714844-15-15-15-8.285157 0-15 6.71875-15 15v97.132813c0 19.238281 15.648437 34.886719 34.886719 34.886719h27.132812c8.28125 0 15-6.714844 15-15s-6.71875-15-15-15zm0 0"/><path d="m133.863281 129.507812c-8.28125 0-15 6.71875-15 15v43.511719h-27.015625v-43.511719c0-8.28125-6.71875-15-15-15-8.285156 0-15 6.71875-15 15v117.019532c0 8.285156 6.714844 15 15 15 8.28125 0 15-6.714844 15-15v-43.507813h27.015625v43.507813c0 8.285156 6.71875 15 15 15 8.285157 0 15-6.714844 15-15v-117.019532c0-8.28125-6.714843-15-15-15zm0 0"/><path d="m405.976562 129.507812h-21.933593c-11.898438 0-21.574219 9.679688-21.574219 21.574219v110.445313c0 8.285156 6.714844 15 15 15s15-6.714844 15-15v-45h13.507812c23.992188 0 43.511719-19.515625 43.511719-43.507813 0-23.992187-19.519531-43.511719-43.511719-43.511719zm0 57.019532h-13.507812v-27.019532h13.507812c7.449219 0 13.511719 6.0625 13.511719 13.511719s-6.0625 13.507813-13.511719 13.507813zm0 0"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "13") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="-15 0 512 512"><path d="m417.589844 101.179688c-41.390625-41.394532-96.425782-64.1875-154.960938-64.1875-7.570312 0-15.148437.386718-22.664062 1.160156-2.703125-11.246094-10.109375-20.730469-21.832032-27.289063-19.914062-11.132812-53.382812-13.902343-89.535156-7.40625-36.296875 6.519531-65.703125 20.632813-78.722656 37.832031-25.925781 34.71875-43.082031 90.523438-48.300781 157.132813-5.070313 64.695313 2.238281 132.570313 20.050781 186.222656 22.21875 66.917969 58.882812 109.679688 106.023438 123.65625l.144531.042969c8.457031 2.417969 20.027343 3.65625 32.78125 3.65625 8.441406 0 17.40625-.542969 26.328125-1.648438 18.671875-2.3125 43.839844-7.878906 57.71875-21.246093 8.816406-8.488281 12.167968-19.28125 9.445312-30.386719l-.089844-.359375-24.332031-81.527344c-2.945312-10.125-4.890625-16.816406-11.019531-21.640625-7.144531-5.621094-14.832031-4.796875-23.738281-3.839844l-39.476563 2.925782c-.746094.054687-1.453125-.339844-1.8125-.996094-11.667968-21.265625-20.535156-82.183594-19.378906-107.832031.949219-20.152344 6.699219-59.589844 11.527344-67.371094 1.464844-1.234375 6.238281-1.449219 10.859375-1.652344 14.105469-.628906 37.71875-1.683593 52.339843-34.042969l.1875-.425781 27.785157-73.234375c8.488281-1.148437 17.101562-1.730468 25.707031-1.730468 104.300781 0 189.152344 84.851562 189.152344 189.148437 0 43.15625-14.148438 83.789063-40.914063 117.507813-20.980469 26.425781-48.824219 46.832031-79.992187 58.941406l3.8125-9.9375c2.964844-7.734375-.898438-16.410156-8.632813-19.378906-7.738281-2.964844-16.410156.898437-19.378906 8.632812l-13.332031 34.757812c-2.527344 6.582032-2.257813 14.015626.738281 20.394532s8.542969 11.332031 15.222656 13.59375l36.484375 12.34375c1.59375.539062 3.214844.792968 4.808594.792968 6.316406 0 12.207031-4.019531 14.269531-10.378906 2.554688-7.878906-2.03125-16.320312-9.878906-18.972656l-12.429687-4.207031c35.769531-14.070313 67.707031-37.574219 91.804687-67.929688 31.019531-39.078125 47.417969-86.160156 47.417969-136.15625.003906-58.539062-22.792969-113.574219-64.1875-154.964843zm-208.507813-43.652344-27.660156 72.902344c-6.96875 15.167968-13.8125 15.472656-26.152344 16.023437-9.324219.417969-22.09375.984375-31.71875 11.425781-4.535156 4.871094-9.835937 14.109375-14.773437 45.449219-2.5625 16.265625-4.1875 33.597656-4.523438 40.738281-1.21875 26.972656 7.050782 96.234375 23.6875 123.996094 10.765625 17.8125 32.925782 15.964844 44.832032 14.972656l26.832031-2.015625 25.367187 85.058594c0 .003906 0 .007813.003906.015625-.816406 1.808594-9.046874 9.246094-34.957031 13.507812-22.289062 3.664063-43.96875 2.734376-53.917969-.082031-26.019531-7.742187-62.035156-32.132812-86.003906-104.328125-16.597656-49.996094-23.382812-113.570312-18.613281-174.421875 4.710937-60.148437 20.175781-111.730469 42.367187-141.449219 8.148438-10.761718 32.28125-21.347656 60.050782-26.335937 28.652344-5.144531 55.96875-3.550781 69.589844 4.066406 6.878906 3.847657 10.214843 8.613281 5.589843 20.476563zm0 0"/><path d="m254.488281 186.253906h-39.457031c-8.28125 0-15 6.714844-15 15 0 8.28125 6.71875 15 15 15h36.933594v21.929688h-24.457032c-15.148437 0-27.476562 12.324218-27.476562 27.476562v26.976563c0 15.152343 12.328125 27.476562 27.476562 27.476562h39.457032c8.28125 0 15-6.714843 15-15 0-8.285156-6.71875-15-15-15h-36.933594v-21.929687h24.457031c15.148438 0 27.476563-12.324219 27.476563-27.476563v-26.980469c-.003906-15.148437-12.328125-27.472656-27.476563-27.472656zm0 0"/><path d="m309.640625 186.253906c-8.28125 0-15 6.714844-15 15v39.453125c0 15.152344 12.328125 27.476563 27.476563 27.476563h24.457031v36.929687c0 8.285157 6.714843 15 15 15 8.28125 0 15-6.714843 15-15v-103.859375c0-8.285156-6.71875-15-15-15-8.285157 0-15 6.714844-15 15v36.929688h-21.933594v-36.929688c0-8.285156-6.714844-15-15-15zm0 0"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "14") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M437.019,74.983C388.667,26.63,324.38,0.002,256.001,0.002S123.334,26.632,74.983,74.983 C26.63,123.334,0,187.621,0,256.001c0,68.378,26.629,132.662,74.978,181.013l0.002,0.002c0,0,0,0,0.002,0.002 c0,0,0,0.002,0.002,0.002c48.35,48.351,112.637,74.98,181.016,74.98s132.668-26.629,181.019-74.98 C485.371,388.666,512,324.379,512,255.998C511.998,187.619,485.37,123.333,437.019,74.983z M256.001,46.545 c48.114,0,93.741,16.128,130.738,45.801l-49.825,49.828c-9.438-6.713-19.72-12.268-30.684-16.497 c-16.018-6.178-32.911-9.311-50.238-9.311c-30.109,0-58.023,9.582-80.854,25.854l-49.875-49.875 C162.26,62.673,207.887,46.545,256.001,46.545z M349.093,256.001c0,51.33-41.759,93.091-93.088,93.091h-0.006 c-51.33,0-93.091-41.76-93.091-93.091c0-51.329,41.756-93.088,93.112-93.088c11.546,0,22.804,2.084,33.458,6.194 C325.133,182.856,349.09,217.778,349.093,256.001z M46.545,256.001c0-48.115,16.128-93.744,45.804-130.744l49.875,49.875 c-16.277,22.835-25.861,50.753-25.861,80.869c0,30.113,9.584,58.031,25.857,80.865l-49.875,49.873 C62.673,349.741,46.545,304.115,46.545,256.001z M255.999,465.453c-48.115,0-93.744-16.125-130.743-45.802l49.876-49.875 c22.834,16.275,50.751,25.859,80.865,25.859h0.006c30.112,0,58.028-9.582,80.86-25.856l49.875,49.873 C349.745,449.327,304.115,465.453,255.999,465.453z M419.654,386.74l-49.875-49.875c16.275-22.834,25.859-50.753,25.859-80.868 c-0.002-28.763-8.684-56.391-25.108-79.897c-0.236-0.338-0.486-0.662-0.726-0.998l49.847-49.849 c29.674,36.999,45.804,82.627,45.804,130.743C465.455,304.113,449.327,349.741,419.654,386.74z"/></svg>';
      } else if (d.settings.style.customized.svg_yes == "15") {
        var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M248.158,343.22c-14.639,0-26.491,12.2-26.491,26.84c0,14.291,11.503,26.84,26.491,26.84 c14.988,0,26.84-12.548,26.84-26.84C274.998,355.42,262.799,343.22,248.158,343.22z"/><path d="M252.69,140.002c-47.057,0-68.668,27.885-68.668,46.708c0,13.595,11.502,19.869,20.914,19.869 c18.822,0,11.154-26.84,46.708-26.84c17.429,0,31.372,7.669,31.372,23.703c0,18.824-19.52,29.629-31.023,39.389 c-10.108,8.714-23.354,23.006-23.354,52.983c0,18.125,4.879,23.354,19.171,23.354c17.08,0,20.565-7.668,20.565-14.291 c0-18.126,0.35-28.583,19.521-43.571c9.411-7.32,39.04-31.023,39.04-63.789S297.307,140.002,252.69,140.002z"/><path d="M256,0C114.516,0,0,114.497,0,256v236c0,11.046,8.954,20,20,20h236c141.483,0,256-114.497,256-256 C512,114.516,397.503,0,256,0z M256,472H40V256c0-119.377,96.607-216,216-216c119.377,0,216,96.607,216,216 C472,375.377,375.393,472,256,472z"/></svg>';
      } else {
		        if (d.settings.style.customized.svg_yes == undefined) 
					{

      var newwwsvgicon =
          '<svg class="pushdaddyx-svg" style="position: absolute;left: 50%;-webkit-transform: translateX(-50%); -ms-transform: translateX(-50%);transform: translateX(-50%);color:' +
          d.settings.style.customized.svg_color +
          '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256.064,0h-0.128C114.784,0,0,114.816,0,256c0,56,18.048,107.904,48.736,150.048l-31.904,95.104l98.4-31.456 C155.712,496.512,204,512,256.064,512C397.216,512,512,397.152,512,256S397.216,0,256.064,0z M405.024,361.504 c-6.176,17.44-30.688,31.904-50.24,36.128c-13.376,2.848-30.848,5.12-89.664-19.264C189.888,347.2,141.44,270.752,137.664,265.792 c-3.616-4.96-30.4-40.48-30.4-77.216s18.656-54.624,26.176-62.304c6.176-6.304,16.384-9.184,26.176-9.184 c3.168,0,6.016,0.16,8.576,0.288c7.52,0.32,11.296,0.768,16.256,12.64c6.176,14.88,21.216,51.616,23.008,55.392 c1.824,3.776,3.648,8.896,1.088,13.856c-2.4,5.12-4.512,7.392-8.288,11.744c-3.776,4.352-7.36,7.68-11.136,12.352 c-3.456,4.064-7.36,8.416-3.008,15.936c4.352,7.36,19.392,31.904,41.536,51.616c28.576,25.44,51.744,33.568,60.032,37.024 c6.176,2.56,13.536,1.952,18.048-2.848c5.728-6.176,12.8-16.416,20-26.496c5.12-7.232,11.584-8.128,18.368-5.568 c6.912,2.4,43.488,20.48,51.008,24.224c7.52,3.776,12.48,5.568,14.304,8.736C411.2,329.152,411.2,344.032,405.024,361.504z"/></svg>';


					}
					else
					{
					        var newwwsvgicon = "";
	
					}
		  
		  
      }

      if (d.settings.style.customized.svg_yes == "0") {
        var addwidgettteclass = "";
        var addxxclass = "";
        var addsvgcodee = "";
      } else {
        var addwidgettteclass = "pushdaddyx-clip-path";
        var addxxclass = "x";

        var addsvgcodee =
          '<svg class="pushdaddyx-svg-clip-path"><defs><clipPath id="pushdaddyx-chat-button-clip-path" clipPathUnits="objectBoundingBox"><path d="M0.11,0.09 C0.014,0.174,-0.003,0.398,0,0.499 C-0.003,0.618,0.015,0.849,0.125,0.919 C0.235,0.989,0.413,0.997,0.504,0.999 C0.604,0.999,0.719,0.999,0.869,0.924 C0.974,0.849,0.994,0.704,0.999,0.499 C1,0.295,0.984,0.155,0.879,0.075 C0.796,0.011,0.593,-0.003,0.504,0 C0.413,-0.005,0.206,0.006,0.11,0.09"></path></clipPath></defs></svg>';
      }

      // var e = ''+mergeed_iconsdata+'<div id="pushdaddy-button" class="pushdaddy-button pwapp-animated pwapp-'+d.settings.style.customized.animation_count+' '+d.settings.style.customized.button_animation+'" style="width:'+d.settings.style.customized.icon_width+'px;height:'+final_heighttt+'px;border-radius: ' + d.settings.style.customized.border_radius + 'px;bottom: ' + d.settings.style.customized.updown_bottom + 'px;'+left_right_secondary_first+':' + d.settings.style.customized.leftt_rightt + '%; ' + hide_boxxss + ' '+bg_imggggg+';background-size: auto;background-position: center;background-repeat: no-repeat; ' +transparenttt + ' ' +disable_whatsappp + ' ' +boxshadowww + '"><%= widget_button_label %><%= widget_whatsapp_icon %><%= widget_close_icon %></div>'+secondary_btnn+'';

 
 let ctoenabled = '0';
  ctoenabled = calltoaget(`pushaa_greeting`);
	var calltoaction ='';
	
	if (d.settings.style.customized.ctaction_animation === 'pwapp-slideInUp')
	{
	var addtwo ='pwapp-animated2';	
	}
	
	else
	{
		var addtwo ='pwapp-animated';	
	
	}
	
if (d.settings.style.customized.clicktcart === '1' && d.settings.style.customized.clicktcart_text.length > 0 && ctoenabled !== '1') 
//if (ctoenabled !== '1') 

{
var calltoaction ='<div id="pushdaddy-greetingcta" style="'+left_right_secondary_first+': '+ d.settings.style.customized.leftt_rightt +'%;" class="pushdaddy-greetingcta--opened '+addtwo+' '+ d.settings.style.customized.clicktcart_anim_c +' '+ d.settings.style.customized.ctaction_animation +'">'+ d.settings.style.customized.clicktcart_text +'<span id="pushdaddy-greetingcta-close"><svg height="10" width="10" class="pushaa-svg-close" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 20"><path d="M11.414 10l6.293-6.293a1 1 0 10-1.414-1.414L10 8.586 3.707 2.293a1 1 0 00-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 101.414 1.414L10 11.414l6.293 6.293A.998.998 0 0018 17a.999.999 0 00-.293-.707L11.414 10z"></path></svg></span></div>';
	
	
	
}

var eghggl = document.getElementById("pushdaddy-greetingcta-close");
	
 
		
	if(eghggl){
  eghggl.addEventListener("click", function () {
                    
					ctoactionn();

		  })
		  }


	
		
	


if (true == ukkk()) 
{
	var dskmlooobup = d.settings.style.customized.updown_bottom_m;
}
else
{
	var dskmlooobup = d.settings.style.customized.updown_bottom;
	
}


      var e =
        "" +
        mergeed_iconsdata + calltoaction +
        " " +
        addsvgcodee +
        '<div id="pushdaddy' +
        addxxclass +
        '-button" class="pushdaddy' +
        addxxclass +
        "-button pwapp-animated pwapp-" +
        d.settings.style.customized.animation_count +
        " " +
        d.settings.style.customized.button_animation +
        '" style="width:' +
        d.settings.style.customized.icon_width +
        "px;height:" +
        final_heighttt +
        "px;border-radius: " +
        d.settings.style.customized.border_radius +
        "px;bottom: " +
        dskmlooobup +
        "px;" +
        left_right_secondary_first +
        ":" +
        d.settings.style.customized.leftt_rightt +
        "%; " +
        hide_boxxss +
        " " +
        bg_imggggg +
        ";background-size: auto;background-position: center;background-repeat: no-repeat; " +
        transparenttt +
        " " +
        disable_whatsappp +
        " " +
        boxshadowww +
        '"><%= widget_button_label %><%= widget_whatsapp_icon %><%= widget_close_icon %></div>' +
        secondary_btnn +
        "";

 let blinkenabled = '0';
  blinkenabled = calltoaget(`pushaa_blink`);
	var blinkicoonm ='';


if(d.settings.style.customized.blink_circle ==='1' && blinkenabled !== '1')
{
	var blinkicoonm ='<span id="pushy-pending" class="pwapp-animated pwapp-infinite '+d.settings.style.customized.blink_animation+'">1</span>';

//console.log('33333333');

	

	
}
else
{
	var blinkicoonm ='';
	
}

if (d.settings.style.customized.chatnow_color == "" || d.settings.style.customized.chatnow_color == undefined) 
		{
var lableeecoloooor ='black;';
		}

else
{
var lableeecoloooor = d.settings.style.customized.chatnow_color +";";

}	
	
	if (lableeecoloooor == undefined) 
	{
var lableeecoloooorff = 'black;';
	}

else

{
var lableeecoloooorff = lableeecoloooor;

}	


if(hidesvg2 == "display:none;")
{
var svg_imgggg_width_height_final2 ='0'; 	
}
else
{
var svg_imgggg_width_height_final2 = svg_imgggg_width_height_final; 	
	
}


if(d.settings.style.customized.labelradius != "8")
{
var  lblrdssu ="border-radius:" + d.settings.style.customized.labelradius + "px;" ;	
}
else
{
var lblrdssu ="border-radius:8px;" ; 	
	
}




      return (e = e
        .replace(
          /<%= widget_button_label %>/g,
          d.settings.texts.button.length
            ? '<div class="pushdaddy-button-label"  id="pushdaddy-button-label" style="'+lblrdssu+' color:'+ lableeecoloooorff +' ;margin:0 ' +
                lable_marginnn_finnnnn_finaaalll +
                "px;padding:" +
                lable_paddinggg1 +
                "px " +
                lable_paddinggg1 +
                "px;  " +
                boxshadowww +
                " " +
                disable_labelinmobile +
                " " +
                lable_rightt_marginnn +
                " " +
                lable_bgroundcolor +
                " font-family: " +
                d.settings.style.customized.font +
                ";font-weight: " +
                d.settings.style.customized.font_weight +
                "; " +
                label_fontsizee +
                ' ">' +
                d.settings.texts.button +
                "</div>"
            : ""
        )
        .replace(
          /<%= widget_whatsapp_icon %>/g,
          '<img style="width: ' +
            svg_imgggg_width_height_final2 +
            "px;height: " +
            svg_imgggg_width_height_final2 +
            "px;left:" +
            leeftt_marginnn +
            "%;position: absolute;" +
          hidesvg2 +
            ';top: 50%;transform: translateY(-50%);" src="' +
            bgimgicon +
            '">' +
            newwwsvgicon +
            ""
        )
        .replace(
          /<%= widget_close_icon %>/g,
          '<svg class="svg-close"><path d="M13.978 12.637l-1.341 1.341L6.989 8.33l-5.648 5.648L0 12.637l5.648-5.648L0 1.341 1.341 0l5.648 5.648L12.637 0l1.341 1.341L8.33 6.989l5.648 5.648z"></path></svg>'+blinkicoonm+''
        ));
    }

   function ctoactionn() {

        const holaaa = document['getElementById']("pushdaddy-greetingcta");
        if (holaaa !== null) {
            holaaa['classList']['remove']('pushdaddy-greetingcta--opened');
            setTimeout(function() {
                holaaa['remove']()
            }, 200);
			 calltoas(`pushaa_greeting`, '1')

        }
    }

   function blinkkactionn() {

	  var  elementhg = document.getElementById('pushy-pending');
if (elementhg != null) 
{

document.getElementById("pushy-pending").style.visibility = "hidden";

}
else
{
	
}

			 calltoas(`pushaa_blink`, '1')

    }





    function processShowDialog(object) {
		
      FB.CustomerChat.show();
      object.css("max-height", "100%");
      object
        .removeClass("fb_customer_chat_bounce_out_v2")
        .addClass("fb_customer_chat_bounce_in_v2");
    }

    function processHideDialog(object) {
      FB.CustomerChat.show();
      object.css("max-height", "0px");
      object
        .removeClass("fb_customer_chat_bounce_in_v2")
        .addClass("fb_customer_chat_bounce_out_v2");
    }

    function a() {

      var e =
        d.settings.texts.title.length ||
        d.settings.texts.description.length ||
        d.settings.texts.note.length
          ? '<div class="pushdaddy-greeting"><%= widget_title %><%= widget_description %><%= widget_note %></div>'
          : "";

      // if(d.settings.style.customized.background_pic_header !='' && d.settings.style.customized.extend_header_img =='1')

      if (d.settings.style.customized.extend_header_img == "1") {
        //jQuery('.pushdaddy-note').css('background', 'transparent');
        var addtransparent = ";background:transparent;";
      } else {
        var addtransparent = ";";
      }

      if (
        d.settings.style.customized.title_textsize != "24" &&
        d.settings.style.customized.title_textsize != "0" &&
        d.settings.style.customized.title_textsize != ""
      ) {
        //jQuery('.pushdaddy-note').css('background', 'transparent');
        var title_textsize_show =
          'style="font-size: ' +
          d.settings.style.customized.title_textsize +
          'px;"';
      } else {
		  
	  if (d.settings.style.customized.leftrightclose == "left") {
		        var title_textsize_show = 'style="text-align: right;"';

      } else {
				        var title_textsize_show =  'style="text-align: left;"';

      }		  
		  
		  
		  
      }
	  
	  
   
	  

      if (
        d.settings.style.customized.waving_img != "" &&
        d.settings.style.customized.waving_img != undefined
      ) {
        //jQuery('.pushdaddy-note').css('background', 'transparent');
        var titleimgwidth = d.settings.style.customized.title_textsize * 0.8;

        var titleshowimage =
          '&nbsp;<img style="width:' +
          titleimgwidth +
          "px;border-radius: 50%;height:" +
          titleimgwidth +
          'px;" src="' +
          d.settings.style.customized.waving_img +
          '" />';
      } else {
        var titleshowimage = "";
      }
	  
	  
//console.log(headerrrrleftt);
if (d.settings.mobile.layout == "newchat3" || d.settings.desktop.layout == "newchat3") 

 {
var topavatarrr ='<div class="avatars-wrapper"><div class="header-ava" style="background-image: url(\''+d.block.avatar+'\');"></div></div><div class="avatars-wrapper" style="width: 52px;height: 52px;margin: 0px 18px 0px 0px;float: left;"><div class="header-ava" style="background-image: url(\''+d.block.avatar+'\');width: 52px;height: 52px;border-radius: 24px;background-size: cover;background-position: center center;float: left;"></div></div>';
 }


 else
 {
var topavatarrr ='';
	 
 }

      return (e = e
        .replace(
          /<%= widget_title %>/g,
          d.settings.texts.title.length
            ? ''+topavatarrr+'<h2 class="pushdaddy-title" ' +
        title_textsize_show +
        ">" +
                d.settings.texts.title + 
                titleshowimage +
                "</h2>"
            : ""
        )
        .replace(
          /<%= widget_description %>/g,
          d.settings.texts.description.length
            ? '<div class="pushdaddy-description">' +
                d.settings.texts.description +
                "</div>"
            : ""
        )
        .replace(
          /<%= widget_note %>/g,
          d.settings.texts.note.length
            ? '<div class="pushdaddy-note" style="' +
                addtransparent +
                '">' +
                d.settings.texts.note +
                "</div>"
            : ""
        ));
				
		
    }

    function puuu() {

      var final_background_img_header_url =
        d.settings.style.customized.background_pic_header;

      if (final_background_img_header_url != "") {
        var bg_imggggg_header =
          "background-image:url(" +
          final_background_img_header_url +
          ");background-position: " +
          d.settings.style.customized.header_posit_img +
          ";";
      } else {
        var bg_imggggg_header = ";";
      }

      if (
        d.settings.style.customized.header_text_color != "" &&
        d.settings.style.customized.header_text_color != "#"
      ) {
        var addtextcolor =
          "color:" + d.settings.style.customized.header_text_color + "";
      }

      if (d.settings.style.customized.background_pic_header == "") {
        var addbgcolor =
          "background-color:" +
          d.settings.style.customized.header_bg_color +
          "";
      }

      if (d.settings.style.customized.header_bg_color != "") {
        if (d.settings.style.customized.header_bg_color != "#") {
          var addtextcolor =
            "color:" + d.settings.style.customized.header_text_color + "";
          var addbgcolor =
            "background-color:" +
            d.settings.style.customized.header_bg_color +
            "";
        } else {
          var addtextcolor = ";";
          var addbgcolor = ";";
        }
      }

      if (d.settings.style.customized.what_bg != "") {
        var header_relativeee = ";position: initial;";
      } else {
        var header_relativeee = ";";
      }

      if (
        d.settings.style.customized.chatbox_radius != "8" &&
        d.settings.style.customized.chatbox_radius != ""
      ) {
        var radius_bodyyheader =
          ";border-radius:" +
          d.settings.style.customized.chatbox_radius +
          "px; " +
          d.settings.style.customized.chatbox_radius +
          "px; 0 0;";
      } else {
        var radius_bodyyheader = ";";
      }

      // var e = '<div class="pushdaddy-header" style="'+bg_imggggg_header+';'+addtextcolor+';'+addbgcolor+' '+header_relativeee+'"><div id="pushdaddy-close"><svg><g transform="translate(-340.000000,-32.000000)"><polygon points="350.656537 44 346 39.343463 341.343463 44 340 42.656537 344.656537 38 340 33.343463 341.343463 32 346 36.656537 350.656537 32 352 33.343463 347.343463 38 352 42.656537"></polygon></g></svg></div><%= widget_greeting %><div class="pushdaddy-personal"></div></div>';

   if (d.settings.style.customized.leftrightclose == "left") {
        var closeposition = ";left: 12px;";

      } else {
        var closeposition = ";right: 12px;";

      }

   if (d.settings.style.customized.header_flat == "0") {
        var roundflattttt99 = "99";
      } else {
        var roundflattttt99 = "";
      }



      var e =
        '<div class="pushdaddy-header'+roundflattttt99+'" style="' +
        bg_imggggg_header +
        ";" +
        addtextcolor + 
        ";" +
        addbgcolor +
        " " +
        header_relativeee +
        " " +
        radius_bodyyheader +
        '"><div id="pushdaddy-close" style="'+closeposition+'"><svg><g transform="translate(-340.000000,-32.000000)"><polygon points="350.656537 44 346 39.343463 341.343463 44 340 42.656537 344.656537 38 340 33.343463 341.343463 32 346 36.656537 350.656537 32 352 33.343463 347.343463 38 352 42.656537"></polygon></g></svg></div><%= widget_greeting %><div class="pushdaddy-personal"></div></div>';

      //        var e = '<div class="pushdaddy-header"><div id="pushdaddy-close"><svg><g transform="translate(-340.000000,-32.000000)"><polygon points="350.656537 44 346 39.343463 341.343463 44 340 42.656537 344.656537 38 340 33.343463 341.343463 32 346 36.656537 350.656537 32 352 33.343463 347.343463 38 352 42.656537"></polygon></g></svg></div><%= widget_greeting %><div class="pushdaddy-personal"></div></div>';

      return (e = e.replace(/<%= widget_greeting %>/g, a()));
	  
    }

    function f() {

      var e =
        '<div class="pushdaddy-footer"><pre id="pushdaddy-response-invisible"></pre><textarea id="pushdaddy-response-message" style="border: 0px !important;" placeholder="<%= widget_placeholder %>"></textarea><div class="pushdaddy-actions"><div id="pushdaddy-emoji" class="pushdaddy-action"><svg><path d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm0 1C4.589 1 1 4.589 1 9s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zM5 6.999a1 1 0 1 1 2.002.004A1 1 0 0 1 5 6.999zm5.999 0a1.002 1.002 0 0 1 2.001 0 1 1 0 1 1-2.001 0zM8.959 13.5c-.086 0-.173-.002-.26-.007-2.44-.132-4.024-2.099-4.09-2.182l-.31-.392.781-.62.312.39c.014.017 1.382 1.703 3.37 1.806 1.306.072 2.61-.554 3.882-1.846l.351-.356.712.702-.35.356c-1.407 1.427-2.886 2.15-4.398 2.15z"></path></svg></div><div id="pushdaddy-reply" class="pushdaddy-action"><svg><path d="M1.388 15.77c-.977.518-1.572.061-1.329-1.019l1.033-4.585c.123-.543.659-1.034 1.216-1.1l6.195-.72c1.648-.19 1.654-.498 0-.687l-6.195-.708c-.55-.063-1.09-.54-1.212-1.085L.056 1.234C-.187.161.408-.289 1.387.231l12.85 6.829c.978.519.98 1.36 0 1.88l-12.85 6.83z"></path></svg></div></div></div>';
      return (e = e.replace(
        /<%= widget_placeholder %>/g,
        sanitize(d.settings.texts.placeholder)
      ));
	  


    }

    function s() {

      return d.block.avatar.length
        ? '<div class="pushdaddy-avatar" style="background-image:url(' +
            d.block.avatar +
            ');"><span>' +
            d.block.name +
            "</span></div>"
        : "";
		

    }

    function muuu() {

      var e =
          '<div class="pushdaddy-account <%= account_status %>" data-id="<%= account_id %>"><%= account_avatar %><div class="pushdaddy-profile"><div class="pushdaddy-name"><%= account_name %></div><div class="pushdaddy-label"><%= account_label %></div></div></div>',
        a = d.block,
        t = a.label,
        n = "pushdaddy-online";
      return (
        "offline" ==
          (function () {
            var e = d.block;
            if ("1" == e.online || 0 == d.settings.charge) return "online";
            var a = {
                timeZone: e.timezone,
              },
              t = new Date().toLocaleString([], a),
              //    n = new Date(t);
              sutli = new Date(t);

            if (sutli == "Invalid Date") {
              var resrt = t.split(",");
              var hjhh = resrt[0];
              var balanceetime = resrt[1];
              var etyt = hjhh.replace(".", "/").replace(".", "/");
              var final_datee = createDateObject(etyt) + balanceetime;
              var n = new Date(final_datee);
            } else {
              var n = new Date(sutli);
            }

            var r = [
                "sunday",
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
              ][n.getDay()],
              o = e[r];
			//  var dkkdkfd = o.enabled;

if (o == undefined )
{
				return "online"	

}

       else  if ("1" == o.enabled) {
		//	 if ("1" == o.enabled || o == undefined) {
              var s = o.range;
              s = s.split(",");
              var i = 60 * n.getHours() + n.getMinutes();
              if (s[0] < i && i < s[1]) return "online";
            }			
            return "offline";
          })() &&
          ((n = "pushdaddy-offline"),
          (t =
            '<svg viewBox="0 0 8 10"><g><polygon points="4 0 4 0.9 6.2 0.9 4 3.9 4 4.7 7.6 4.7 7.6 3.8 5.3 3.8 7.5 0.8 7.5 0"></polygon><path d="M3 5.7L3 4.7 3 3.9 3 3.5 3.2 3.3 4 2.2C3.8 2.2 3.7 2.2 3.5 2.2 1.6 2.2 0 3.7 0 5.7 0 7.6 1.6 9.2 3.5 9.2 5.4 9.2 7 7.6 7 5.7L4 5.7 3 5.7Z"></path></g></svg>' +
            a.offline)),
        (e = e
          .replace(/<%= account_id %>/g, a.id)
          .replace(/<%= account_avatar %>/g, s())
          .replace(/<%= account_name %>/g, a.name)
          .replace(/<%= account_label %>/g, t)
          .replace(/<%= account_status %>/g, n))
      );
	  


    }

   function golumuuu() {

	   
if("1" == d.block.page_url)
	{
     var  a = d.settings.texts.prefilledt + "\x0A\x0A" + window.location.href ;
	     //  var  a = '' ;

	}
	else
	{
	      var  a = d.settings.texts.prefilledt  ;

	
	}
	
    // a = a.trim().replace(/\n\r?/g, "\x0A").replaceAll("<", "[").replaceAll(">", "]");
	    a = a.trim().replace(/\n\r?/g, "\x0A").replace("<", "[").replace(">", "]");
	
      var t = i();
        (t += "&text=" + encodeURIComponent(a));
   
	   
	   
	   
	   
      var e =
'<a style="text-decoration:none" href="'+t+'" target="_blank"><div class="list-cs"><div><div class="wa-chat-bubble-avatar"><img style="height: 55px; width: 55px; border-radius: 50%; background: #20802C;" class="avatar-theme-301" src="' +
            d.block.avatar + '"></div></div><div class="wa-chat-bubble-cs-profile"><div class="wa-chat-bubble-profile-name">' +
            d.block.name + '</div><p>' +
            d.block.label + '</p></div></div></a>',
        a = d.block,
        t = a.label,
        n = "pushdaddy-online";
      return (
        "offline" ==
          (function () {
            var e = d.block;
            if ("1" == e.online || 0 == d.settings.charge) return "online";
            var a = {
                timeZone: e.timezone,
              },
              t = new Date().toLocaleString([], a),
              //    n = new Date(t);
              sutli = new Date(t);

            if (sutli == "Invalid Date") {
              var resrt = t.split(",");
              var hjhh = resrt[0];
              var balanceetime = resrt[1];
              var etyt = hjhh.replace(".", "/").replace(".", "/");
              var final_datee = createDateObject(etyt) + balanceetime;
              var n = new Date(final_datee);
            } else {
              var n = new Date(sutli);
            }

            var r = [
                "sunday",
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
              ][n.getDay()],
              o = e[r];
       	 //  if ("1" == o.enabled) {
			 if ("1" == o.enabled || o == undefined) {
              var s = o.range;
              s = s.split(",");
              var i = 60 * n.getHours() + n.getMinutes();
              if (s[0] < i && i < s[1]) return "online";
            }
            return "offline";
          })() &&
          ((n = "pushdaddy-offline"),
          (t =
            '<svg viewBox="0 0 8 10"><g><polygon points="4 0 4 0.9 6.2 0.9 4 3.9 4 4.7 7.6 4.7 7.6 3.8 5.3 3.8 7.5 0.8 7.5 0"></polygon><path d="M3 5.7L3 4.7 3 3.9 3 3.5 3.2 3.3 4 2.2C3.8 2.2 3.7 2.2 3.5 2.2 1.6 2.2 0 3.7 0 5.7 0 7.6 1.6 9.2 3.5 9.2 5.4 9.2 7 7.6 7 5.7L4 5.7 3 5.7Z"></path></g></svg>' +
            a.offline)),
        (e = e
          .replace(/<%= account_id %>/g, a.id)
          .replace(/<%= account_avatar %>/g, s())
          .replace(/<%= account_name %>/g, a.name)
          .replace(/<%= account_label %>/g, t)
          .replace(/<%= account_status %>/g, n))
      );
	  


    }




    function createDateObject(value) {

      try {
        //  return new Date(value.split('/').reverse().join('/'));
        return value.split("/").reverse().join("/");
      } catch (e) {
        return null;
      }
    }

    function h() {

      var e = d.block.chat.greeting || "";
      if (0 == e.length || "0" == d.block.chat.enabled) return "";
 

 
 
 
 // if (d.settings.desktop.layout == "baby" || d.settings.mobile.layout == "baby") 
if (true == ukkk() && d.settings.mobile.layout == "baby") 

 {
var babyyesno =' pushy-whatsapp-message';
 }

else if (true != ukkk() && d.settings.desktop.layout == "baby") 

 {
var babyyesno =' pushy-whatsapp-message';
 }
 
 else
 {
var babyyesno ='';
	 
 }
 
  if (d.settings.style.customized.bot_yn == "1" && d.settings.style.customized.advance_bot !='1')
 {
var botdataaaddd = '<div class="bot1"><a id="1123" class="btnbooot">' +d.settings.texts.bot_tri_button + '</a><br><br><br><br><br></div>';



 }
 
 else if (d.settings.style.customized.bot_yn == "1" && d.settings.style.customized.advance_bot =='1')
 {
var botdataaaddd = '<div class="bot1">'+d.settings.style.customized.adddv_bott+'</div>';



 }
 
else
{
	var botdataaaddd = '';

}
 

 
if (d.settings.style.customized.faq_yn == "1") {

var a =
        '<div class="pushdaddy-chat '+babyyesno+'"><%= account_avatar %><%= chat_message %></div>' +
        faqpd43() +
        " ";
}
else if (d.settings.desktop.layout == "newchat3") {

var a = '<div class="pushdaddy-chat '+babyyesno+'"><%= chat_message %></div>'+botdataaaddd+'';
	
}

else
{
var a = '<div class="pushdaddy-chat '+babyyesno+'"><%= account_avatar %><%= chat_message %></div>'+botdataaaddd+'';
	
}



    
      return (a = a
        .replace(/<%= chat_message %>/g, e)
        .replace(/<%= account_avatar %>/g, s()));
		

    }

    function n() {

      var e = "https://web.whatsapp.com/send";
      var opoalios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      var opoal =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
          navigator.userAgent
        ) && !window.MSStream;




      if (true == opoal) {

			 if (true == opoalios) {  
		            var pathhhu = "whatsapp://send";
	  
			 }
			 else
			 {
            var pathhhu = "https://api.whatsapp.com/send";
			 } 
		        } else {
        // var pathhhu= "https://api.whatsapp.com/send";
        var pathhhu = "https://web.whatsapp.com/send";
      }

      return ukkk() && (e = "" + pathhhu + ""), e;
	  
  
    }

    function i(e) {

      e = e || !1;
      var a = n(),
        t = d.block.number;
      // return -1 !== t.indexOf("chat.whatsapp.com") ? a = t : a += "?phone=" + t, e && (a += "&text=" + (e = w())), encodeURI(a)
	  // var textdata = w().replace("<", "[").replace(">", "]") ;
	  	//  console.log(textdata);

      return (
-1 !== t.indexOf("chat.whatsapp.com") ? (a = t) : (a += "?phone=" + t), e && (a += "&text=" + (e = w())),
//-1 !== t.indexOf("chat.whatsapp.com") ? (a = t) : (a += "?phone=" + t), e && (a += "&text=" + (e = sanitize(w()))),


	  //   e && (a += "&text=" + (e = textdata)),
        encodeURI(a)
      );
	  

    }

    function c() {

      var e = window.location;
      //     return window != window.top && (e = window.top.location), e.origin + e.pathname +'%0A%0A';
      return (
        window != window.top && (e = window.top.location), e.origin + e.pathname
      );
	 

    }

    function w() {

      var e = d.block.message;
      // return "1" == d.block.page_url && (e = c() + "\n\n  " + e), e
      return "1" == d.block.page_url && (e = c() + "\x0A\x0A" + e), e;
    }

    function l() {

      var e = d.emojis,
        a = "";
      for (var t in e) {
        var n = e[t],
          r = "emoji_" + t;
        a +=
          '<div class="pushdaddy-picker-group"><h3 class="pushdaddy-picker-group-title">' +
          d.settings.texts[r] +
          "</h3>";
        for (var o = 0; o < n.length; o++) {
          var s = n[o];
          a +=
            '<span class="pushdaddy-picker-emoji" title="' +
            s[0] +
            '">' +
            s[1] +
            "</span>";
        }
        a += "</div>";
      }
      (document.getElementById("pushdaddy-picker-groups").innerHTML = a), z();
    }

    function buuu(e, a) {

      var t = document.getElementsByClassName(e)[0],
        n = document.getElementsByClassName(a)[0];

      if (null == n || null == t) return !1;
      n.style.removeProperty("height"),
        (n.style.height = t ? t.offsetHeight + "px" : "0px");
		
	
    }

    function v() {

    if(Object.keys(d.settings.style).length>0){
      if (d.settings.style.customized.remove_bg == "1") {
       
        var bgcolorrrrrrrr = "transparent";
      } else {
        var bgcolorrrrrrrr = d.settings.style.customized.background;
      }
    }
    

      if (d.settings.style.customized.svg_yes == "0") {
        var addxxclasspp = "";
      } else {
        var addxxclasspp = "x";
      }
	  
       document.documentElement.style.setProperty(
            "--pushdaddy-position-bottom",
            d.settings.style.customized.updown_bottom+"px"
          )	  ;
	  
	document.documentElement.style.setProperty(
              "--pushy-pending-color",
              d.settings.style.customized.blink_circle_color
            );
			
		document.documentElement.style.setProperty(
              "--svg-bg-color",
              d.settings.style.customized.svg_color
            );		
		
		document.documentElement.style.setProperty(
              "--faq-bg-color",
              d.settings.style.customized.faq_color
            );	

			document.documentElement.style.setProperty(
              "--share_radius",
              d.settings.style.customized.share_radius+'px'
            );	


	
			
			document.documentElement.style.setProperty(
              "--pushy-pending-background",
              d.settings.style.customized.blink_circle_bg
            );		  
	  
	  

      if ("0" == d.settings.style.customized.enabled) {
        var e = d.patterns[d.settings.style.pattern],
          a = (function (e) {
            var a = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
            return a
              ? {
                  r: parseInt(a[1], 16),
                  g: parseInt(a[2], 16),
                  b: parseInt(a[3], 16),
                }
              : null;
          })(e[3]);

        if (d.settings.style.customized.svg_yes == "0") {
          // document.documentElement.style.setProperty(
            // "--pushdaddy" + addxxclasspp + "-color",
            // e[2]
          // ),
     document.documentElement.style.setProperty(
            "--pushdaddy" + addxxclasspp + "-color",
            d.settings.style.customized.color
          ),		  
		  
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background",
              "linear-gradient(115deg, " + e[0] + ", " + e[1] + ")"
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background2",
              "linear-gradient(115deg, " + e[0] + ", " + e[1] + ")"
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background-dark",
              e[0]
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background-light",
              e[1]
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-box-shadow",
              "rgba(" + a.r + ", " + a.g + ", " + a.b + ", 0.5) 0px 4px 24px"
            );
        } else {
          document.documentElement.style.setProperty(
            "--pushdaddy" + addxxclasspp + "-color",
            e[2]
          ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background",
              "linear-gradient(115deg, " + e[0] + ", " + e[1] + ")"
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background2",
              "linear-gradient(115deg, " + e[0] + ", " + e[1] + ")"
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background-dark",
              e[0]
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background-light",
              e[1]
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-box-shadow",
              "rgba(" + a.r + ", " + a.g + ", " + a.b + ", 0.5) 0px 4px 24px"
            );

          document.documentElement.style.setProperty("--pushdaddy-color", e[2]),
            document.documentElement.style.setProperty(
              "--pushdaddy-background",
              "linear-gradient(115deg, " + e[0] + ", " + e[1] + ")"
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy-background2",
              "linear-gradient(115deg, " + e[0] + ", " + e[1] + ")"
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy-background-dark",
              e[0]
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy-background-light",
              e[1]
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy-box-shadow",
              "rgba(" + a.r + ", " + a.g + ", " + a.b + ", 0.5) 0px 4px 24px"
            );
        }
      } else {
        if (d.settings.style.customized.svg_yes == "0") {
          document.documentElement.style.setProperty(
            "--pushdaddy" + addxxclasspp + "-color",
            d.settings.style.customized.color
          ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background",
              bgcolorrrrrrrr
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background2",
              d.settings.style.customized.background
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background-dark",
              tuuu(bgcolorrrrrrrr, 0.1)
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background-light",
              tuuu(bgcolorrrrrrrr, 0.1)
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-box-shadow",
              "rgba(0,0,0,0.06) 0 1px 6px 0, rgba(0,0,0,0.16) 0 2px 32px 0"
            );
          document.documentElement.style.setProperty(
            "--pushdaddy" + addxxclasspp + "-share-color",
            d.settings.share.style.color
          ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-share-background",
              d.settings.share.style.background
            );
        } else {
          document.documentElement.style.setProperty(
            "--pushdaddy" + addxxclasspp + "-color",
            d.settings.style.customized.color
          ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background",
              bgcolorrrrrrrr
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background2",
              d.settings.style.customized.background
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background-dark",
              tuuu(bgcolorrrrrrrr, 0.1)
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-background-light",
              tuuu(bgcolorrrrrrrr, 0.1)
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-box-shadow",
              "rgba(0,0,0,0.06) 0 1px 6px 0, rgba(0,0,0,0.16) 0 2px 32px 0"
            );
          document.documentElement.style.setProperty(
            "--pushdaddy" + addxxclasspp + "-share-color",
            d.settings.share.style.color
          ),
            document.documentElement.style.setProperty(
              "--pushdaddy" + addxxclasspp + "-share-background",
              d.settings.share.style.background
            );

          document.documentElement.style.setProperty(
            "--pushdaddy-color",
            d.settings.style.customized.color
          ),
            document.documentElement.style.setProperty(
              "--pushdaddy-background",
              bgcolorrrrrrrr
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy-background2",
              d.settings.style.customized.background
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy-background-dark",
              tuuu(bgcolorrrrrrrr, 0.1)
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy-background-light",
              tuuu(bgcolorrrrrrrr, 0.1)
            ),
            document.documentElement.style.setProperty(
              "--pushdaddy-box-shadow",
              "rgba(0,0,0,0.06) 0 1px 6px 0, rgba(0,0,0,0.16) 0 2px 32px 0"
            );
          document.documentElement.style.setProperty(
            "--pushdaddy-share-color",
            d.settings.share.style.color
          ),
            document.documentElement.style.setProperty(
              "--pushdaddy-share-background",
              d.settings.share.style.background
            );
        }
		
      }
    }

var secondsuu = 0;
function incrementSeconds() {
    secondsuu += 1; 
}

var canceluuu = setInterval(incrementSeconds, 1000);

var varname = "VISIT_COUNTER";
 if (localStorage.getItem(varname) === null) {
        localStorage.setItem(varname, 1);
 } else { 
        var visits_count = parseInt(localStorage.getItem(varname)) + 1;
        localStorage.setItem(varname, visits_count);
 }



    function y(e) {

      if (0 == d.settings.charge) return !1;
      var messsgge = document.getElementById("pushdaddy-response-message")
        .value;



      //      var a = d.settings.track_url + "?shop=" + d.shop + "&action=" + e + "&request_url=" + window.location.pathname;
      var a =
        d.settings.track_url +
        "?shop=" +
        d.shop +
        "&msgggg=" +
        messsgge +
		"&action=" +
        e +
		"&chattimee=" +
        canceluuu +
        "&visited_count=" +
        visits_count +
        "&request_url=" +
        window.location.pathname;

      //    "chat" == e && void 0 !== d.block.name && (a += "&operator=" + d.block.name), r(a)
      //var eupo = this.getAttribute("data-id");
      if ("chat" == e) {
        //	var chat_share =d.block.cid;
        "chat" == e &&
          void 0 !== d.block.name &&
          (a += "&operator=" + d.block.cid),
          r(a);
      }
      if ("share" == e) {
        "share" == e &&
          void 0 !== d.block.name &&
          (a += "&operator=" + d.block.ciiid),
          r(a);
      }

      // fbpixel + google analytics starts here
      var a = window.ga;
      a &&
        a("send", {
          hitType: "event",
          eventCategory: d.settings.style.customized.google_ec,
          eventAction: d.settings.style.customized.google_ea,
          eventLabel: d.settings.style.customized.google_el,
        });
      var o = window.fbq;
      o && ol("track", d.settings.style.customized.fpixel_en, {});
      // ends hjere
    }


	
    function calltoaget(gfkfkg) {
        return window['sessionStorage']['getItem'](gfkfkg)
    }

    function calltoas(gfkfkg, gllrfr) {
        window['sessionStorage']['setItem'](gfkfkg, gllrfr)
    }	
	
	
	
    function _newy() {		


		      var epoyu = localStorage.getItem("auto_start");
			  
	  

      if (epoyu > 1) {
      } else {
        localStorage.setItem("auto_start", "99");
        setTimeout(function () {
          jQuery("#pushdaddy-button,#pushdaddyx-button").click();
		  
		  
		  
        }, d.settings.style.customized.auto_start);
      }

      return 0 == d.settings.charge ? '<div class="pushdaddy-branding2" style="text-align: center;"><a class="pushdaddy-branding21" style="align-self: center;font: small-caption;opacity: 0.5;" href="https://apps.shopify.com/whatsapp-chat-for-support" target="_blank">We run on Pushdaddy </a></div>' : ""
    
    }
    function k() {
		

	
		
      if (null != document.getElementById("pushdaddy-box")) {
        var e = document.body,
          a = document.getElementById("pushdaddy-widget");
        a.classList.contains("pushdaddy-opened")
          ? (a.classList.remove("pushdaddy-opened"),
            e.classList.remove("pushdaddy-overlay"))
          : (a.classList.add("pushdaddy-opened"),
            e.classList.add("pushdaddy-overlay"),
            a.classList.contains("pushdaddy-button-chat") && Muuu());
				 jQuery("#pushdaddy-box").removeClass('bounceDown99');		

      } else Buuu();
    }

    function E() {

      var e = (function () {
        var e = c() + "\n\n" + d.settings.share.texts.message,
          a = n();
        return encodeURI((a += "?text=" + e));
      })();
      window.open(e, "_blank").focus(), y("share");
    }

    function x(e, a) {
      if (((a = a || ""), document.selection))
        e.focus(), (document.selection.createRange().text = a);
      else if (e.selectionStart || 0 === e.selectionStart) {
        var t = e.selectionStart,
          n = e.selectionEnd;
        (e.value =
          e.value.substring(0, t) + a + e.value.substring(n, e.value.length)),
          (e.selectionStart = t + a.length),
          (e.selectionEnd = t + a.length);
      } else e.value += a;
      e.focus();
    }

function countWords(str) {
  //  var regEx = /([^\u0000-\u007F]|\w)+/g;  
       var regEx = /([^\u0000-\u007F]|[\w-])+/g;  
    return str.match(regEx).length;
}

function hasNumber(myString) {
  return /\d/.test(myString);
}


    function L() {
      var e = document.getElementById("pushdaddy-response-message"),
        a = e.value;
      // if (0 === a.length || !a.trim()) return e.classList.add("pushdaddy-shake"), e.focus(), setTimeout(
	  
if( a ) {
var gffgf= countWords(a);
}
else
{
var gffgf= '25';
	
}

var gffgf= countWords(a);
var dfgfgfgfg = hasNumber(a);


var showemailpopyy =  d.settings.style.customized.emailpop
 if(showemailpopyy == '1')
 
 {
	
var eppyiiyy = localStorage.getItem("emailpoppuupp");


if(	eppyiiyy != '99')
{
var fkukdks = '1';	
	
}
else
{
	var fkukdks = '0';	

}

 }
 else
 {
	var fkukdks = '0';	
 
 }
 



   if (0 === a.length || !a.trim())
	
	
        return (
          e.classList.add("pushdaddy-shake"),
          e.focus(),
          setTimeout(function () {
            e.classList.remove("pushdaddy-shake");
          }, 1e3),
          !1
        );

      // a = a.trim().replace(/\n\r?/g, "\x0A");
    // a = a.trim().replace(/\n\r?/g, "\x0A").replaceAll("<", "[").replaceAll(">", "]");
    a = a.trim().replace(/\n\r?/g, "\x0A").replace("<", "[").replace(">", "]");

	  
      var t = i();

    //  if (a.match(/^[0-9]+$/) != null) 
	  // if (1 === gffgf && true == dfgfgfgfg || a.indexOf('@') != -1)
	  
	//  console.log(fkukdks);
			//  console.log('nw55');
  
   	  if (1 === gffgf && true == dfgfgfgfg || a.indexOf('@') != -1 || fkukdks == 1)

	  {
			//  console.log('cffff');
	  
	 if (fkukdks == 1)
	 {	 
jQuery("#imgreftransfer").css("display", "block");
	 }
	 else
	 {
	jQuery("#imgreftransfer").css("display", "none");
	 
	 }
	 
   	  if (fkukdks == 0)
	{	
	
		//  console.log('jkjj');

        // t += "&text=" + a.trim(), I(), y("chat");
        //   t += "&text=" + a.trim(), y("chat");
        if (0 == d.settings.charge) return !1;
        var messsgge = document.getElementById("pushdaddy-response-message")
          .value;
        // var roboturl = d.settings.track_url + "?shop=" + d.shop + "&msgggg=" + messsgge + "&request_url=" + d.block.cid;
        var roboturl =
          "https://way2enjoy.com/touch/1/tracking_with_bot6.php?shop=" +
          d.shop +
          "&msgggg=" +
          messsgge +
          "&request_url=" +
          d.block.cid;
        // sound starts hereee
        var nuuyuyiyy = document.createElement("audio");
        nuuyuyiyy.setAttribute("autoplay", "autoplay"),
          (nuuyuyiyy.innerHTML =
            '<source src="https://cdn.shopify.com/s/files/1/0033/3538/9233/files/download.mp3?v=1637130603" type="audio/mp3">');
        // sound ends here

        jQuery("#pushdaddy-response-message").val("");

        jQuery.get(
          "" + roboturl + "",
          function (data) {
            nuuyuyiyy.play();

if (d.settings.mobile.layout == "baby" || d.settings.desktop.layout == "baby") 

 {
   var kkfkdfd = ' pushy-whatsapp-message';

			}

else 
 {
        var kkfkdfd = '';


			}

if (d.settings.desktop.layout == "button_list") 

 {
   var kkfkdfdhhggyy = 'position: relative;';

			}

else 
 {
        var kkfkdfdhhggyy = '';


			}



     jQuery(".pushdaddy-body, .conversation").append(
              '<div class="pushdaddy-chats" style="'+kkfkdfdhhggyy+'"><div class="pushdaddy-chat '+kkfkdfd+'"><div class="pushdaddy-avatar" style="background-image:url(' +
            d.block.avatar + ');"><span>' +d.block.name + '</span></div>' +
                data.roboresp +
                "</div></div>"
            );

  
            //$('.pushdaddy-body').animate({"scrollBottom": $('.pushdaddy-body')[0].scrollHeight}, "fast");
            jQuery(".pushdaddy-body, .conversation").animate(
              { scrollTop: jQuery(".pushdaddy-body, .conversation")[0].scrollHeight

			  },
              2000
            );
          },
          "json"
        );
		
	  }
      } else {
		  	//	  console.log('nw1');

        // t += "&text=" + a.trim(), window.open(t, "_blank").focus(), I(), y("chat");
        (t += "&text=" + encodeURIComponent(a)),
          window.open(t, "_blank").focus(),
          I(),
          y("chat");
		//  console.log('nw2');
      }
    }
	
    function Lupooo() {	 
	
	if("1" == d.block.page_url)
	{
       var  a = d.settings.texts.prefilledt + "\x0A\x0A" + window.location.href ;
	}
	else
	{
	       var  a = d.settings.texts.prefilledt  ;
	
	}
	
   // a = a.trim().replace(/\n\r?/g, "\x0A").replaceAll("<", "[").replaceAll(">", "]");
		    a = a.trim().replace(/\n\r?/g, "\x0A").replace("<", "[").replace(">", "]");

      var t = i();
        (t += "&text=" + encodeURIComponent(a)),
          window.open(t, "_blank"),
          I();
      }


    function Buuu() {
	
		
		
		
      var e = i(!0);
      window.open(e, "_blank").focus(), I(), y("chat");
    }

    function I() {
      var e = document.body,
        a = document.getElementById("pushdaddy-widget"),
        t = document.getElementById("pushdaddy-response-message");
      e.classList.remove("pushdaddy-overlay"),
        a.classList.remove("pushdaddy-opened"),
        null != t && (t.value = "");
    }

    function z() {
      for (
        var e = document.getElementById("pushdaddy-response-message"),
          a = document.getElementsByClassName("pushdaddy-picker-emoji"),
          t = 0;
        t < a.length;
        t++
      )
        a[t].addEventListener("click", function () {
          x(e, this.innerHTML);
        });
    }

function sanitize(string) {
  const map = {
  //    '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
  //    '"': '&quot;',
   //   "'": '&#x27;',
   //   "/": '&#x2F;',
  };
  const reg = /[&<>"'/]/ig;
  // return string.replace(reg, (match)=>(map[match]));
    return string.toString().replace(reg, (match)=>(map[match]));

}



    function Muuu() {
      setTimeout(function () {
        document.getElementById("pushdaddy-response-message").focus();
      }, 300);
    }

    function j() {
	
	
	

      setTimeout(function () {
	
jQuery("#pushdaddy-greetingcta-close,#pushdaddy-button-label,#pushdaddy-button,#pushdaddyx-button").click(function() { 

                ctoactionn();
				
if(d.settings.style.customized.blink_circle ==='1')
{
				blinkkactionn();
}


// jQuery("#pushdaddy-box").removeClass("bounceDown99");
              // jQuery("#pushdaddy-box").addClass("bounceUp99");
			  if(jQuery("#pushdaddy-box").hasClass('bounceDown99')) {
    //    jQuery("#pushdaddy-box").removeClass('bounceDown99');
		//        jQuery("#pushdaddy-box").addClass('bounceUp99');

		  //     jQuery("#pushdaddy-box").removeClass('bounceUp99');


    } 
	else if(jQuery("#pushdaddy-box").hasClass('bounceUp99')) {
		       jQuery("#pushdaddy-box").removeClass('bounceUp99');
  // jQuery("#pushdaddy-box").addClass('bounceDown99');
			   		     jQuery("#moon").addClass('hideeee');

    }
	
		else if(jQuery("#wa-chat-bubble").hasClass('bounceUp99')) {
		       jQuery("#wa-chat-bubble").removeClass('bounceUp99');
			   		     jQuery("#moon").addClass('hideeee');

  // jQuery("#pushdaddy-box").addClass('bounceDown99');

    }
	
	
	
	
		// else if(jQuery("#pushdaddy-box").hasClass('bounceDown99')) {
		       // jQuery("#pushdaddy-box").removeClass('bounceDown99');
		       // jQuery("#pushdaddy-box").addClass('bounceUp99');

    // }
	
	else {
       jQuery("#pushdaddy-box").addClass('bounceUp99');
		     jQuery("#pushdaddy-box").removeClass('bounceDown99');
       jQuery("#wa-chat-bubble").addClass('bounceUp99');
       jQuery("#wa-chat-bubble").addClass('bounceUp99');
       // jQuery("#moon").addClass('showwww');
		     jQuery("#moon").removeClass('hideeee');




    }







            })
			
			
			
	jQuery("#pushdaddy-close").click(function() { 
     jQuery("#pushdaddy-box").removeClass("bounceUp99");
      // jQuery("#pushdaddy-box").addClass("bounceDown99");

	})	;
	
	
	jQuery("#ic_close").click(function() { 
    jQuery(".user-data-modal").css("display", "none");
            });	
	
//	jQuery(".btnbooot").click(function() { 
	
      if (true == ukkk())
	  {
var chatyppeep = d.settings.mobile.layout;
	  }
	  else
	  {
	var chatyppeep = d.settings.desktop.layout;
  
	  }
	 	var mergeynnnb = d.settings.style.customized.merge_bot_button;
 
	
jQuery(document).on("click", ".btnbooot,.btnbooot2,.dWKXTd", function(){ 
	
	//jQuery(".pushdaddy-chats").css("position", "relative");
	jQuery(".pushdaddy-chats").css({position: "relative"});

var botttidddkkk = jQuery(this).attr('id');
var roboturl65 =
          "https://way2enjoy.com/touch/1/abotchat5.php?shop=" +
          d.shop +
		"&msgggg=" +
          botttidddkkk +
		  "&request_url=" +
          d.block.cid +
		  "&ctattypee=" +
          chatyppeep+
		  "&mergeynnnb=" +
          mergeynnnb;

        // sound starts hereee
        var nuuyuyiyyff = document.createElement("audio");
        nuuyuyiyyff.setAttribute("autoplay", "autoplay"),
          (nuuyuyiyyff.innerHTML =
            '<source src="https://cdn.shopify.com/s/files/1/0033/3538/9233/files/download.mp3?v=1637130603" type="audio/mp3">');
        // sound ends here

        jQuery.get(
          "" + roboturl65 + "",
          function (data) {
            nuuyuyiyyff.play();

if (d.settings.mobile.layout == "baby" || d.settings.desktop.layout == "baby") 

 {
   var kkfkdfd = ' pushy-whatsapp-message';

			}

else 
 {
        var kkfkdfd = '';


			}

if (d.settings.desktop.layout == "button_list") 

 {
   var kkfkdfdhhgg = 'position: relative;';

			}

else 
 {
        var kkfkdfdhhgg = '';


			}


if (d.settings.mobile.layout == "newchat4" || d.settings.desktop.layout == "newchat4") 

 {
   var fggfhyfd = 'margin-top: 110px;background: rgb(255, 255, 255);color: rgb(0, 0, 0);padding: 15px 17px; border-radius: 20px 20px 20px 5px;';

			}

else 
 {
        var fggfhyfd = 'margin-top: 110px;';


			}



     jQuery(".pushdaddy-body, .conversation").append(
              '<div class="pushdaddy-chats" style="'+kkfkdfdhhgg+'"><div style="'+fggfhyfd+'" class="pushdaddy-chat '+kkfkdfd+'"><div class="pushdaddy-avatar" style="background-image:url(' +
            d.block.avatar + ');"><span>' +d.block.name + '</span></div>' +
                data.roboresp +
                "</div></div>"
            );


            jQuery(".pushdaddy-body, .conversation").animate(
              {
			   scrollTop: jQuery(".pushdaddy-body, .conversation")[0].scrollHeight
		//	 scrollTop: jQuery(".pushdaddy-body, .conversation")[0].offset().top - 20

			  },

              2000
            );
			
	
			
			
			
          },
          "json"
        );

jQuery(".pushdaddy-chat, .pushdaddy-chat1").css("margin-top", "110px");
//jQuery(".pushdaddy-chat, .pushdaddy-chat1").css("background-color", "#fff");


	})	;
	
	
// new email collection starts here
		jQuery(document).on("click", "#emailcollect", function(e){ 
	
	 localStorage.setItem("emailpoppuupp", "99");


	
        e.preventDefault();

var botttidddkkk1 = jQuery('#emailuserss').val();

var roboturl656 =
          "https://way2enjoy.com/touch/1/emailsubs3.php?shop=" +
          d.shop +
		"&msgggg=" +
          botttidddkkk1 +
		  "&request_url=" +
          d.block.cid;

  
  jQuery.ajax({
        url: roboturl656,
        type: 'post',
        dataType: 'json',
     data: jQuery('form#emailpoopupp').serialize(),
        success: function(data) {
			      //   return data; 
var trnsfrdre = '';
for (var i = 0; i < data.length; i++) {
trnsfrlo = data[i];
trnsfrdre = trnsfrlo.tcredituu;
}

jQuery('#trnsfr-btnm').html(trnsfrdre);
jQuery('.user-data-modal-text').hide();
setTimeout(function() {jQuery('#imgreftransfer').fadeOut('fast');}, 2000);

                 }
    });



	})	;
	

// new email collection ends here


      }, 700);
			
			
      //  }
	
		
      setTimeout(function () {
        if (
          d.settings.share.desktop.disabled == "0" ||
          d.settings.share.mobile.disabled == "0"
        ) {
          jQuery("#pushdaddy-share,#pushdaddy-button,#pushdaddy-widget").hover(
            function () {
              jQuery(this).removeClass("hide_share");
            },
            function () {
              jQuery(this).addClass("");
            }
          );
    var pkk = document.getElementsByTagName("head")[0],
      bkk = document.createElement("link");
    (bkk.rel = "stylesheet"),
      (bkk.href =
        "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"),
      (bkk.onload = pkk.appendChild(bkk));		  
		  
		  
        }

        jQuery("#sywh-open-services").click(function () {
          if (jQuery(".sywh-services").hasClass("active")) {
            jQuery(".sywh-services").removeClass("active");
            jQuery("a.sywh-open-services i.fa-times").hide();
            jQuery("a.sywh-open-services i.fa-comments").show();
            $("a.sywh-open-services").removeClass("data-tooltip-hide");
            jQuery(".sywh-services a:nth-child(1)").delay(0).fadeOut();
            jQuery(".sywh-services a:nth-child(2)").delay(30).fadeOut();
            jQuery(".sywh-services a:nth-child(3)").delay(60).fadeOut();
            jQuery(".sywh-services a:nth-child(4)").delay(90).fadeOut();
            jQuery(".sywh-services a:nth-child(5)").delay(120).fadeOut();
            jQuery(".sywh-services a:nth-child(6)").delay(150).fadeOut();
            jQuery(".sywh-services a:nth-child(7)").delay(180).fadeOut();
            jQuery(".sywh-services a:nth-child(8)").delay(210).fadeOut();
            jQuery(".sywh-services a:nth-child(9)").delay(240).fadeOut();
            jQuery(".sywh-services a:nth-child(10)").delay(270).fadeOut();
            jQuery(".sywh-services a:nth-child(11)").delay(300).fadeOut();
            jQuery(".sywh-services a:nth-child(12)").delay(330).fadeOut();
            jQuery(".sywh-services a:nth-child(13)").delay(360).fadeOut();
            jQuery(".sywh-services a:nth-child(14)").delay(390).fadeOut();
          } else {
            jQuery(".sywh-services").addClass("active");
            jQuery("a.sywh-open-services i.fa-comments").hide();
            jQuery("a.sywh-open-services i.fa-times").show();
            jQuery("a.sywh-open-services").addClass("data-tooltip-hide");

            jQuery(".sywh-services a:nth-child(14)").delay(0).fadeIn();
            jQuery(".sywh-services a:nth-child(13)").delay(30).fadeIn();
            jQuery(".sywh-services a:nth-child(12)").delay(60).fadeIn();
            jQuery(".sywh-services a:nth-child(11)").delay(90).fadeIn();
            jQuery(".sywh-services a:nth-child(10)").delay(120).fadeIn();
            jQuery(".sywh-services a:nth-child(9)").delay(150).fadeIn();
            jQuery(".sywh-services a:nth-child(8)").delay(180).fadeIn();
            jQuery(".sywh-services a:nth-child(7)").delay(210).fadeIn();
            jQuery(".sywh-services a:nth-child(6)").delay(240).fadeIn();
            jQuery(".sywh-services a:nth-child(5)").delay(270).fadeIn();
            jQuery(".sywh-services a:nth-child(4)").delay(300).fadeIn();
            jQuery(".sywh-services a:nth-child(3)").delay(330).fadeIn();
            jQuery(".sywh-services a:nth-child(2)").delay(360).fadeIn();
            jQuery(".sywh-services a:nth-child(1)").delay(390).fadeIn();
          }
        });
      }, 400);

      var o = document.getElementById("pushdaddy-widget");
	  

      	  
      document.getElementById("pushdaddy-share") &&
        document
          .getElementById("pushdaddy-share")
          .addEventListener("click", function () {
			   if ( d.settings.style.customized.share_icons_display == "Whatsapp" )
		{  
			  
        E();
		}
          }),
        document.getElementById("pushdaddy-button") &&
          document
            .getElementById("pushdaddy-button")
            .addEventListener("click", function () {
              k();
            }),
        document.getElementById("pushdaddyx-button") &&
          document
            .getElementById("pushdaddyx-button")
            .addEventListener("click", function () {
              k();
            }),
        document.getElementById("pushy-close-button") &&
          document
            .getElementById("pushy-close-button")
            .addEventListener("click", function () {
              k();
            }),			
        document.getElementById("pushdaddy-close") &&
          document
            .getElementById("pushdaddy-close")
            .addEventListener("click", function () {
  // jQuery("#pushdaddy-box").removeClass("bounceUp99");
   //   jQuery("#pushdaddy-box").addClass("bounceDown99");				
              k();
            });
		
			
			
      for (
        var e = document.getElementsByClassName("pushdaddy-account"), a = 0;
        a < e.length;
        a++
      )
        e[a].addEventListener("click", function () {
          var e = this.getAttribute("data-id"),
            a = d.settings.blocks[e];
          if (
            ((a.id = e), "object" == typeof (d.block = a) && "0" == a.disabled)
          )
            if ("0" == a.chat.enabled) Buuu();
            else if (!o.classList.contains("pushdaddy-slidden")) {
              var t = muuu();
              document.getElementsByClassName(
                "pushdaddy-personal"
              )[0].innerHTML =
                '<div id="pushdaddy-back" class="pushdaddy-back"><svg><polygon points="44.3 38.8 44.3 31.1 42.1 31.1 42.1 40 42.1 41.1 52.1 41.1 52.1 38.8" transform="translate(-40 -29)translate(47.071068 36.071068)rotate(-315)translate(-47.071068 -36.071068)"></polygon></svg></div>' +
                t;
              var n = h();
              document.getElementsByClassName(
                "pushdaddy-chats"
              )[0].innerHTML = n;
            //  var r = sanitize(w());
			      var r = w();
				  
   if (d.settings.style.customized.header_flat == "0") {
        var roundflatkkkk99 = "pushdaddy-header99";
      } else {
        var roundflatkkkk99 = "pushdaddy-header";
      }				  
				  
              (document.getElementById("pushdaddy-response-message").value = r),
                (document.getElementById(
                  "pushdaddy-response-invisible"
                ).innerHTML = r),
                buuu("pushdaddy-personal", ""+roundflatkkkk99+""),
                o.classList.add("pushdaddy-slidden"),
                Muuu(),
                document
                  .getElementsByClassName("pushdaddy-back")[0]
                  .addEventListener("click", function () {
                    o.classList.remove("pushdaddy-slidden"),
                      buuu("pushdaddy-greeting", ""+roundflatkkkk99+""),
                      (d.block = {}),
                      setTimeout(function () {
                        (document.getElementsByClassName(
                          "pushdaddy-chats"
                        )[0].innerHTML = ""),
                          (document.getElementsByClassName(
                            "pushdaddy-personal"
                          )[0].innerHTML = ""),
                          (document.getElementById(
                            "pushdaddy-response-message"
                          ).value = ""),
                          (document.getElementById(
                            "pushdaddy-response-invisible"
                          ).innerHTML = ""),
                          o.classList.contains("emoji-picker") &&
                            (o.classList.remove("emoji-picker"),
                            document
                              .getElementById("pushdaddy-emoji-picker")
                              .remove(),
                            (document.getElementById(
                              "pushdaddy-emoji"
                            ).innerHTML =
                              '<svg><path d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm0 1C4.589 1 1 4.589 1 9s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zM5 6.999a1 1 0 1 1 2.002.004A1 1 0 0 1 5 6.999zm5.999 0a1.002 1.002 0 0 1 2.001 0 1 1 0 1 1-2.001 0zM8.959 13.5c-.086 0-.173-.002-.26-.007-2.44-.132-4.024-2.099-4.09-2.182l-.31-.392.781-.62.312.39c.014.017 1.382 1.703 3.37 1.806 1.306.072 2.61-.554 3.882-1.846l.351-.356.712.702-.35.356c-1.407 1.427-2.886 2.15-4.398 2.15z"></path></svg>'));
                      }, 300);
					movefun();
                  });
            }
        });
      document.getElementById("pushdaddy-response-message") &&
        document
          .getElementById("pushdaddy-response-message")
          .addEventListener("input", function () {
            var e = sanitize(document.getElementById("pushdaddy-response-message"));
            document.getElementById("pushdaddy-response-invisible").innerHTML =
              e.value;
          }),
        document.getElementById("pushdaddy-response-message") &&
          document
            .getElementById("pushdaddy-response-message")
            .addEventListener("keypress", function (e) {
              13 === (e.which || e.keyCode) && (e.preventDefault(), L());
            }),
        document.getElementById("pushdaddy-reply") &&
          document
            .getElementById("pushdaddy-reply")
            .addEventListener("click", function () {
              L();
		//	  console.log('ok');
            }),
       document.getElementById("pushdaddy-reply2") &&
          document
            .getElementById("pushdaddy-reply2")
            .addEventListener("click", function () {
              Lupooo();
            }),

        document.getElementById("pushdaddy-emoji") &&
          document
            .getElementById("pushdaddy-emoji")
            .addEventListener("click", function () {
              if (o.classList.contains("emoji-picker"))
                o.classList.remove("emoji-picker"),
                  document.getElementById("pushdaddy-emoji-picker").remove(),
                  (this.innerHTML =
                    '<svg><path d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm0 1C4.589 1 1 4.589 1 9s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zM5 6.999a1 1 0 1 1 2.002.004A1 1 0 0 1 5 6.999zm5.999 0a1.002 1.002 0 0 1 2.001 0 1 1 0 1 1-2.001 0zM8.959 13.5c-.086 0-.173-.002-.26-.007-2.44-.132-4.024-2.099-4.09-2.182l-.31-.392.781-.62.312.39c.014.017 1.382 1.703 3.37 1.806 1.306.072 2.61-.554 3.882-1.846l.351-.356.712.702-.35.356c-1.407 1.427-2.886 2.15-4.398 2.15z"></path></svg>');
              else {
                this.innerHTML =
                  '<svg><linearGradient id="emoji-gradient" gradientTransform="rotate(25)"><stop offset="0%"></stop><stop offset="100%"></stop></linearGradient><path fill="url(#emoji-gradient)" d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zM5 6.999a1 1 0 1 0 2.001 0A1 1 0 0 0 5 7zm5.999 0a1.001 1.001 0 0 0 2.001 0 1 1 0 0 0-2.001 0zm-2.3 6.494c.087.005.174.007.26.007 1.513 0 2.99-.722 4.398-2.149l.35-.356.482-.702-10.326.006.435.62.31.392c.068.083 1.652 2.05 4.092 2.182z"></path></svg>';
                var e = (function () {
                    var e =
                      '<div class="pushdaddy-picker"><div class="pushdaddy-picker-header"><svg viewBox="0 0 512 512"><path d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"></path></svg><input id="pushdaddy-picker-input" placeholder="<%= emoji_search %>" /></div><div class="pushdaddy-picker-body"><div id="pushdaddy-picker-groups"></div></div></div>';
                    return (e = e.replace(
                      /<%= emoji_search %>/g,
                      d.settings.texts.emoji_search
                    ));
                  })(),
                  a = document.createElement("div");
                (a.id = "pushdaddy-emoji-picker"), (a.innerHTML = e);
                var t = document.getElementById("pushdaddy-response-message");
                t.parentNode.insertBefore(a, t),
                  o.classList.add("emoji-picker"),
                  l(),
                  setTimeout(function () {
                    document.getElementById("pushdaddy-picker-input").focus(),
                      document
                        .getElementById("pushdaddy-picker-input")
                        .addEventListener("input", function () {
                          var e = document.getElementById(
                            "pushdaddy-picker-input"
                          ).value;
                          e.length
                            ? (function (e) {
                                var a = d.emojis,
                                  t = "",
                                  n = !1;
                                for (var r in ((t +=
                                  '<div class="pushdaddy-picker-group">'),
                                a))
                                  for (var o = a[r], s = 0; s < o.length; s++) {
                                    var i = o[s];
                                    -1 !== i[0].indexOf(e) &&
                                      ((t +=
                                        '<span class="pushdaddy-picker-emoji" title="' +
                                        i[0] +
                                        '">' +
                                        i[1] +
                                        "</span>"),
                                      (n = !0));
                                  }
                                0 == n &&
                                  (t +=
                                    '<div class="pushdaddy-picker-message">' +
                                    d.settings.texts.emoji_not_found +
                                    "</div>"),
                                  (t += "</div>"),
                                  (document.getElementById(
                                    "pushdaddy-picker-groups"
                                  ).innerHTML = t),
                                  z();
                              })(e)
                            : l();
                        });
                  }, 300);
              }
            });
    }

function movefun() {
    var elementsppioo = document.getElementsByClassName("pushdaddy-chats");
    for (var iyy = 0; iyy < elementsppioo.length; iyy++) {

        elementsppioo[iyy].style.position = "absolute";

    }
}


    // here we are starting whatsapp popup for abandned cart
    mobilecheck = function () {
      var e,
        t = !1;
      return (
        (e = navigator.userAgent || navigator.vendor || window.opera),
        (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          e
        ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            e.substr(0, 4)
          )) &&
          (t = !0),
        t
      );
    };

    function nl(t, n) {
      jQuery.ajax({
        //        url: e + "/chatlytics/chat?shop_id=" + A + "&url_path=" + window.location.pathname + "&agent_id=" + (n || ""),
        url:
          "https://way2enjoy.com/shopify/1/whatsapp-chat/proxy/js/chatlytics.php?shop_id=&url_path=" +
          window.location.pathname +
          "&agent_id=" +
          (n || ""),

        type: "GET",
      });
    }

    function rl(e, t, n) {
      var a = "",
        //    o = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        o =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
            navigator.userAgent
          ) && !window.MSStream;

      return (
        2 == n
          ? (a = "https://web.whatsapp.com/send?text=" + t)
          : 1 != n || o
          ? 1 == n && o && (a = "https://api.whatsapp.com/send?text=" + t)
          : (a = "whatsapp://send?text=" + t),
        e && (a += "&phone=" + e),
        a
      );
    }

    function yl(e) {
      switch (e) {
        case 1:
          return "CONFIRM";
        case 2:
          return "CONFIRME";
        case 3:
          return "CONFIRMAR";
        case 4:
          return "CONFERMARE";
        case 5:
          return "CONFIRMER";
        case 6:
          return "KONFIRMASI";
        case 7:
          return "BESTÄTIGEN";
        case 8:
          return "تؤكد";
        case 9:
          return "ONAYLAMAK";
      }
    }

    function vl(t) {
      if (
        (jQuery("#wa-optin-widget-root-old").remove(),
        localStorage.getItem("opted_in_phone"))
      )
        return;
      if (localStorage.getItem("dismiss_count") > 1) return;
      let n = al();
      var o = document.createElement("div");
      o.id = "wa-optin-widget-root-old";
      var i = document.createElement("style");
      (i.type = "text/css"),
        (i.innerHTML =
          ".wa-optin-widget-z-index-old { z-index:" +
          (1 === n
            ? t.chatsetting.optin_widget_z_index_mobile
            : t.chatsetting.optin_widget_z_index_desktop) +
          ";}"),
        document.head.appendChild(i),
        (o.className =
          "wa-optin-widget-container-old wa-optin-widget-z-index-old");
      var s = document.createElement("div");
      (s.className = "wa-optin-widget-close-btn-old"),
        (s.onclick = function () {
          var e = localStorage.getItem("dismiss_count");
          localStorage.setItem(
            "dismiss_count",
            parseInt(e) ? parseInt(e) + 1 : 1
          ),
            jQuery("#wa-optin-widget-root-old").remove();
        });
      var c = document.createElement("img");
      (c.className = "wa-optin-widget-close-img-old"),
        (c.src =
          "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/Group_2.png?1194"),
        s.appendChild(c);
      var r = document.createElement("div");
      r.className = "wa-optin-widget-content-container-old";
      var l = document.createElement("img");
      (l.className = "wa-optin-widget-logo-img-old"),
        (l.src = (function (e) {
          switch (e) {
            case 1:
              return mobilecheck()
                ? "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/optin-eng-mobile.png"
                : "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/optin-eng-desktop.png";
            case 2:
              return mobilecheck()
                ? "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/optin-por-mobile.png"
                : "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/optin-por-desktop-s.png?1306";
            case 3:
              return mobilecheck()
                ? "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/optin-spa-mobile.png"
                : "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/optin-spa-desktop-s.png?1306";
            case 4:
              return mobilecheck()
                ? "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/optin-ita-mobile.png?1538"
                : "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/optin-ita-desktop.png?1538";
            default:
              return mobilecheck()
                ? "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/optin-eng-mobile.png"
                : "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/optin-eng-desktop.png";
          }
        })(t.widget_language));
      var d = document.createElement("div");
      d.style = "text-align: center";
      var p = document.createElement("input");
      (p.className = "wa-optin-widget-number-input-old"),
        (p.placeholder = "XXXXXXXXXX"),
        (p.id = "wa-optin-phone-number-old"),
        (p.type = "tel");
      var u = document.createElement("button");
      (u.className = "wa-optin-widget-confirm-button-old"),
        (u.innerHTML = yl(t.widget_language)),
        (u.onclick = function () {
          var t = jQuery("#wa-optin-phone-number-old").val();

          jQuery("#wa-optin-widget-root-old").remove(),
            t &&
              (localStorage.setItem("opted_in_phone", t),
              jQuery.ajax({
                url: "https://way2enjoy.com/touch/optin_23aug.php",

                type: "POST",
                dataType: "json",
           //     contentType: "application/json",
                data: JSON.stringify({
                  shop_id: Il(),
                  phone: t,
                }),
              }));
        }),
        d.appendChild(p),
        d.appendChild(u),
        r.appendChild(l),
        r.appendChild(d),
        o.appendChild(s),
        o.appendChild(r),
        document.body.appendChild(o),
        document
          .getElementById("wa-optin-phone-number-old")
          .addEventListener(
            "focus",
            (e) => (
              e.relatedTarget &&
                (e.relatedTarget.removeAttribute("tabindex"), e.target.focus()),
              !1
            )
          ),
        jQuery("#wa-optin-phone-number-old").focus(),
        localStorage.getItem("calling_code")
          ? (jQuery("#wa-optin-phone-number-old").val(
              "+" + localStorage.getItem("calling_code") + "  "
            ),
            jQuery("#wa-optin-phone-number-old").focus())
          : jQuery.get(
              "https://api.ipdata.co?api-key=739556kpa888a7d2fa6b7ed364de18eb19af0b702fb9b457ae7y7875ff",
              function (e) {
                e &&
                  e.calling_code &&
                  (jQuery("#wa-optin-phone-number-old").val(
                    "+" + e.calling_code + "  "
                  ),
                  jQuery("#wa-optin-phone-number-old").focus(),
                  localStorage.setItem("calling_code", e.calling_code),
                  localStorage.setItem("emoji_flag", e.emoji_flag));
              },
              "jsonp"
            );
    }

    function kl(t, n) {
      t.enable_optin &&
        // hl() && t.show_optin_on_thank_you_page ? localStorage.getItem("opted_in_phone") ? (Shopify.checkout.order_id && jQuery.ajax({
        //		hl() && t.show_optin_on_thank_you_page ? localStorage.getItem("opted_in_phone") ? (Shopify.checkout.order_id && jQuery.ajax({
        (hl() && d.settings.style.customized.order_conf
          ? localStorage.getItem("opted_in_phone")
            ? (Shopify.checkout.order_id &&
                jQuery.ajax({
                  // url: e + "/shop/order/optin",
                  //url:"https://way2enjoy.com/shopify/1/whatsapp-chat/proxy/js/optin_251020.php",
                  url: "https://way2enjoy.com/touch/optin_23aug.php",

                  type: "POST",
                  dataType: "json",
               //   contentType: "application/json",
                  data: JSON.stringify({
                    // shop_id: I(),
                    shop_id: Il(),
                    phone: localStorage.getItem("opted_in_phone"),
                    order_id: Shopify.checkout.order_id,
                  }),
                }),
              El(t.widget_language))
            : Nl(t.widget_language)
          : t.enable_optin_on_store_front &&
            (t.show_optin_on_checkout &&
              (function (e, t) {
                //}), El(1)) : Nl(1) : true && (t.true && function(e, t) {

                var n = !1;
                document.body.addEventListener(
                  "click",
                  function (a) {
                    const o = Sl(a.target),
                      i = (function (e) {
                        if (!e) return null;
                        if ("A" == e.tagName) return e;
                        if (jQuery(e).closest("a"))
                          return jQuery(e).closest("a")[0];
                      })(a.target),
                      s =
                        o && "submit" == o.getAttribute("type")
                          ? jQuery(o).closest("form")
                          : null;
                    ((o &&
                      ("checkout" == o.getAttribute("name") ||
                        "window.location='/checkout'" ==
                          o.getAttribute("onclick"))) ||
                      (a.target &&
                        "checkout" == a.target.name &&
                        "INPUT" == a.target.tagName) ||
                      (i && "/checkout" == i.getAttribute("href")) ||
                      (s && "/checkout" == s.attr("action"))) &&
                      (n
                        ? (n = !1)
                        : (a.stopPropagation(),
                          a.preventDefault(),
                          Cl(e, t, function () {
                            (n = !0), a.target.click();
                          })));
                  },
                  !0
                );
              })(t, n),
            t.show_optin_on_buy_now &&
              (function (e, t) {
                var n = !1;
                document.body.addEventListener(
                  "click",
                  function (a) {
                    const o = Sl(a.target);
                    o &&
                      o.getAttribute("data-testid") &&
                      "Checkout-button" == o.getAttribute("data-testid") &&
                      (n
                        ? (n = !1)
                        : (a.preventDefault(),
                          a.stopPropagation(),
                          Cl(e, t, function () {
                            (n = !0), o.click();
                          })));
                  },
                  !0
                );
              })(t, n),
            t.show_optin_on_add_to_cart &&
              (function (e, t) {
                var n = !1;
                document.body.addEventListener(
                  "click",
                  function (a) {
                    const o = Sl(a.target),
                      i = jQuery(o).closest("form");
                    o &&
                      "Checkout-button" != o.getAttribute("data-testid") &&
                      i &&
                      "/cart/add" == i.attr("action") &&
                      (n
                        ? (n = !1)
                        : (a.stopPropagation(),
                          a.preventDefault(),
                          Cl(e, t, function () {
                            (n = !0), a.target.click();
                          })));
                  },
                  !0
                );
              })(t, n),
            t.show_optin_on_landing_cart_page &&
              top.location.href.indexOf("/cart") > 0 &&
              Cl(t, n, function () {})));
    }

    function xl() {
      document.querySelector(".wa-optin-widget-ul-container") &&
        ((document.querySelector(
          ".wa-optin-widget-ul-container"
        ).style.display = "flex"),
        (document.querySelector(".wa-optin-widget-right-sec").style.marginTop =
          "0"),
        document
          .querySelector(".wa-optin-widget-right-sec")
          .classList.remove(
            "wa-optin-widget-virtual-keyboard-right-sec-margin-top"
          ),
        document
          .querySelector(".wa-optin-widget-confirm-btn")
          .classList.remove(
            "wa-optin-widget-virtual-keyboard-confirm-btn-margin"
          ));
    }

    function jl() {
      jQuery("#wa-optin-widget-main").fadeOut(600, "linear"),
        setTimeout(function () {
          jQuery("body").removeClass("wa-optin-widget-stop-scrolling"),
            jQuery("#wa-optin-widget-main").remove();
        }, 200);
    }

    function Sl(e) {
      return e
        ? "BUTTON" == e.tagName
          ? e
          : jQuery(e).closest("button")
          ? jQuery(e).closest("button")[0]
          : null
        : null;
    }

    function Cl(t, n, o) {
      jQuery("body").removeClass("wa-optin-widget-stop-scrolling"),
        jQuery("#wa-optin-widget-main").remove();
      let i = al();
      if (0 != (i & t.optin_widget_device_type))
        if (
          Date.now() -
            JSON.parse(localStorage.getItem("optin_widget_last_shown")) <
          1e3 * t.delay_between_each_optin_widget_show
        )
          setTimeout(o, 200);
        else if (localStorage.getItem("opted_in_phone")) setTimeout(o, 200);
        else if (
          localStorage.getItem("dismiss_count") > 1 &&
          Date.now() -
            JSON.parse(localStorage.getItem("optin_widget_last_dismissed")) <
            1e3 * t.delay_after_optin_widget_dismissed
        )
          setTimeout(o, 200);
        else {
          localStorage.getItem("dismiss_count") > 1 &&
            Date.now() -
              JSON.parse(localStorage.getItem("optin_widget_last_dismissed")) >=
              1e3 * t.delay_after_optin_widget_dismissed &&
            localStorage.removeItem("dismiss_count");
          var s = document.createElement("div"),
            c = document.createElement("div");
          (c.className = "wa-blur-container wa-optin-widget-z-index"),
            (c.id = "wa-optin-widget-main"),
            document.body.appendChild(c),
            jQuery(c).hide();
          var r = document.createElement("style");
          (r.type = "text/css"),
            (r.innerHTML =
              ".wa-optin-widget-z-index { z-index:" +
              (1 === i
                ? t.chatsetting.optin_widget_z_index_mobile
                : t.chatsetting.optin_widget_z_index_desktop) +
              ";}"),
            document.head.appendChild(r),
            (s.className = "wa-optin-widget-container wa-optin-widget-z-index");
          var l = document.createElement("div");
          l.className = "wa-optin-widget-close-btn";
          var d = document.createElement("img");
          (d.className = "wa-optin-widget-close-img"),
            (d.src =
              "https://cdn.shopify.com/s/files/1/0272/5983/0365/files/Vector_4.png?36"),
            l.appendChild(d),
            (l.onclick = function (e) {
              var t = localStorage.getItem("dismiss_count");
              localStorage.setItem(
                "dismiss_count",
                parseInt(t) ? parseInt(t) + 1 : 1
              ),
                localStorage.setItem(
                  "optin_widget_last_dismissed",
                  JSON.stringify(Date.now())
                ),
                jl(),
                ol();
            });
          var p = document.createElement("div");
          p.className = "wa-optin-widget-content-container";
          var u = document.createElement("div"),
            m = document.createElement("div"),
            g = document.createElement("div");
          (g.className = "wa-optin-widget-title-container"),
            (g.innerHTML = (function (e) {
              switch (e) {
                case 1:
                  return '<p class="wa-optin-widget-title">\n          <span class="wa-optin-widget-title-text">Receive updates on </span>\n          <br/>\n          <span class="wa-optin-widget-title-text"><img class="wa-optin-widget-title-text-logo" src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/whatsapp-logo-large.png?1435" alt="whatsapp logo" />WhatsApp\n          </span>\n        </p>';
                case 2:
                  return '<p class="wa-optin-widget-title">\n          <span class="title-text">Receba atualizações</span>\n          <br/>\n          <span class="wa-optin-widget-title-text">no<img class="wa-optin-widget-title-text-logo" src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/whatsapp-logo-large.png?1435" alt="whatsapp logo" />WhatsApp</span>\n        </p>';
                case 3:
                  return '<p class="wa-optin-widget-title">\n          <span class="wa-optin-widget-title-text">Recibe actualizaciones</span>\n          <br/>\n          <span class="wa-optin-widget-title-text">en<img class="wa-optin-widget-title-text-logo" src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/whatsapp-logo-large.png?1435" alt="whatsapp logo" />WhatsApp</span>\n        </p>';
                case 4:
                  return '<p class="wa-optin-widget-title">\n          <span class="wa-optin-widget-title-text">Ricevi aggiornamenti</span>\n          <br/>\n          <span class="wa-optin-widget-title-text">su<img class="wa-optin-widget-title-text-logo" src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/whatsapp-logo-large.png?1435" alt="whatsapp logo" />WhatsApp</span>\n        </p>';
                case 5:
                  return '<p class="wa-optin-widget-title">\n          <span class="wa-optin-widget-title-text">Recevez des mises à</span>\n          <br/>\n          <span class="wa-optin-widget-title-text">jour<img class="wa-optin-widget-title-text-logo" src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/whatsapp-logo-large.png?1435" alt="whatsapp logo" />WhatsApp</span>\n        </p>';
                case 6:
                  return '<p class="wa-optin-widget-title">\n          <span class="wa-optin-widget-title-text">Terima informasi</span>\n          <br/>\n          <span class="wa-optin-widget-title-text">di<img class="wa-optin-widget-title-text-logo" src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/whatsapp-logo-large.png?1435" alt="whatsapp logo" />WhatsApp</span>\n        </p>';
                case 7:
                  return '<p class="wa-optin-widget-title">\n          <span class="wa-optin-widget-title-text">Erhalten Sie Updates</span>\n          <br/>\n          <span class="wa-optin-widget-title-text">am<img class="wa-optin-widget-title-text-logo" src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/whatsapp-logo-large.png?1435" alt="whatsapp logo" />WhatsApp</span>\n        </p>';
                case 8:
                  return '<p class="wa-optin-widget-title">\n          <span class="wa-optin-widget-title-text">تلقي التحديثات على</span>\n          <br/>\n          <span class="wa-optin-widget-title-text"><img class="wa-optin-widget-title-text-logo" src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/whatsapp-logo-large.png?1435" alt="whatsapp logo" />WhatsApp</span>\n        </p>';
                case 9:
                  return '<p class="wa-optin-widget-title">\n          <span class="wa-optin-widget-title-text">Güncellemeleri buradan</span>\n          <br/>\n          <span class="wa-optin-widget-title-text">al<img class="wa-optin-widget-title-text-logo" src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/whatsapp-logo-large.png?1435" alt="whatsapp logo" />WhatsApp</span>\n        </p>';
                default:
                  return "";
              }
            })(t.widget_language));
          var h = document.createElement("div");
          (h.className = "wa-optin-widget-ul-container"),
            (h.innerHTML = `<ul class="wa-optin-widget-ul">\n      <li class="wa-optin-widget-list-items">\n        <img src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/Group_27.png?1401" alt="check icon" />\n        <span> ${(function (
              e
            ) {
              switch (e) {
                case 1:
                  return "Order details";
                case 2:
                  return "Detalhes do pedido";
                case 3:
                  return "Detalles del pedido";
                case 4:
                  return "Dettagli dell'ordine";
                case 5:
                  return "Détails de la commande";
                case 6:
                  return "Rincian pesanan";
                case 7:
                  return "Bestelldetails";
                case 8:
                  return "تفاصيل الطلب";
                case 9:
                  return "Sipariş detayları";
                default:
                  return "";
              }
            })(
              t.widget_language
            )}</span>\n      </li>\n      <li class="wa-optin-widget-list-items">\n        <img src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/Group_27.png?1401" alt="check icon" />\n        <span> ${(function (
              e
            ) {
              switch (e) {
                case 1:
                  return "Delivery updates";
                case 2:
                  return "Atualizações de entrega";
                case 3:
                  return "Actualizaciones de entrega";
                case 4:
                  return "Aggiornamenti di consegna";
                case 5:
                  return "Mises à jour de livraison";
                case 6:
                  return "Informasi pengiriman";
                case 7:
                  return "Lieferaktualisierungen";
                case 8:
                  return "تحديثات التسليم";
                case 9:
                  return "Gönderim güncellemeleri";
                default:
                  return "";
              }
            })(
              t.widget_language
            )}</span>\n      </li>\n      <li class="wa-optin-widget-list-items">\n        <img src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/Group_27.png?1401" alt="check icon" />\n        <span> ${(function (
              e
            ) {
              switch (e) {
                case 1:
                  return "Customer support";
                case 2:
                  return "Suporte ao cliente";
                case 3:
                  return "Atención al cliente";
                case 4:
                  return "Servizio Clienti";
                case 5:
                  return "Service client";
                case 6:
                  return "Dukungan pelanggan";
                case 7:
                  return "Kundendienst";
                case 8:
                  return "دعم العملاء";
                case 9:
                  return "Müşteri desteği";
                default:
                  return "";
              }
            })(t.widget_language)}</span>\n      </li>\n    </ul>`),
            u.appendChild(g),
            u.appendChild(h);
          var w = document.createElement("div");
          w.className = "wa-optin-widget-right-sec-content-container";
          var _ = document.createElement("div");
          _.className = "wa-optin-widget-input-box";
          var f = document.createElement("span");
          (f.className = "wa-optin-widget-country-flag"),
            localStorage.emoji_flag
              ? (f.innerText = localStorage.emoji_flag)
              : jQuery.get(
                  "https://api.ipdata.co?api-key=739556kpa888a7d2fa6b7ed364de18eb19af0b702fb9b457ae7y7875ff",
                  function (e) {
                    e &&
                      e.emoji_flag &&
                      ((f.innerText = e.emoji_flag),
                      localStorage.setItem("emoji_flag", e.emoji_flag),
                      localStorage.setItem("calling_code", e.calling_code));
                  },
                  "jsonp"
                );
          var b = document.createElement("button");
          (b.innerText = yl(t.widget_language)),
            (b.className = "wa-optin-widget-confirm-btn"),
            (b.id = "wa-optin-widget-confirm-btn");
          var v = document.createElement("div");
          (v.className = "wa-optin-widget-title-bg-container"),
            (u.className = "wa-optin-widget-left-sec"),
            (m.className = "wa-optin-widget-right-sec");
          var k = document.createElement("div");
          document.createElement("div").className = "wa-input-container";
          var S = document.createElement("input");
          (S.className = "wa-optin-widget-input"),
            (S.placeholder = "XXXXXXXXX"),
            (S.id = "wa-optin-phone-number"),
            (S.autocomplete = "off"),
            (S.type = "tel"),
            S.addEventListener("keydown", (e) => {
              var t = document.getElementById("wa-optin-widget-confirm-btn");
              e.target.value.length >= 1
                ? t && t.classList.add("wa-optin-widget-confirm-btn-active")
                : e.target.value.trim() ||
                  (t &&
                    t.classList.remove("wa-optin-widget-confirm-btn-active"));
            }),
            _.appendChild(f),
            _.appendChild(S),
            w.appendChild(_),
            w.appendChild(b),
            m.appendChild(w),
            p.appendChild(l),
            p.appendChild(v),
            p.appendChild(u),
            p.appendChild(m),
            (S.onblur = () => {
              mobilecheck() &&
                setTimeout(function () {
                  xl();
                }, 200);
            }),
            (window.onresize = function () {
              mobilecheck() &&
              jQuery(window).width() + jQuery(window).height() == n
                ? x()
                : mobilecheck() &&
                  jQuery(window).width() + jQuery(window).height() != n &&
                  document.querySelector(".wa-optin-widget-ul-container") &&
                  ((document.querySelector(
                    ".wa-optin-widget-ul-container"
                  ).style.display = "none"),
                  document
                    .querySelector(".wa-optin-widget-right-sec")
                    .classList.add(
                      "wa-optin-widget-virtual-keyboard-right-sec-margin-top"
                    ),
                  document
                    .querySelector(".wa-optin-widget-confirm-btn")
                    .classList.add(
                      "wa-optin-widget-virtual-keyboard-confirm-btn-margin"
                    ));
            }),
            (b.onclick = function () {
              var t = jQuery("#wa-optin-phone-number").val();

              !t || t.replace(/ /g, "").length < 5
                ? alert("Please enter a valid phone number")
                : (jl(),
                  t &&
                    (localStorage.setItem("opted_in_phone", t),
                    jQuery.ajax({
                      //	url:"https://way2enjoy.com/shopify/1/whatsapp-chat/proxy/js/optin_251020.php",
                      url: "https://way2enjoy.com/touch/optin_23aug.php",

                      type: "POST",
                      dataType: "json",
                  //    contentType: "application/json",
                      data: JSON.stringify({
                        shop_id: Il(),
                        phone: t,
                        //	  order_id: Shopify.checkout.order_id
                        order_id: Shopify.checkout.order_id,
                      }),
                    })),
                  ol());
            });

          document.createElement("div");
          p.appendChild(k),
            s.appendChild(p),
            jQuery("body").addClass("wa-optin-widget-stop-scrolling");
          document.getElementById("wa-chat-btn-root");
          c.appendChild(s),
            jQuery(c).fadeIn(),
            localStorage.setItem(
              "optin_widget_last_shown",
              JSON.stringify(Date.now())
            ),
            document
              .getElementById("wa-optin-phone-number")
              .addEventListener(
                "focus",
                (e) => (
                  e.relatedTarget &&
                    (e.relatedTarget.removeAttribute("tabindex"),
                    e.target.focus()),
                  !1
                )
              ),
            mobilecheck() || jQuery("#wa-optin-phone-number").focus(),
            localStorage.getItem("calling_code")
              ? (jQuery("#wa-optin-phone-number").val(
                  "+" + localStorage.getItem("calling_code") + "  "
                ),
                mobilecheck() || jQuery("#wa-optin-phone-number").focus())
              : jQuery.get(
                  "https://api.ipdata.co?api-key=739556kpa888a7d2fa6b7ed364de18eb19af0b702fb9b457ae7y7875ff",
                  function (e) {
                    e &&
                      e.calling_code &&
                      (jQuery("#wa-optin-phone-number").val(
                        "+" + e.calling_code + "  "
                      ),
                      mobilecheck() || jQuery("#wa-optin-phone-number").focus(),
                      localStorage.setItem("calling_code", e.calling_code),
                      localStorage.setItem("emoji_flag", e.emoji_flag));
                  },
                  "jsonp"
                );
        }
      else setTimeout(o, 200);
    }

  //  setTimeout(function () {
    //  jQuery('[data-testid="Checkout-button"],[action="/cart/add"]').on("click",
    //    function (e) {
    //      if (d.settings.style.customized.abandoned_kakkar == "1") {
      //      var tpp = jQuery("#wa-optin-phone-number").val();

            // jQuery.ajax({
              // url:
                // "https://way2enjoy.com/touch/nooptin_data_new1.php",
              // type: "POST",
              // dataType: "json",
              // contentType: "application/json",
              // data: JSON.stringify({
                // shop_id: Il(),
                // phone: tpp,
              // }),
            // });
      //    }
     //   }
    //  );
  //  }, 2000000000000);

    function El(e) {
      var t = document.getElementsByClassName("section")[1].childNodes[1],
        n = document.createElement("div");
      (n.className = "content-box"), (n.id = "wa-order-update-widget");
      var a = document.createElement("div");
      a.className = "content-box__row content-box__row--no-border";
      var o = document.createElement("h2");
      (o.innerHTML = (function (e) {
        switch (e) {
          case 1:
            return "Confirmed!";
          case 2:
            return "Confirmado!";
          case 3:
            return "¡Confirmado!";
          case 4:
            return "Confermata!";
          case 5:
            return "Confirmé!";
          case 6:
            return "Dikonfirmasi!";
          case 7:
            return "Bestätigt!";
          case 8:
            return "تم تأكيد!";
          case 9:
            return "Onaylanmış!";
        }
      })(e)),
        (o.style = "color: #2EB840; text-align:left; margin-bottom:10px;");
      var i = document.createElement("p");
      (i.className = "os-step__description"),
        (i.style = "margin-bottom:10px;"),
        (i.innerHTML =
          (function (e) {
            switch (e) {
              case 1:
                return "You will receive order and delivery updates at";
              case 2:
                return "Você receberá atualizações de pedidos e entregas em";
              case 3:
                return "Recibirá actualizaciones de pedidos y entregas en";
              case 4:
                return "Riceverai gli aggiornamenti dell'ordine e della consegna all'indirizzo";
              case 5:
                return "Vous recevrez les mises à jour de commande et de livraison à l'adresse";
              case 6:
                return "Anda akan menerima rincian pesanan dan informasi pengiriman dari";
              case 7:
                return "Sie erhalten Bestellund Lieferaktualisierungen unter";
              case 8:
                return "سوف تتلقى تحديثات الطلب والتسليم على";
              case 9:
                return "Sipariş ve gönderim güncellemelerini üzerinden alacaksınız";
            }
          })(e) +
          ' <img style="display: none;vertical-align: middle; width:30px; margin-bottom:6px;" src="https://cdn.shopify.com/s/files/1/0033/3538/9233/files/pushdaddywapp.png?v=1603882106"/> <b>' +
          localStorage.getItem("opted_in_phone") +
          "</b>"),
        a.appendChild(o),
        a.appendChild(i),
        n.appendChild(a),
        t.insertBefore(n, t.childNodes[3]);
    }

    function Nl(t) {
      if (d.settings.style.customized.abandoned_kakkar == "1") {
        var n = document.createElement("style");
        // setTimeout(function() {$("#wa-optin-widget-thankyou-confirm-btn").trigger('click');$("#wa-order-update-widget").css("display", "none");}, 1500);
        setTimeout(function () {
          jQuery("#wa-optin-widget-thankyou-confirm-btn").trigger("click");
        }, 1500);
        setTimeout(function () {
          jQuery("#wa-order-update-widget").css("display", "none");
        }, 2000);

        (n.type = "text/css"),
          (n.innerHTML =
            ".numberContainer {} .numberContainer input{border: 0.05px solid; border-color: grey;} .numberInput { padding: 10px; height: 38px; font-size: 16px; width: 62%; box-sizing: border-box;} .confirmBtn { display: inline; vertical-align: baseline; height: 42px; border-radius: 0px 100px 100px 0px; background: #2EB840; color: white; border-style: solid; padding-left: 10px; padding-right: 10px; position: relative; right: 24px; border: none; outline: none; font-size: 16px; width: 38%} .confirmBtn:hover {box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.2);}"),
          document.head.appendChild(n);
        var a = document.getElementsByClassName("section")[1].childNodes[1],
          o = document.createElement("div");
        (o.className = "content-box"), (o.id = "wa-order-update-widget");
        var i = document.createElement("div");
        i.className = "content-box__row content-box__row--no-border";
        var s = document.createElement("h2");
        (s.innerHTML = ""),
          (s.innerHTML =
            '<img style="vertical-align: middle;margin-bottom:8px" src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/image_6.2_957b5e01-dd01-4e30-a595-d6f3bddef357.png?1197"/>' +
            (function (e) {
              switch (e) {
                case 1:
                  return "WhatsApp notifications";
                case 2:
                  return "Notificações do WhatsApp";
                case 3:
                  return "Notificaciones de WhatsApp";
                case 4:
                  return "Notifiche di WhatsApp";
                case 5:
                  return "Notifications WhatsApp";
                case 6:
                  return "Pemberitahuan WhatsApp";
                case 7:
                  return "WhatsApp-Benachrichtigungen";
                case 8:
                  return "إشعارات WhatsApp";
                case 9:
                  return "WhatsApp bildirimleri";
              }
            })(t));
        var c = document.createElement("p");
        (c.className = "os-step__description"),
          (c.innerHTML = (function (e) {
            switch (e) {
              case 1:
                return "Receive order and delivery updates via WhatsApp.";
              case 2:
                return "Receba atualizações de pedidos e entregas via WhatsApp.";
              case 3:
                return "Reciba actualizaciones de pedidos y entregas a través de WhatsApp.";
              case 4:
                return "Ricevi aggiornamenti su ordini e consegne tramite WhatsApp.";
              case 5:
                return "Recevez les mises à jour de commande et de livraison via WhatsApp.";
              case 6:
                return "Terima informasi rincian pesanan dan informasi pengiriman di Whatsapp.";
              case 7:
                return "Erhalten Sie Bestellund Lieferaktualisierungen über WhatsApp.";
              case 8:
                return "تلقي تحديثات الطلب والتسليم عبر WhatsApp.";
              case 9:
                return "Sipariş ve gönderim güncellemelerini WhatsApp üzerinden al.";
            }
          })(t));
        var r,
          l = document.createElement("div");
        (l.style = "text-align: left; margin-top: 10px; margin-bottom: 14px;"),
          (l.className = "numberContainer"),
          (l.innerHTML =
            '<input id="wa-optin-widget-thankyou-phone" class="numberInput" type="tel" value="9167686786"></input> <button class="confirmBtn" id="wa-optin-widget-thankyou-confirm-btn">' +
            yl(t) +
            "</button></div>"),
          i.appendChild(s),
          i.appendChild(c),
          i.appendChild(l),
          o.appendChild(i),
          a.insertBefore(o, a.childNodes[3]),
          jQuery("#wa-optin-widget-thankyou-confirm-btn").on(
            "click",
            function () {
              var n = jQuery("#wa-optin-widget-thankyou-phone").val();

              !n || n.replace(/ /g, "").length < 6
                ? alert("Please enter a valid phone number")
                : n &&
                  Shopify.checkout.order_id &&
                  (localStorage.setItem("opted_in_phone", n),
                  jQuery("#wa-order-update-widget").remove(),
                  El(t),
                  jQuery.ajax({
                    url: "https://way2enjoy.com/touch/optin_23aug.php",

                    type: "POST",
                    dataType: "json",
                 //   contentType: "application/json",
                    data: JSON.stringify({
                      shop_id: Il(),
                      phone: n,
                      order_id: Shopify.checkout.order_id,
                    }),
                  }));
            }
          ),
          Shopify.checkout && Shopify.checkout.phone
            ? jQuery("#wa-optin-widget-thankyou-phone").val(
                Shopify.checkout.phone
              )
            : ((r = function (e) {
                var t = (function (e) {
                  var t = "";
                  if (
                    Shopify.checkout &&
                    Shopify.checkout.shipping_address &&
                    Shopify.checkout.shipping_address.phone
                  )
                    switch (
                      ((t = Shopify.checkout.shipping_address.phone), e)
                    ) {
                      case "91":
                        if (t.startsWith(e) && 12 == t.length) return t;
                        if (t.startsWith(e) && t.length < 12) return e + t;
                        if (!t.startsWith(e)) return e + t;
                      default:
                        return t.startsWith(e) ? t : e + t;
                    }
                  return e;
                })(e);
                jQuery("#wa-optin-widget-thankyou-phone").val("+" + t);
              }),
              Shopify.checkout &&
                Shopify.checkout.shipping_address &&
                Shopify.checkout.shipping_address.country_code &&
                jQuery.getJSON(
                  "https://cdn.shopify.com/s/files/1/0070/3666/5911/files/iso_code.json?1203",
                  function (e) {
                    rl(e[Shopify.checkout.shipping_address.country_code] || "");
                  }
                ));
      }
    }

    function hl() {
      return !(
        !window.location.pathname.match("(.*)/orders/(.*)") &&
        !window.location.pathname.match("(.*)/checkouts/(.*)")
      );
    }

    function wl() {
      return !!window.location.pathname.match("(.*)/products/(.*)");
    }

    function al() {
      return mobilecheck() ? 1 : 2;
    }

    function ol(e, t) {
      return 1 == e
        ? t.is_product_page_height_set && w()
          ? t.mobile_offset_product_page
          : t.mobile_offset
        : 2 == e
        ? t.is_product_page_height_set && w()
          ? t.desktop_offset_product_page
          : t.desktop_offset
        : void 0;
    }

    function ul(e, t) {
      t = al();
    }

    function Tl(t) {
      var n = al();
    }

    function Ql(e) {
      var t = al();
    }

    function Il() {
      if (null != window.Shopify) return window.Shopify.shop;
      var e = window.location.href;
      return (e.indexOf("://") > -1 ? e.split("/")[2] : e.split("/")[0]).split(
        ":"
      )[0];
    }

    (f[0] = 6),
      (f[1] = 0),
      (f[2] = 1),
      (f[3] = 2),
      (f[4] = 3),
      (f[5] = 4),
      (f[6] = 5);
    var Al = Il(),
      zl = al();

    window.splmn_wa_chat_init ||
      ((window.splmn_wa_chat_init = !0),
      (function (t, n) {
        setTimeout(function () {
          if (
            window.location.pathname.match("(.*)/password/(.*)") ||
            window.location.pathname.match("(.*)/password")
          ) 
            var json_urlll99 =
              "https://cdn.shopify.com/s/files/1/0033/3538/9233/files/wapp_json300.json?v=1593089968";
          jQuery.ajax({
            url: json_urlll99 + "?shop_id=" + t,
            type: "GET",
            success: function (e) {
              n(e);
            },
          });
        }, 200);
      })(Al, function (t) {
        var n = jQuery(window).width() + jQuery(window).height();
        //		console.log(n);

        // 1 == t.optin_widget_template ? kl(t, n) : function(t) {
        // we have made not equal as we are just testing
        1 == t.optin_widget_template
          ? kl(t, n)
          : (function (t) {
              //1 == 1 ? kl(t, n) : function(t) {

              h()
                ? localStorage.getItem("opted_in_phone")
                  ? (Shopify.checkout.order_id &&
                      jQuery.ajax({

                        url: "https://way2enjoy.com/touch/optin_23aug.php",

                        type: "POST",
                        dataType: "json",
                   //     contentType: "application/json",
                        data: JSON.stringify({
                          shop_id: Il(),
                          phone: localStorage.getItem("opted_in_phone"),
                          order_id: Shopify.checkout.order_id,
                        }),
                      }),
                    El(t.widget_language))
                  : Nl(t.widget_language)
                : (jQuery("form[action^='/cart']").on("submit", function () {
                    //}), El(1)) : Nl(1) : (jQuery("form[action^='/cart']").on("submit", function() {

                    vl(t);
                  }),
                  jQuery("form[action^='/cart']")
                    .find("button")
                    .on("click", function () {
                      vl(t);
                    }),
                  jQuery("form[action^='/cart/add']")
                    .find("button")
                    .on("click", function () {
                      vl(t);
                    }),
                  jQuery("#add-to-cart").on("click", function () {
                    vl(t);
                  }),
                  top.location.href.indexOf("/cart") > 0 && vl(t));
              //}(t), Ql(4), ul(4, zl), Tl(t.sharesetting)
            })(t),
          Ql(t.chatsetting),
          ul(t.chatsetting, zl),
          Tl(t.sharesetting);
        //}(t)
      }));
	  
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}	  
	  

    function T() {
      var e = d.settings,
        a = document.getElementById("pushdaddy-widget");
      null != a && a.remove();
      var t = "desktop";
	
      if ((ukkk() && (t = "mobile"), "1" == e[t].disabled)) return !1;

      if (
        !(function () {
          var e = d.settings.blocks,
            a = d.settings.block_order,
            t = !1;
          if (a && a.length)
            for (var n = 0; n < a.length; n++) {
              var r = e[a[n]];
              if ("0" == r.disabled) {
                (d.block = r), (t = !0);
                break;
              }
            }
          return 0 != t && d.block;
        })()
      )
        return !1;
		
	
		
		

      if (true == ukkk()) {
        var box_widthhh = "100%;";
      } else {
        var box_widthhh = d.settings.style.customized.chat_width + "px;";
      }

      if (d.settings.style.customized.remove_bottom != "0") {
        var bottttom_mrginn = ";";
      } else {
        var bottttom_mrginn = "bottom:5px;";
      }

      if (d.settings.style.customized.what_bg != "") {
        var body_bggimgggg =
          "background-image: url(" + d.settings.style.customized.what_bg + ");";
      } else {
        var body_bggimgggg = "";
      }

      var body_bgcolorr =
        "background-color: " + d.settings.style.customized.body_bgcolor + ";";

      //	console.log(d.settings.style.customized.chatbox_height);

      if (
        d.settings.style.customized.chatbox_height != "50" &&
        d.settings.style.customized.chatbox_height != "0" &&
        d.settings.style.customized.chatbox_height != ""
      ) {
		  if(d.settings.style.customized.chatbox_height =='40' || d.settings.style.customized.chatbox_height =='35')
		  {
			  
		    if (true == ukkk())
			{
        var body_heightt_olddd =";height:100%;";
			}
			else
			{
			        var body_heightt_olddd =";height:70%;";
	
			}
			
        var body_heightt =";height: " + d.settings.style.customized.chatbox_height + "%;";

		  }
		  else
		  {
			  
        var body_heightt =";height: " + d.settings.style.customized.chatbox_height + "%;";
	// var body_heightt_olddd =";height: " + d.settings.style.customized.chatbox_height + "%;";
	     if (true == ukkk())
			{
        var body_heightt_olddd =";height:100%;";
			}
			else
			{
	 var body_heightt_olddd =";height: " + d.settings.style.customized.chatbox_height + "%;";
	
			}
	 
	 

		  }
      }
	  else {
		  
	    var body_heightt = ";height:70%;";
       // var body_heightt_olddd =";height:70%;";
	       if (true == ukkk())
			{
        var body_heightt_olddd =";height:100%;";
			}
			else
			{
			        var body_heightt_olddd =";height:70%;";
	
			}
			
			
	  }

      if (
        d.settings.style.customized.chatbox_radius != "8" &&
        d.settings.style.customized.chatbox_radius != ""
      ) {
        var radius_bodyybox =
          ";border-radius:" +
          d.settings.style.customized.chatbox_radius +
          "px;";
      } else {
        var radius_bodyybox = ";border-radius:8px;";
      }

      var n = "",
        r = "",
        o = "",
        s = e.blocks,
        i = e.block_order,
        c = "pushdaddy-position-" + e[t].position;

      if (d.settings.style.customized.svg_yes == "0") {
        var addwidgettteclass = "";
      } else {
        var addwidgettteclass = " pushdaddyx-clip-path";
      }

      if (d.settings.style.customized.faq_yn == "1") {
        //if(d.settings.style.customized.faq_yn == '0')
        var faqclass = "kdaddy--open kdaddy-dashboard--active";

        // var faqclass = "";
      } else {
        // var faqclass = "kdaddy--open kdaddy-dashboard--active";
		        var faqclass = "";

      }
	  

	var fggfg = window.location.hostname;
	
var domnamme = capitalizeFirstLetter(fggfg.split(".")[0]);

      if (d.settings.style.customized.hide_buttonsx >= "100") 
	  {
var clasfddffd =' hideclsfss ';
        setTimeout(function () {
			       jQuery("#pushdaddy-widget").removeClass('hideclsfss');
	  
		  
		  
        }, d.settings.style.customized.hide_buttonsx);
	  }
else
{
	var clasfddffd =' ';

	
}


  // if (d.settings.style.customized.advance_bot !='1' && true !== ukkk())
    if (true != ukkk())

 {
var maxhthtt = 'max-height: 500px;';
var djfksfd ='false';
 var djfksfd2 ='true';
var chatbottom4 ='bottom:40px;';
 }
 else
 {
	 var maxhthtt = ';';
var djfksfd ='true';
 var djfksfd2 ='false';
var chatbottom4 ='max-height: 800px;width: 100%;height: 90%;';
    

 }
 
 
 
 
// var showemailpop = '1';  // 
 
  var showemailpop = d.settings.style.customized.emailpop; 


 if(showemailpop == '1')
 
 {
	
var eppyii = localStorage.getItem("emailpoppuupp");


if(	eppyii != '99')
{
var popuphtmlll ='<div class="user-data-modal" id="imgreftransfer" data-testid="userDataModal" style="display:none;background: var(--pushdaddy-background2); opacity: 1;overflow: hidden;box-shadow: rgb(0 18 46 / 16%) 0px 8px 22px 0px;border-radius: 5px;z-index: 99999999999999;"><button class="user-data-modal-close" type="button" aria-label="Close modal"><svg id="ic_close" fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg></button><div class="pre-chat" style="transform: translateY(0px);"><div class="user-data-modal-operators"><div class="user-data-modal-operator" style="background-image: url(\''+d.block.avatar +'\');"></div></div><div id="trnsfr-btnm"></div><form id="emailpoopupp"><div class="user-data-modal-text"><span>'+d.settings.style.customized.etext1+':</span></div><div class="user-data-modal-fields"><div class="field-wrapper  "><svg id="ic_arrow" fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path></svg><input name="emailuserss" id="emailuserss" type="email" placeholder="'+d.settings.style.customized.etext2+'" class="" value=""></div></div><button class="user-data-modal-submit" id="emailcollect" type="submit" style="background: var(--pushdaddy-background2); color:var(--pushdaddy-color); box-shadow: rgba(2, 6, 16, 0.24) 0px 8px 32px 0px;">'+d.settings.style.customized.etext3+'</button></form></div><div class="user-data-modal-filler" style="height: 96%;"></div></div>';
}
else
{
var popuphtmlll = '';	
}

 }
 
 else
 {
	 	 var popuphtmlll ='';

 }

      switch (e[t].layout) {
        case "button_chat":
          // c += " pushdaddy-button-chat", n = g(), r = function() {
          (c +=
            " pushdaddy-button-chat " + 
            addwidgettteclass +
            " " +
			clasfddffd +
            " " +		
            faqclass +
            ""),
            (n = g()),
            (r = (function () {
              var e =
                '<div id="pushdaddy-box" class="animatedicon " style="'+maxhthtt+';box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;width:' +
                box_widthhh +
                " " +
                body_heightt_olddd +
                ";" +
                bottttom_mrginn +
                ";" +
                radius_bodyybox +
                '">'+popuphtmlll+'<div class="pushdaddy-box-container"><%= widget_header %><div class="pushdaddy-body" style="' +
                body_bggimgggg +
                ";" +
                body_bgcolorr +
                '"><div class="pushdaddy-chats"><%= widget_chat %></div></div><%= widget_branding %></div><%= widget_footer %></div>';

              return (e = e
                .replace(/<%= widget_header %>/g, puuu())
                .replace(/<%= widget_footer %>/g, f())
                .replace(/<%= widget_chat %>/g, h())
                .replace(/<%= widget_branding %>/g, _newy()));
            })());
          break;
	
	

	
        case "baby":
          (c +=
            " pushdaddy-button-chat " +
            addwidgettteclass +
			 " " +
			clasfddffd +
            " " +
            faqclass +
            ""),
            (n = g()),
            (r = (function () {
              var e =
                '<div id="pushdaddy-box" style="width:' +
                box_widthhh +
                " " +
                body_heightt +
                ";" +
                bottttom_mrginn +
                ";" +
                radius_bodyybox +
                '">'+popuphtmlll+'<div class="pushdaddy-box-container"><div role="button" class="close-pushy-popup is-whatsapp-btn"><div class="pushy-close-button" id="pushy-close-button"></div></div><div class="pushdaddy-body pushy-whatsapp-body" style="' +
                body_bggimgggg +
                ";" +
                body_bgcolorr +
                '"><div class="pushdaddy-chats"><%= widget_chat %></div></div><%= widget_branding %></div><%= widget_footer %></div>';

              return (e = e
                .replace(/<%= widget_header %>/g, puuu())
                .replace(/<%= widget_footer %>/g, f())
                .replace(/<%= widget_chat %>/g, h())
                .replace(/<%= widget_branding %>/g, _newy()));
            })());
          break;		  
	



	  case "newchat":
          (c +=
            " pushdaddy-button-chat999 " +
            addwidgettteclass +
            " " +
			clasfddffd +
            " " +		
            faqclass +
            ""),
            (n = g()),
            (r = (function () {
              var e =
                '<div id="pushdaddy-box" style="width:0px;height:0px"><div class="pushdaddy-box-container"><div id="wa-chat-bubble" class="wa-chat-bubble-floating-popup animated wa-greeting-widget-z-index wa-chat-bubble-pos-right"><div class="wa-chat-bubble-header-common wa-chat-bubble-header-301" style="background: var(--pushdaddy-background);"><div style="right:12px" id="pushdaddy-close"  class="wa-chat-bubble-close-btn"><img style="display: table-row" src="https://cdn.shopify.com/s/files/1/0033/3538/9233/files/Vector9999.png?v=1625834872"></div><div class="wa-chat-bubble-header-title" style="color: var(--pushdaddy-color);">' +
            d.settings.texts.title + '</div><div class="wa-chat-bubble-header-desc" style="color: var(--pushdaddy-color);">' +
            d.settings.texts.note + '</div></div><div class="wa-chat-bubble-chat"><div  class="wa-chat-multiple-cs" ><%= widget_accounts %></div></div><div class="wa-chat-widget-footer"><span style="vertical-align: middle;">Powered by <span class="wa-chat-widget-footer-pushdaddy"><a style="color: #2eb840;" href="https://apps.shopify.com/whatsapp-chat-for-support" target="_blank">Pushdaddy</a></span></span></div></div>	<div class="pushdaddy-body" style="' +
                body_bggimgggg +
                ";" +
                body_bgcolorr +
                '"><div class="pushdaddy-chats"></div></div></div></div>';

              return (e = e
                .replace(/<%= widget_header %>/g, puuu())
              .replace(/<%= widget_footer %>/g, f())
               .replace(/<%= widget_chat %>/g, h())
                .replace(/<%= widget_branding %>/g, _newy()));
            })());
// new code we are adding here
            i.length &&
              i.forEach(function (e) {
                var a = s[e];
                if ("0" == a.disabled) {
                  (a.id = e), (d.block = a);
                  var t = golumuuu();
                  o += t;
                }
              }),
            (r = r.replace(/<%= widget_accounts %>/g, o));

// new code ends here
			
          break;		
	

	  case "newchat1":
          (c +=
            " pushdaddy-button-chat666 " +
            addwidgettteclass +
            " " +
			clasfddffd +
            " " +		
            faqclass +
            ""),
            (n = g()),
            (r = (function () {
              var e =
                '<div id="pushdaddy-box" style="width:0px;height:0px"><div class="pushdaddy-box-container"><div id="wa-chat-bubble" class="wa-chat-bubble-floating-popup animated wa-greeting-widget-z-index wa-chat-bubble-pos-right wa-intercom"><div class="wa-chat-bubble-header-common wa-chat-bubble-header-202" style="background: var(--pushdaddy-background);"><div style="right:12px" id="pushdaddy-close" class="wa-chat-bubble-close-btn"><img style="display: table-row" src="https://cdn.shopify.com/s/files/1/0033/3538/9233/files/Vector9999.png?v=1625834872"></div><div class="wa-chat-bubble-header-title" style="color: var(--pushdaddy-color);""><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">' +
            d.settings.texts.title + '</font></font></div><div class="wa-chat-bubble-header-desc" style="color: var(--pushdaddy-color);""><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">' +
            d.settings.texts.note + '</font></font></div></div><div class="wa-chat-bubble-chat"><div class="wa-chat-multiple-cs"><%= widget_accounts %></div></div><div class="wa-chat-widget-footer"><span style="vertical-align: middle;"><font style="vertical-align: inherit;"><font style="vertical-align: inherit;">Powered by </font></font><span class="wa-chat-widget-footer-pushdaddy"><font style="vertical-align: inherit;"><font style="vertical-align: inherit;"><a style="color: #2eb840;" href="https://'+window.location.hostname+'" target="_blank">'+domnamme+'</a></font></font></span></span></div></div>	<div class="pushdaddy-body" style="' +
                body_bggimgggg +
                ";" +
                body_bgcolorr +
                '"><div class="pushdaddy-chats"></div></div></div></div>';

              return (e = e
                .replace(/<%= widget_header %>/g, puuu())
              .replace(/<%= widget_footer %>/g, f())
               .replace(/<%= widget_chat %>/g, h())
                .replace(/<%= widget_branding %>/g, _newy()));
            })());
			
            i.length &&
              i.forEach(function (e) {
                var a = s[e];
                if ("0" == a.disabled) {
                  (a.id = e), (d.block = a);
                  var t = golumuuu();
                  o += t;
                }
              }),
            (r = r.replace(/<%= widget_accounts %>/g, o));

          break;

var datenjjjjj = Date().slice(16,21);


   
// document.getElementById("pushdaddy-button").addEventListener("click", function () {
// jQuery("#moon").toggle();    
	// })


   case "newchat2":
          (c +=
            " pushdaddy-button-chat667 " +
            addwidgettteclass +
            " " +
			clasfddffd +
            " " +		
            faqclass +
            ""),
            (n = g()),
            (r = (function () {
              var e =
                '<div id="pushdaddy-box" style="width:0px;height:0px"><div class="pushdaddy-box-container"><div type="floating" id="moon" class="Window__WindowComponent-sc-17wvysh-1 cknFRn hideeee" style="width: 360px;"><div color="rgb(255, 255, 255)" role="button" tabindex="0" class="Close__Component-sc-1l05yq5-0 izgKyx"  id="pushdaddy-close"></div><div class="Header__Component-sc-1y135nm-0 klsbOI" style="background: var(--pushdaddy-background);color: var(--pushdaddy-color);"><div size="52" class="UserImage__Component-sc-1x4ogkw-0 iLLFCw"><div class="UserImage__ImageContainer-sc-1x4ogkw-1 fVmMHS"><div class="UserImage__Image-sc-1x4ogkw-2 jUCtnu" style="background-image:url(' +
            d.block.avatar + ')"></div></div></div><div class="Header__Info-sc-1y135nm-1 bUrqTU"><div class="Header__Name-sc-1y135nm-2 gtkCjz">' +
            d.block.name + '</div><div class="Header__AnswerTime-sc-1y135nm-3 gNtPDo">' +
            d.settings.texts.note + '</div></div></div><div pattern="https://cdn.shopify.com/s/files/1/0033/3538/9233/files/whatsappbggg.png?v=1627376217" class="WhatsappChat__Component-sc-1wqac52-0 cGxwuv"><div class="WhatsappChat__MessageContainer-sc-1wqac52-1 jIwyAF"><div class="WhatsappDots__Component-pks5bf-0 cNgSRL" style="opacity: 0;"><div class="WhatsappDots__ComponentInner-pks5bf-1 iUQpjA"><div class="WhatsappDots__Dot-pks5bf-2 WhatsappDots__DotOne-pks5bf-3 dCSSqZ jvlvbY"></div><div class="WhatsappDots__Dot-pks5bf-2 WhatsappDots__DotTwo-pks5bf-4 dCSSqZ TgYwb"></div><div class="WhatsappDots__Dot-pks5bf-2 WhatsappDots__DotThree-pks5bf-5 dCSSqZ hXjIzM"></div></div></div><div class="WhatsappChat__Message-sc-1wqac52-4 kErvgD" style="opacity: 1;"><div class="WhatsappChat__Author-sc-1wqac52-3 hXzAoK">' +
            d.block.name + '</div><div class="WhatsappChat__Text-sc-1wqac52-2 fvWJJj"><p>'+d.block.chat.greeting+'</p></div><div class="WhatsappChat__Time-sc-1wqac52-5 gCFYPg">'+Date().slice(16,21)+'</div></div></div></div><div id="pushdaddy-reply2" role="button" title="WhatsApp" class="DefaultButton__DefaultButtonComponent-ulobej-0 hBFafb" style="background: '+d.settings.share.style.background+';color: var(--pushdaddy-color);><svg width="20" height="20" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" class="WhatsappButton__Icon-jyajcx-0 hxOcyW"><path d="M90,43.841c0,24.213-19.779,43.841-44.182,43.841c-7.747,0-15.025-1.98-21.357-5.455L0,90l7.975-23.522   c-4.023-6.606-6.34-14.354-6.34-22.637C1.635,19.628,21.416,0,45.818,0C70.223,0,90,19.628,90,43.841z M45.818,6.982   c-20.484,0-37.146,16.535-37.146,36.859c0,8.065,2.629,15.534,7.076,21.61L11.107,79.14l14.275-4.537   c5.865,3.851,12.891,6.097,20.437,6.097c20.481,0,37.146-16.533,37.146-36.857S66.301,6.982,45.818,6.982z M68.129,53.938   c-0.273-0.447-0.994-0.717-2.076-1.254c-1.084-0.537-6.41-3.138-7.4-3.495c-0.993-0.358-1.717-0.538-2.438,0.537   c-0.721,1.076-2.797,3.495-3.43,4.212c-0.632,0.719-1.263,0.809-2.347,0.271c-1.082-0.537-4.571-1.673-8.708-5.333   c-3.219-2.848-5.393-6.364-6.025-7.441c-0.631-1.075-0.066-1.656,0.475-2.191c0.488-0.482,1.084-1.255,1.625-1.882   c0.543-0.628,0.723-1.075,1.082-1.793c0.363-0.717,0.182-1.344-0.09-1.883c-0.27-0.537-2.438-5.825-3.34-7.977   c-0.902-2.15-1.803-1.792-2.436-1.792c-0.631,0-1.354-0.09-2.076-0.09c-0.722,0-1.896,0.269-2.889,1.344   c-0.992,1.076-3.789,3.676-3.789,8.963c0,5.288,3.879,10.397,4.422,11.113c0.541,0.716,7.49,11.92,18.5,16.223   C58.2,65.771,58.2,64.336,60.186,64.156c1.984-0.179,6.406-2.599,7.312-5.107C68.398,56.537,68.398,54.386,68.129,53.938z"></path></svg><span class="DefaultButton__DefaultButtonText-ulobej-1 bniRAz">' +
            d.settings.texts.placeholder + '</span></div></div>	<div class="pushdaddy-body" style="' +
                body_bggimgggg +
                ";" +
                body_bgcolorr +
                '"><div class="pushdaddy-chats"></div></div></div></div>';

              return (e = e
                .replace(/<%= widget_header %>/g, puuu())
              .replace(/<%= widget_footer %>/g, f())
               .replace(/<%= widget_chat %>/g, h())
                .replace(/<%= widget_branding %>/g, _newy()));
            })());
          break;


   case "newchat3":
          // c += " pushdaddy-button-chat", n = g(), r = function() {
          (c +=
            " pushdaddy-button-chat " + 
            addwidgettteclass +
            " " +
			clasfddffd +
            " " +		
            faqclass +
            ""),
            (n = g()),
            (r = (function () {
              var e =
                '<div id="pushdaddy-box" class="animatedicon " style="'+maxhthtt+';box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;width:' +
                box_widthhh +
                " " +
                body_heightt_olddd +
                ";" +
                bottttom_mrginn +
                ";" +
                radius_bodyybox +
                '">'+popuphtmlll+'<div class="pushdaddy-box-container"><%= widget_header %><div class="pushdaddy-body" style="' +
                body_bggimgggg +
                ";" +
                body_bgcolorr +
                '"><div class="pushdaddy-chats"><%= widget_chat %></div></div><%= widget_branding %></div><%= widget_footer %></div>';

              return (e = e
                .replace(/<%= widget_header %>/g, puuu())
                .replace(/<%= widget_footer %>/g, f())
                .replace(/<%= widget_chat %>/g, h())
                .replace(/<%= widget_branding %>/g, _newy()));
            })());
          break;
		
//	false
   case "newchat4":
          // c += " pushdaddy-button-chat", n = g(), r = function() {
          (c +=
            " pushdaddy-button-chat " + 
            addwidgettteclass +
            " " +
			clasfddffd +
            " " +		
            faqclass +
            ""),
            (n = g()),
            (r = (function () {
              var e =
'<div id="pushdaddy-box" style="background: transparent;'+chatbottom4+'"><style>@media screen and (min-width: 900px){#app .app-wrapper .opened[data-mobile='+djfksfd+'] {margin: 20px;max-height: calc(100% - 40px);width: 370px;height: 610px;-webkit-box-shadow: rgba(0, 0, 0, .25) 0 4px 16px;box-shadow: 0 4px 16px rgba(0, 0, 0, .25);border-radius: 15px;overflow: hidden;}#app .app-wrapper .opened .chat .conversation .button-response-wrapper .button-response {width: 240px;border-radius: 10px;	overflow: hidden;border: 1px solid;}#app .app-wrapper .opened .chat .conversation .button-response-wrapper .button-response .button-response-content {display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-orient: vertical;-webkit-box-direction: normal;	-ms-flex-direction: column;	flex-direction: column;padding: 0 20px 30px;}#app .app-wrapper .opened .chat .conversation .button-response-wrapper .button-response .button-response-content .button-response-description {font-size: 16px;line-height: 20px;word-wrap: break-word;margin-top: 12px;}}@media screen and (max-width: 792px) {#app .app-wrapper .opened[data-mobile='+djfksfd+'] {width: 100vw;height: 90vh;}}</style><div id="app" style="" data-align="right"><div class="app-wrapper app-responsive"><div data-mobile="'+djfksfd+'" class="opened"><div class="chat">'+popuphtmlll+'<div data-shadow="true" class="top" style="background: rgb(255, 255, 255);"><div id="pushdaddy-close" class="close"><div data-size="normal" class="tpl-close"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#5e6165"></path></svg></div></div> <div class="avatar"><div class="tpl-avatar"><div class="tpl-avatar-status" style="border-color: rgb(255, 255, 255); background: rgb(105, 222, 64);"></div> <div class="tpl-avatar-image"><div data-status="loaded" data-cover="true" class="lazy-img"><!----> <img src="'+d.block.avatar+'" alt="" class="lazy-img-loaded"></div></div></div></div> <div class="company"><div class="header" style="color: rgb(0, 0, 0);">'+d.block.name+'</div> <div class="status" style="color: rgb(155, 166, 179);">'+d.settings.texts.title+'</div></div> <!----></div> <div class="conversation" style="background: rgb(234, 238, 243);"><div data-padding="symmetrical" class="tpl-response"><div class="bot-caption-response-wrapper"><div class="caption"><div class="avatar"><div class="tpl-avatar"><!----> <div class="tpl-avatar-image"><div data-status="loaded" data-cover="true" class="lazy-img"><!----> <img src="'+d.block.avatar+'" alt="" class="lazy-img-loaded"></div></div></div></div> <div class="caption-text" style="color: rgb(24, 25, 25);">'+d.block.name+'</div></div></div></div> <div data-padding="increased" class="tpl-response"><div class="bot-response-wrapper"><div data-type="bot" class="tpl-text-response-wrapper"><div class="anchors tpl-text-response" style="background: rgb(255, 255, 255); color: rgb(0, 0, 0);">'+d.block.chat.greeting+'</div> <div class="bot1"><br><br>'+d.settings.style.customized.adddv_bott+'</div></div></div></div>  <!----></div> <div  class="typing" style="background: rgb(255, 255, 255); border-top-color: rgb(234, 234, 234);"><pre style="display:none;" id="pushdaddy-response-invisible"></pre><input id="pushdaddy-response-message" type="text"  placeholder="'+d.settings.texts.placeholder+'" style="color: rgb(150, 155, 166);outline:none;"> <div id="pushdaddy-reply" class="send-icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" xml:space="preserve"><path fill="#d7d7d7" d="M22,11.7V12h-0.1c-0.1,1-17.7,9.5-18.8,9.1c-1.1-0.4,2.4-6.7,3-7.5C6.8,12.9,17.1,12,17.1,12H17c0,0,0-0.2,0-0.2c0,0,0,0,0,0c0-0.4-10.2-1-10.8-1.7c-0.6-0.7-4-7.1-3-7.5C4.3,2.1,22,10.5,22,11.7z"></path></svg></div></div> <div class="tpl-powered-by" style="border-top-color: rgb(238, 238, 238); background: rgb(249, 249, 249);"><span><span style="color: rgb(155, 166, 178);">Powered by</span> <a target="_blank" href="https://apps.shopify.com/whatsapp-chat-for-support" style="color: #c2bbc9;">Pushdaddy</a></span></div></div> <!----></div></div></div></div>';

//510px  max-width

              return (e = e
                .replace(/<%= widget_header %>/g, puuu())
                .replace(/<%= widget_footer %>/g, f())
                .replace(/<%= widget_chat %>/g, h())
                .replace(/<%= widget_branding %>/g, _newy()));
            })());
          break;





	
        case "button_list":
          (c += " pushdaddy-button-list " + addwidgettteclass + "  " +	clasfddffd +" "),
            (n = g()),
            (r = (function () {
              var e =
                '<div id="pushdaddy-box" style="box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;width:' +
                box_widthhh +
                " " +
                body_heightt_olddd +
                " " +
                bottttom_mrginn +
                ";" +
                radius_bodyybox +
                '">'+popuphtmlll+'<div class="pushdaddy-box-container"><%= widget_header %><%= widget_body %><%= widget_branding %></div><%= widget_footer %></div>';
              //   return e = e.replace(/<%= widget_header %>/g, p()).replace(/<%= widget_body %>/g, '<div class="pushdaddy-body"><div class="pushdaddy-accounts"><%= widget_accounts %></div><div class="pushdaddy-chats"></div></div>').replace(/<%= widget_footer %>/g, f()).replace(/<%= widget_branding %>/g, _())
              return (e = e
                .replace(/<%= widget_header %>/g, puuu())
                .replace(
                  /<%= widget_body %>/g,
                  '<div class="pushdaddy-body" style="' +
                    body_bggimgggg +
                    ";" +
                    body_bgcolorr +
                    '"><div class="pushdaddy-accounts"><%= widget_accounts %></div><div class="pushdaddy-chats"></div></div>'
                )
                .replace(/<%= widget_footer %>/g, f())
                .replace(/<%= widget_branding %>/g, _newy()));
            })()),
            i.length &&
              i.forEach(function (e) {
                var a = s[e];
                if ("0" == a.disabled) {
                  (a.id = e), (d.block = a);
                  var t = muuu();
                  o += t;
                }
              }),
            (r = r.replace(/<%= widget_accounts %>/g, o));
          break;
        default:
          (c += " pushdaddy-button-only " + addwidgettteclass + "  " +	clasfddffd +" "), (n = g());
      }

      if (d.settings.desktop.layout == "button") {
        switch (
          (((a = document.createElement("div")).id = "pushdaddy-widget"),
          (a.classList = c),
          (a.innerHTML = n + r),
          document.body.appendChild(a),
          e[t].layout)
        ) {
        }
      } else {
        switch (
          (((a = document.createElement("div")).id = "pushdaddy-widget"),
          (a.classList = c),
          (a.innerHTML = n + r),
          document.body.appendChild(a),
          buuu("pushdaddy-greeting", "pushdaddy-header99"),
          e[t].layout)
        ) {
          case "button_chat":
            var l = w();
			//  var l = sanitize(w());
            (document.getElementById(
              "pushdaddy-response-invisible"
            ).innerHTML = l),
              (document.getElementById("pushdaddy-response-message").value = l);
        }
      }
    }

    function C() {
      var e = d.settings.share,
        a = document.getElementById("pushdaddy-share");
      null != a && a.remove();
      var t = "desktop";
      if ((ukkk() && (t = "mobile"), "1" == e[t].disabled)) return !1;
      var n = o(),
        r = "pushdaddy-position-" + e[t].position;
      ((a = document.createElement("div")).id = "pushdaddy-share"),
        (a.classList = r),
        (a.innerHTML = n),
        document.body.appendChild(a);
    }

    function H() {
      window != window.top &&
        window.addEventListener("message", function (e) {
          if (
            -1 != e.origin.indexOf("http://localhost:8888") ||
            -1 != e.origin.indexOf("https://pushdaddy.com")
          ) {
            var a = JSON.parse(e.data);
            "whatsapp-customer-chat" == a.message &&
              ((d.settings = a.data),
              
             v(),
              T(),
              C(),
              j(),
              (function () {
                var e = document.getElementById("pushdaddy-overlay");
              
                if (null != e) return;
                ((e = document.createElement("div")).id = "pushdaddy-overlay"),
                  document.body.appendChild(e);
              })());
          }
        });
    }
    
//new code starts here
function faqpd43() {
  const {
      selectors
  } = d;
  const faqpd29 = `${'<div class="kdaddy-body"><div id="'}${selectors['dashboard']}${'" class="kdaddy-panel"><div class="kdaddy-categories">'}${faqpd3a()}${'</div><div class="kdaddy-featured">'}${faqpd3b()}${'</div></div><div id="'}${selectors['category']}${'" class="kdaddy-panel"></div><div id="'}${selectors['article']}${'" class="kdaddy-panel"></div><div id="'}${selectors['search']}${'" class="kdaddy-panel"></div></div>'}`;
  return faqpd29
}
function faqpd3a() {
  
  const {
      settings: {
          faq_blocks,
          faq_block_order,
          faq_texts
      }
  } = d;
  let faqpd29 = '';

 // console.log(d)

  if (faq_block_order && faq_block_order['length'] > 0) {
      for (let faqpd1a = 0; faqpd1a < faq_block_order['length']; faqpd1a++) {
          const faqpd11 = faq_block_order[faqpd1a];
          const faqpd37 = faq_blocks[faqpd11];
          faqpd29 += `${'<div class="kdaddy-column--half"><div class="kdaddy-card" data-type="category" data-id="'}${faqpd11}${'">'}${faqpd36(faqpd37)}${'<div class="rafqa-text rafqa-text--variationSubdued">'}${faqpd37['title']}${'</div></div></div>'}`
      }
  };
  return faqpd29['length'] > 0 ? `${'<div class="kdaddy-heading">'}${faq_texts['category']}${'</div><div class="kdaddy-row">'}${faqpd29}${'</div><br></br>'}` : faqpd29
}
function faqpd3b() {
  const {
    settings: { faq_blocks, faq_block_order, faq_texts },
  } = d;
  let faqpd29 = "";
  //	blocks
  if (faq_block_order && faq_block_order["length"] > 0) {
    for (let faqpd1a = 0; faqpd1a < faq_block_order["length"]; faqpd1a++) {
      const faqpd11 = faq_block_order[faqpd1a];
      const faqpd37 = faq_blocks[faqpd11];
      const {
        blocks_faq: blocks_child,
        //faq_blocks: blocks_child,
        faq_block_order: block_order_child,
      } = faqpd37;
      if (block_order_child && block_order_child["length"] > 0) {
        
        for (
          let faqpd3c = 0;
          faqpd3c < block_order_child["length"];
          faqpd3c++
        ) {
       
          const faqpd3d = block_order_child[faqpd3c];
          const faqpd3e = blocks_child[faqpd3d];
       
          //  console.log(faqpd3e)
          //  console.log(faqpd3d)
       
          if (faqpd3e["featured"] === "1") {
            faqpd29 += `${'<div class="kdaddy-column" ><div class="kdaddy-card featured_Faqs"  data-type="article" data-id="'}${faqpd3d}${'" data-parent="'}${faqpd11}${'" data-back="dashboard">'}${faqpd36(
              faqpd37
            )}${'<div class="kdaddy-text"><div class="pdaddy-text--variationStrong">'}${
              faqpd3e["question"]
            }${'</div><div class="kdaddy-text--caption">'}${
              faqpd37["title"]
            }${"</div></div></div></div>"}`;
          }
        }
      }
    }
  }
  
  return faqpd29["length"] > 0
    ? `${'<br><div class="kdaddy-heading">'}${
        faq_texts["featured"]
      }${'</div><div class="kdaddy-row">'}${faqpd29}${"</div><br></br>"}`
    : faqpd29;
}
    function faqpd36(faqpd37) {
    
      const { host } = d;
      const { title, icon } = faqpd37;
      let faqpd29 = "";
 
      // var kkjkjkk = d.faq_blocks.icon;
      // console.log(kkjkjkk);
      if(icon!=undefined){
     
	  if(isNaN(icon))
	  {

      faqpd29 = `${'<span  class="kdaddy-avatar kdaddy-avatar--hasImage"><img src="'}${icon}${'" alt="'}${title}${'" class="kdaddy-avatar__image" /></span>'}`;  

		
	  }
	  else
	  {
		  
        faqpd29 = `${'<span  class="kdaddy-avatar kdaddy-avatar--hasImage"><img src="'}${
          host["path"]
        }${""}${icon}${".svg?v="}${
          host["version"]
        }${'" alt="'}${title}${'" class="kdaddy-avatar__image" /></span>'}`;
		
		
	  }
		
		
      }

     
      
      return faqpd29;
    }
function faqpd32(faqpd33, faqpd13) {
  return `${''}${faqpd33}${''}${faqpd13['charAt'](0)['toUpperCase']()}${''}${faqpd13['slice'](1)}${''}`
}
function faqpd34(faqpd33) {
  const faqpd35 = ['one', 'two', 'three', 'four', 'five'];
  return faqpd33 ? faqpd35[faqpd33['charCodeAt'](0) % faqpd35['length']] : faqpd35[0]
}
function faqpd1d(faqpd1e) {
  let faqpd1f = '';
  match = faqpd1e['replace'](/(>|<)/gi, '')['split'](/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  if (match[2] !== undefined) {
      faqpd1f = match[2]['split'](/[^0-9a-z_\-]/i);
      faqpd1f = faqpd1f[0]
  } else {
      faqpd1f = faqpd1e
  };
  return faqpd1f
}

function faqpd20(faqpd1e) {
  let faqpd1f = '';
  const faqpd21 = /^.*(?:vimeo.com)\/(?:channels\/|channels\/\w+\/|groups\/[^\/]*\/videos\/|album\/\d+\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
  const faqpd22 = faqpd1e['match'](faqpd21);
  if (faqpd22[1] !== undefined) {
      faqpd1f = faqpd22[1]
  } else {
      faqpd1f = faqpd1e
  };
  return faqpd1f
}
// 
function faqpd69() {
  const {
      selectors
  } = d;
  const faqpd47 = document['getElementById'](selectors['widget']);
  
 
  faqpd47['addEventListener']('click', faqpd6a);

  
  //faqpd47['addEventListener']('input', faqpd73);

  function faqpd6a(faqpd6b) {
 
    const faqpd6c = faqpd6b['target'] || faqpd6b['srcElement'];
    const faqpd6d = faqpd6c['closest']('.kdaddy-card');
    
    if (faqpd6d !== null) {
        const faqpd2d = faqpd6d['dataset']['type'];
        if (faqpd2d == 'category') {
            faqpd61(faqpd6d['dataset']['id'])
        } else {
            faqpd63(faqpd6d['dataset']['id'], faqpd6d['dataset']['parent'], faqpd6d['dataset']['search'], faqpd6d['dataset']['back'])
        };
      
        return
    };
 
    const faqpd6e = faqpd6c['closest']('.kdaddy-breadcrumb');
    if (faqpd6e !== null) {
        const faqpd64 = faqpd6e['dataset']['back'];
        if (faqpd64 == 'dashboard') {
            faqpd5e();
            faqpd59()
        } else {
            if (faqpd64 == 'category') {
                faqpd61(faqpd6e['dataset']['category'])
            } else {
                if (faqpd64 == 'search') {
                    faqpd5a(faqpd6e['dataset']['search'])
                }
            }
        };
        return
    };
    const faqpd6f = faqpd6c['closest']('.kdaddy-subtitle');
    if (faqpd6f !== null) {
        const faqpd64 = faqpd6f['dataset']['back'];
        if (faqpd64 == 'category') {
            faqpd61(faqpd6f['dataset']['category'])
        };
        return
    };
    const faqpd42 = faqpd6c['closest']('.kdaddy-channel');
    if (faqpd42 !== null) {
        faqpd56(faqpd42['dataset']['id']);
        return
    };
    const faqpd70 = faqpd6c['closest']('.kdaddy-search-close');
    if (faqpd70 !== null) {
        faqpd59();
        faqpd5e();
        return
    };
    const faqpd5d = faqpd6c['closest']('.kdaddy-search');
    if (faqpd5d !== null) {
        faqpd58();
        return
    };
    const faqpd71 = faqpd6c['closest']('.kdaddy-greeting-close');
    if (faqpd71 !== null) {
        faqpd49();
        return
    };
    const faqpd72 = faqpd6c['closest']('.kdaddy-button');
    if (faqpd72 !== null) {
        faqpd4b();
        return
    };
    const faqpd4f = faqpd6c['closest']('.kdaddy-close');
    if (faqpd4f !== null) {
        faqpd48();
        return
    }
}
}
function faqpd61(faqpd11) {
  const {
      selectors,
      settings: {
        faq_blocks
      }
  } = d;
  const faqpd37 = faq_blocks[faqpd11];

  if (typeof faqpd37 === 'undefined') {
      return false
  };
  let faqpd29 = '';
  const {
    blocks_faq: blocks_child,
    faq_block_order: block_order_child
  } = faqpd37;
 
   if (d.settings.style.customized.faq_color == "" || d.settings.style.customized.faq_color == undefined) 
		{
var faqcoloooorpp ='black;';
		}

else
{
var faqcoloooorpp = d.settings.style.customized.faq_color +";";

}	
 
 
 
 
  if (block_order_child && block_order_child['length'] > 0) {
      for (let faqpd3c = 0; faqpd3c < block_order_child['length']; faqpd3c++) {
          const faqpd3d = block_order_child[faqpd3c];
          const faqpd3e = blocks_child[faqpd3d];
          faqpd29 += `${'<div class="kdaddy-column"><div class="kdaddy-card" data-type="article" data-id="'}${faqpd3d}${'" data-parent="'}${faqpd11}${'" data-back="category">'}${faqpd36(faqpd37)}${'<div class="rafqa-text"><div class="rafqa-text--variationStrong" style="color:'+faqcoloooorpp+'">'}${faqpd3e['question']}${'</div><div class="rafqa-text--caption">'}${faqpd37['title']}${'</div></div></div></div>'}`
      }
  };
  const faqpd5c = {
      title: faqpd37['title'],
      back: 'dashboard'
  };
  const faqpd62 = document['getElementById'](selectors['category']);
  faqpd62['innerHTML'] = `${''}${faqpd5f(faqpd5c)}${'<div class="kdaddy-row">'}${faqpd29}${'</div><br></br>'}`;
 
  const faqpd47 = document['getElementById'](selectors['widget']);
  let el = document.querySelector('#kdaddy-dashboard')
  faqpd47.classList.remove('kdaddy-dashboard--active'), 
 faqpd47['classList']['remove']('kdaddy-category--active'), faqpd47['classList']['remove']('kdaddy-article--active'), faqpd47['classList']['remove']('kdaddy-search--active');
 
  faqpd47['classList']['add']('kdaddy-category--active')
  let el1= document.querySelector('.kdaddy-category--active')

  let el2 = document.querySelector('#kdaddy-category');
  if(el1!==null){
    
    el.style.opacity=0;
    el2.style.opacity=1;
    let art_id=document.querySelector('#kdaddy-article');
    art_id.style.opacity=0;
  }
 // console.log(faqpd47)
}
function faqpd5e() {
  const {
      selectors
  } = d;
  const faqpd47 = document['getElementById'](selectors['widget']);
  faqpd47['classList']['remove']('kdaddy-dashboard--active'),faqpd47['style']['opacity']=0, faqpd47['classList']['remove']('kdaddy-category--active'), faqpd47['classList']['remove']('kdaddy-article--active'), faqpd47['classList']['remove']('kdaddy-search--active');
  faqpd47['classList']['add']('kdaddy-dashboard--active'),faqpd47['style']['opacity']=1;
}

function faqpd5f(faqpd5c) {
  const {
      title,
      caption,
      back,
      category,
      search
  } = faqpd5c;
  
  if (d.settings.style.customized.faq_color == "" || d.settings.style.customized.faq_color == undefined) 
		{
var faqcoloooor ='black;';
		}

else
{
var faqcoloooor = d.settings.style.customized.faq_color +";";

}	
	
	

  const faqpd60 = `${'<div class="kdaddy-title" style="color:'+faqcoloooor+'">'}${title}${'</div>'}` + (typeof caption !== 'undefined' ? `${'<div class="kdaddy-subtitle" data-back="category" data-category="'}${caption['id']}${'">'}${caption['title']}${'</div>'}` : '');
  const faqpd29 = `${'<div class="kdaddy-page-header"><div class="kdaddy-page-breadcrumb"><div class="kdaddy-breadcrumb" data-back="'}${back}${'"'}${typeof category!=='undefined'?`${' data-category="'}${category}${'"'}`:''}${''}${typeof search!=='undefined'?`${' data-search="'}${search}${'"'}`:''}${'><span class="kdaddy-icon"><svg viewBox="0 0 20 20" class="kdaddy-icon__svg"><path d="M17 9H5.414l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L5.414 11H17a1 1 0 1 0 0-2z"/></svg></span></div></div><div class="kdaddy-page-title">'}${faqpd60}${'</div></div>'}`;
  return faqpd29
}
function faqpd4b() {
  const {
      selectors
  } = faqpd1;
  const faqpd47 = document['getElementById'](selectors['widget']);
  if (faqpd47['classList']['contains']('kdaddy--open')) {
      faqpd48()
  } else {
      faqpd45()
  }
}
function faqpd48() {
  const {
      selectors
  } = d;
  const faqpd46 = document['body'];
  const faqpd47 = document['getElementById'](selectors['widget']);
  faqpd47['classList']['remove']('kdaddy--open');
  faqpd47['classList']['remove']('kdaddy--forceopen');
  faqpd46['classList']['remove']('kdaddy-overlay')
}
function faqpd49() {
  const {
      shop,
      selectors
  } = d;
  const faqpd4a = document['getElementById'](selectors['greeting']);
  if (faqpd4a !== null) {
      faqpd4a['classList']['remove']('kdaddy-greeting--open');
      setTimeout(function() {
          faqpd4a['remove']()
      }, 200);
      faqpd12(`${'kdaddy_greeting-'}${shop}${''}`, '1')
  }
}
function faqpd12(faqpd11, faqpd13) {
  window['sessionStorage']['setItem'](faqpd11, faqpd13)
}

function faqpd58() {
  const {
      selectors
  } = d;
  const faqpd47 = document['getElementById'](selectors['widget']);
  faqpd47['classList']['add']('kdaddy-search--open');
  faqpd47['querySelector']('.kdaddy-search-input')['focus']()
}
function faqpd59() {
  const {
      selectors
  } = d;
  const faqpd47 = document['getElementById'](selectors['widget']);
  faqpd47['classList']['add']('kdaddy-search--close');
  faqpd47['classList']['remove']('kdaddy-search--open');
  let el1= document.querySelector('.kdaddy-category--active')
  let el2 = document.querySelector('#kdaddy-category');
  if(el1==null){
    let el = document.querySelector('#kdaddy-dashboard')
    el.style.opacity=1;
    el2.style.opacity=0;
    let art_id=document.querySelector('#kdaddy-article');
    art_id.style.opacity=0;
  }
  setTimeout(function() {
      faqpd47['querySelector']('.kdaddy-search-input')['value'] = '';
      faqpd47['classList']['remove']('kdaddy-search--close')
  }, 200)
}
function faqpd63(faqpd3d, faqpd11, faqpd5d, faqpd64) {
  const {
      selectors,
      settings: {
          faq_blocks
      }
  } = d;
  const faqpd37 = faq_blocks[faqpd11];
  if (typeof faqpd37 === 'undefined') {
      return false
  };
  const {
    blocks_faq: blocks_child
  } = faqpd37;

  const faqpd65 = blocks_child[faqpd3d];
  //console.log(faqpd65)
  if (typeof faqpd65 === 'undefined') {
      return false
  };
  const faqpd5c = {
      title: faqpd65['question'],
      caption: {
          title: faqpd37['title'],
          id: faqpd11
      },
      search: faqpd5d,
      back: faqpd64
  };
  if (faqpd64 === 'category') {
      faqpd5c['category'] = faqpd11
  };
  let faqpd66 = faqpd65['answer'];
  if (typeof faqpd65['image'] !== 'undefined') {
      const {
          image
      } = faqpd65;
      if (image['enabled'] === '1' && image['src']['length'] > 0) {
          if (image['position'] === 'top') {
              faqpd66 = `${'<figure class="kdaddy-image kdaddy-image--top"><img src="'}${image['src']}${'"/></figure>'}` + faqpd66
          } else {
              faqpd66 = faqpd66 + `${'<figure class="kdaddy-image kdaddy-image--bottom"><img src="'}${image['src']}${'"/></figure>'}`
          }
      }
  };
  if (typeof faqpd65['video'] !== 'undefined') {
      const {
          video
      } = faqpd65;
      if (video['enabled'] === '1' && video['src']['length'] > 0) {
          let faqpd67;
          if (video['type'] === 'youtube') {
              faqpd67 = `${'<iframe src="//www.youtube.com/embed/'}${faqpd1d(video['src'])}${'" frameborder="0" allowfullscreen></iframe>'}`
          } else {
              faqpd67 = `${'<iframe src="//player.vimeo.com/video/'}${faqpd20(video['src'])}${'?byline=0&portrait=0" frameborder="0" allowfullscreen></iframe>'}`
          };
          if (video['position'] === 'top') {
              faqpd66 = `${'<div class="kdaddy-video kdaddy-video--top">'}${faqpd67}${'</div>'}` + faqpd66
          } else {
              faqpd66 = faqpd66 + `${'<div class="kdaddy-video kdaddy-video--bottom">'}${faqpd67}${'</div>'}`
          }
      }
  };
  const faqpd68 = document['getElementById'](selectors['article']);

  faqpd68['innerHTML'] = `${''}${faqpd5f(faqpd5c)}${'<div class="kdaddy-answer">'}${faqpd66}${'</div>'}`;
  const faqpd47 = document['getElementById'](selectors['widget']);
  faqpd47['classList']['remove']('kdaddy-dashboard--active'), faqpd47['classList']['remove']('kdaddy-category--active'), faqpd47['classList']['remove']('kdaddy-article--active'), faqpd47['classList']['remove']('kdaddy-search--active');
  faqpd47['classList']['add']('kdaddy-article--active')
  let art_node = document.querySelector('.kdaddy-article--active')
  let art_id=document.querySelector('#kdaddy-article');
    art_id.style.opacity=1;
  if(art_node!==null){
    let el2 = document.querySelector('#kdaddy-category');
    el2.style.opacity=0;
    let el = document.querySelector('#kdaddy-dashboard')
    el.style.opacity=0;
  }else{
    
  }
}


    // new code ends here

    return {
      init: function () {
         
      
        (function (e, a) {
          for (var t = 0; t < document.styleSheets.length; t++)
            if (document.styleSheets[t].href == e) return;
          var n = document.getElementsByTagName("head")[0],
            r = document.createElement("link");

          (r.rel = "stylesheet"),
            (r.type = "text/css"),
            (r.href = e),
            a &&
              (r.onload = function () {
                a();
               
              }),
            n.appendChild(r);
        })(d.cssUrl),
          window == window.top &&
            e().then(function (e) {
              e && (

                   v(),
                   T(),
                   C(),
                    j()
                   );
            });
            
          H();
         setTimeout(()=>{
	if (d.settings.style.customized.faq_yn === "1" && d.settings.style.customized.faq_yn !== undefined) {
 
      faqpd69()
	}

         },1200)
        
      },
    
    
    };
  
  })()),
  wwhatsappJs.WhatsApp.init();

